import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Container, Divider, Dropdown, Grid, Icon, Image, Item, Label, List, Loader, Menu, Modal, Popup, Segment, Statistic, Step, Table } from 'semantic-ui-react';
import ReactLangSelect from './components/LangSelect';
//import ReactTimezoneSelect from './components/TimezoneSelect';
import { PieChart } from 'react-minimal-pie-chart';
//import { scrollIntoView } from "seamless-scroll-polyfill";
import { YouTubeEmbed, XEmbed, FacebookEmbed, TikTokEmbed, InstagramEmbed } from 'react-social-media-embed';
import Encryption from './constants/Encryption';
import queryString from 'query-string';

import * as Global from './constants/Global';

import 'semantic-ui-css/semantic.min.css';
import './css/index.css';
import './css/App.css';
import './css/AgoneusLive.css';

import moment from 'moment-timezone';
import "moment/locale/fr";
import "moment/locale/mt";
import "moment/locale/pt";

class App extends Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    const parsed = queryString.parse(window.location.search);
    this.directOrg = parsed.org ? parsed.org : null;
    this.directL1 = parsed.l1 ? parsed.l1 : null;
    this.directL2 = parsed.l2 ? parsed.l2 : null;
    this.directL3 = parsed.l3 ? parsed.l3 : null;
    this.directL4 = parsed.l4 ? parsed.l4 : null;
    this.directEvent = parsed.event ? parsed.event : null;
    this.directCateg = parsed.categ ? parsed.categ : null;
    //this.tznames = moment.tz.names();
    const tz = moment.tz.guess(true);
    moment.locale(this.props.t("locale"));
    this.state = {
      running: true,
      error: '',
      currentOrg: null,
      currentL1: { code: 0 },
      currentL2: { code: 0 },
      currentL3: { code: 0 },
      currentL4: { code: 0 },
      allDates: [],
      currentTab: 1,
      currentSaison: null,
      currentEvent: null,
      currentCateg: null,
      currentGroup: null,
      rankings: null,
      shootout: [],
      grpDetail: [],
      currentTimezone: tz + " (" + moment.tz(tz).format('Z z') + ")",
      currentCountries: [],
      currentMonth: moment(),
      searchName: '',
      showModal: {
        open: false
      },
      showLostPassword: false,
      showGroupPlayers: false,
      showGroupTable: true,
      showVideo: null,
      login: '',
      password: '',
      logged: false,
      testMode: this.getTestMode(),
      wsQueue: [],
      onlyOneEvent: this.directEvent ? true : false
    }
    this.tagPhase = [];
    this.tagGroup = [];
    this.componentRefresh = this.componentRefresh.bind(this);
    this.setCurrentTab = this.setCurrentTab.bind(this);
    this.setCurrentEvent = this.setCurrentEvent.bind(this);
    this.showGroupTable = this.showGroupTable.bind(this);
    this.showGroupPlayers = this.showGroupPlayers.bind(this);
    this.swapVideo = this.swapVideo.bind(this);
    this.wsOpen = this.wsOpen.bind(this);
    this.wsClose = this.wsClose.bind(this);
    this.wsSend = this.wsSend.bind(this);
    this.wsReceive = this.wsReceive.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    window.scrollTo(0, 0);
    this.wsOpen();
    document.addEventListener('visibilitychange', this.componentRefresh);
    this.pingTimer = setInterval(() => {
      this.wsSend("act=ping");
    }, 45000);
    this.fetchOrgs();
  }

  componentDidUpdate(prevprop, prevstate) {
    let haschanged = false;
    if (!this.state.tables || this.state.tables.message) return;
    if (!this.checkAnimate) return;
    this.state.tables.forEach(newtable => {
      newtable.cf1 = 0;
      newtable.cf2 = 0;
      newtable.sets.forEach(s => { newtable.cf1 += Number(s.cf1); newtable.cf2 += Number(s.cf2) });
      let oldtable = null;
      if (prevstate.tables && !prevstate.tables.message) {
        oldtable = prevstate.tables.find(t => t.c === newtable.c && t.p === newtable.p && t.g === newtable.g && t.s === newtable.s && t.r === newtable.r);
      }
      if (oldtable) {
        let oldcf1 = 0;
        let oldcf2 = 0;
        oldtable.sets.forEach(s => { oldcf1 += Number(s.cf1); oldcf2 += Number(s.cf2) });
        newtable.animate1 = false;
        newtable.animate2 = false;
        if (newtable.st1 !== oldtable.st1 || Number(newtable.cf1) !== oldcf1) {
          newtable.animate1 = true;
          haschanged = true;
        }
        if (newtable.st2 !== oldtable.st2 || Number(newtable.cf2) !== oldcf2) {
          newtable.animate2 = true;
          haschanged = true;
        }
        newtable.sets.forEach((newset, s) => {
          newset.animate1 = false;
          newset.animate2 = false;
          const oldset = oldtable.sets.find(o => Number(o.set) === Number(newset.set));
          if (oldset) {
            if (newset.sc1 !== oldset.sc1 || Number(newset.cf1) !== Number(oldset.cf1)) {
              newset.animate1 = true;
              haschanged = true;
            }
            if (newset.sc2 !== oldset.sc2 || Number(newset.cf2) !== Number(oldset.cf2)) {
              newset.animate2 = true;
              haschanged = true;
            }
          }
          if (newset.frms) {
            newset.frms.forEach(newframe => {
              const oldframe = oldset && oldset.frms && oldset.frms.find(t => t.frm === newframe.frm);
              newframe.animate1 = false;
              newframe.animate2 = false;
              if (oldframe) {
                if (newframe.sc1 !== oldframe.sc1 || newframe.cf1 !== oldframe.cf1) {
                  newframe.animate1 = true;
                  haschanged = true;
                }
                if (newframe.sc2 !== oldframe.sc2 || newframe.cf2 !== oldframe.cf2) {
                  newframe.animate2 = true;
                  haschanged = true;
                }
              }
            });
          }
        })
      }
    });
    if (haschanged) {
      this.setState({
        tables: this.state.tables
      });
    }
    this.checkAnimate = false;
  }

  componentRefresh() {
    let { currentEvent, currentCateg } = this.state;
    if (document.visibilityState === 'visible') {
      // La page redevient visible (après déverrouillage, retour d'une autre app, etc.)
      if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
        this.wsOpen();
        if (currentEvent && currentCateg) {
          this.wsSend("ident=LS&event=" + currentEvent.code/* + "&user=" + user.email*/);
        }
      }
      if (currentEvent && currentCateg) {
        this.refreshTables();
      }
    }
  }

  componentWillUnmount() {
    if (this.pingTimer) {
      clearInterval(this.pingTimer);
      this.pingTimer = null;
    }
    this.wsClose();
    document.removeEventListener('visibilitychange', this.componentRefresh);
    this._isMounted = false;
  }

  async checkAllEvents(allDates, swapTab = false) {
    const { t } = this.props;
    let { currentEvent, currentTab, onlyOneEvent, parms, testMode } = this.state;
    //Ajout des flyers
    if (parms && parms.length > 0) {
      let modified = false;
      allDates.filter((e) => Number(e.flys) > 0).forEach((e) => {
        const nbFlyers = Number(e.flys);
        for (let i = 1; i <= nbFlyers; i++) {
          if (parms.findIndex(p => Number(p.event) === Number(e.code) && Number(p.categ) === -i) >= 0) return;
          parms.push({
            event: e.code,
            categ: -i,
            enabled: "1",
            hide: "999",
            name: t('flyer') + " #" + i,
            nbTables: "1",
            parm: "",
            winner: ""
          });
        }
      });
      if (modified) {
        this.setState({ parms });
      }
    }
    let archives = null;
    let lives = null;
    let nexts = null;
    const init = { key: 0, text: t('selectevent'), value: 0 };
    let archiveOptions = [init];
    let liveOptions = [init];
    let nextOptions = [init];
    if (allDates && allDates.length > 0) {
      archives = allDates.filter((e) => {
        return e.state === "C";
      });
      archives.forEach((e) => {
        archiveOptions.push({
          key: e.code,
          text: Global.getHtmlString(e.name),
          value: e.code
        })
      })
      lives = allDates.filter((e) => {
        return e.isLive && (testMode || e.state !== "D");
      });
      if (swapTab && (lives.length === 0 || (onlyOneEvent && !lives.find(l => Number(l.code) === Number(this.directEvent)))) && currentTab === 0) {
        currentTab = 1;
      }
      /*if (lives.length > 1) {
        liveOptions.push({
          key: '*',
          text: t('allevents'),
          value: '*'
        })
      }*/
      lives.forEach((e) => {
        if (e.state !== "P" && !testMode) return;
        liveOptions.push({
          key: e.code,
          text: Global.getHtmlString(e.name),
          value: e.code
        })
      })
      if (liveOptions.length === 1) {
        liveOptions = [];
      }
      nexts = allDates.filter((e) => {
        return (e.state === "P" || ((e.state === "D" || e.state === "T") && testMode));
      });
      nexts.forEach((e) => {
        nextOptions.push({
          key: e.code,
          text: Global.getHtmlString(e.name),
          value: e.code
        })
      })
    }
    if (!currentEvent) {
      if (this.directEvent) {
        const directEvent = allDates.find(e => Number(e.code) === Number(this.directEvent));
        if (directEvent) {
          this.setCurrentEvent(directEvent.code, allDates);
        }
      } else {
        if (onlyOneEvent) {
          this.setCurrentEvent(Number(this.directEvent), allDates);
        } else {
          if (currentTab === 0 && lives && lives.length === 1) {
            this.setCurrentEvent(lives[0].code, allDates);
          }
          if (currentTab === 1 && nexts && nexts.length === 1) {
            this.setCurrentEvent(nexts[0].code, allDates);
          }
          /*if (currentTab === 2 && archives && archives.length === 1) {
            this.setCurrentEvent(archives[0].code, allDates);
          }*/
        }
      }
    }
    this.setState({
      archives,
      lives,
      nexts,
      archiveOptions,
      liveOptions,
      nextOptions,
      currentTab
    });
  }

  checkCategs(parms, lives) {
    const { t } = this.props;
    let { categs, currentEvent, currentCateg, currentPhase, currentGroup, currentTab } = this.state;
    if (!parms || !currentEvent) return;
    const init = { key: 0, text: t('selectcateg'), value: 0, type: "Z" };
    const initLive = { key: 0, text: t('allcategories'), value: 0, type: "Z" };
    let categOptions = [];
    let categOptionsLive = [];
    parms.filter(p => Number(p.event) === Number(currentEvent.code)).forEach((p) => {
      if (Number(p.enabled) === 1) {
        const categ = categs.find(c => Number(c.code) === Number(p.categ));
        const isLive = lives.findIndex(l => l.event === currentEvent.code && l.categ === p.categ) >= 0;
        let itemtext = Global.replaceParm(p.name, p.parm);
        let text = itemtext;
        if (isLive) {
          text = <div><span className="hall-categ-live-dot" style={{ marginLeft: 0, marginRight: '.5rem' }}>●</span>{itemtext}<span className="hall-categ-live-dot">●</span></div>;
        }
        const item = { key: p.categ, text: text, itemtext, value: p.categ, ordre: p.ordre, type: categ ? categ.type : "S" };
        categOptions.push(item);
        if (isLive) categOptionsLive.push(item);
      }
    })
    categOptions.sort(function (a, b) {
      if (a.ordre < b.ordre) return -1;
      if (a.ordre > b.ordre) return 1;
      if (a.type > b.type) return -1;
      if (a.type < b.type) return 1;
      return a.itemtext.localeCompare(b.itemtext);
    })
    categOptionsLive.sort(function (a, b) {
      if (a.ordre < b.ordre) return -1;
      if (a.ordre > b.ordre) return 1;
      if (a.type > b.type) return -1;
      if (a.type < b.type) return 1;
      return a.itemtext.localeCompare(b.itemtext);
    })
    categOptions.splice(0, 0, init);
    categOptionsLive.splice(0, 0, initLive);
    if (this.directCateg) {
      const directCateg = categOptions.find(c => Number(c.key) === Number(this.directCateg));
      if (directCateg) {
        this.setCurrentCateg(directCateg.key, null, null);
      }
    } else {
      if (currentTab === 0) {
        if (!currentCateg) {
          this.setCurrentCateg(categOptionsLive[0].key, null, null);
        }
        if (categOptions.length === 2) {
          const key = categOptions.find(c => Number(c.key) !== 0).key;
          this.setCurrentCateg(key, currentPhase ? currentPhase.code : null, currentGroup);
        }
      } else {
        if (categOptions.length === 2) {
          const key = categOptions.find(c => Number(c.key) !== 0).key;
          this.setCurrentCateg(key, currentPhase ? currentPhase.code : null, currentGroup);
        }
      }
    }
    this.setState({
      categOptions,
      categOptionsLive
    });
  }

  async fetchAllEvents(lives, swapTab = false) {
    let { currentOrg, currentL1, currentL2, currentL3, currentL4, currentSaison } = this.state;
    let url = Global.localUrl + 'api/admin/readalldates.php?org=' + currentOrg.code + '&l1=' + currentL1.code + '&l2=' + currentL2.code + '&l3=' + currentL3.code + '&l4=' + currentL4.code + '&saison=' + currentSaison.saison;
    return fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        let allDates = [];
        if (!responseJson.error) {
          allDates = this.sortEvents(responseJson, lives);
          this.setState({
            error: '',
            allDates,
            isLoading: false
          });
        } else {
          this.setState({
            allDates,
            isLoading: false
          });
        }
        this.checkAllEvents(allDates, swapTab);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchAllRankings() {
    let { currentL1, currentL2, currentL3, currentL4, currentOrg, currentSaison } = this.state;
    return fetch(Global.localUrl + 'api/admin/readrankings.php?org=' + currentOrg.code + '&l1=' + currentL1.code + '&l2=' + currentL2.code + '&l3=' + currentL3.code + '&l4=' + currentL4.code + '&saison=' + currentSaison.saison)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this.setState({
            error: '',
            allRankings: Global.implode(responseJson)
          }, () => {
            let events = [];
            this.state.allRankings.forEach(rnk => {
              rnk.events.forEach(evt => {
                if (events.findIndex(e => e.code === evt.event) < 0) {
                  events.push({ code: evt.event });
                }
              })
            });
            this.fetchRankings(events[0].code);
          });
        } else {
          this.setState({
            allRankings: [],
            error: responseJson.error
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchPlayer(code) {
    return fetch(Global.localUrl + 'api/joueur/read.php?code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchTeam(code) {
    return fetch(Global.localUrl + 'api/delegate/readteam.php?code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchStats(code) {
    return fetch(Global.localUrl + 'api/tournament/readstats.php?code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchCateg(categ) {
    if (Number(categ.code) < 0) {
      return this.fetchFlyerCateg(categ);
    }
    return fetch(Global.localUrl + 'api/category/readone.php?code=' + categ.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchCategs(saison, updateState = true) {
    let { currentOrg, currentL1, currentL2, currentL3, currentL4, currentSaison } = this.state;
    if (!saison) {
      saison = currentSaison.saison;
    }
    let url = Global.localUrl + 'api/category/readall.php?org=' + currentOrg.code + '&l1=' + currentL1.code + '&l2=' + currentL2.code + '&l3=' + currentL3.code + '&l4=' + currentL4.code + '&saison=' + saison;
    return fetch(url)
      .then((response) => response.json())
      .then((responseJson) => {
        let categs = [];
        if (!responseJson.error) {
          categs = responseJson;
          updateState && this._isMounted && this.setState({
            error: '',
            categs
          });
        } else {
          updateState && this._isMounted && this.setState({
            categs: []
          });
        }
        return categs;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchDates() {
    const { currentEvent } = this.state;
    return fetch(Global.localUrl + 'api/admin/readdates.php?code=' + currentEvent.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this.setState({
            error: '',
            dates: responseJson
          })
        } else {
          this.setState({
            error: responseJson.error
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchOrgs() {
    return fetch(Global.localUrl + 'api/admin/readorgs.php')
      .then((response) => response.json())
      .then((responseJson) => {
        let orgs = null;
        if (!responseJson.error) {
          orgs = responseJson;
          this._isMounted && this.setState({
            error: '',
            orgs
          }, () => {
            if (this.directOrg) {
              const directOrg = orgs.find(o => Number(o.code) === Number(this.directOrg));
              if (directOrg) {
                this.setOrg(directOrg);
              }
            } else {
              const currentOrg = orgs.find(o => Number(o.code) === 3);
              this.setOrg(currentOrg);
            }
          });
        } else {
          this._isMounted && this.setState({
            orgs: null
          });
        }
      })
      .catch((error) => {
        this._isMounted && this.setState({
          error: error
        });
        console.error(error);
      });
  }

  async fetchFlyerCateg(categ) {
    let { currentEvent } = this.state;
    return fetch(Global.localUrl + 'api/category/readflyercateg.php?event=' + currentEvent.code + '&code=' + categ.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchLiveEvents() {
    return fetch(Global.localUrl + 'api/live/readlives.php')
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.message) {
          this.setState({
            allLives: []
          });
          return [];
        } else {
          this.setState({
            error: '',
            allLives: responseJson
          });
          return responseJson;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchModel(org) {
    return fetch(Global.localUrl + 'api/admin/readlevels.php?org=' + org.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          org.level1 = responseJson;
          let currentL1 = { code: 0 };
          let currentL2 = { code: 0 };
          let currentL3 = { code: 0 };
          let currentL4 = { code: 0 };
          if (Number(this.directL1) > 0) {
            currentL1 = org.level1.find(l => l.code === Number(this.directL1));
            if (currentL1 && Number(this.directL2) > 0) {
              currentL2 = currentL1.level2.find(l => l.code === Number(this.directL2));
              if (currentL2 && Number(this.directL3) > 0) {
                currentL3 = currentL2.level3.find(l => l.code === Number(this.directL3));
                if (currentL3 && Number(this.directL4) > 0) {
                  currentL4 = currentL3.level4.find(l => l.code === Number(this.directL4));
                }
              }
            }
          }
          this._isMounted && this.setState({
            error: '',
            currentOrg: org,
            currentL1,
            currentL2,
            currentL3,
            currentL4
          });
        } else {
          org.level1 = [];
          this._isMounted && this.setState({
            error: responseJson.error,
            currentOrg: org
          });
        }
        return org;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchPlayerNext(code) {
    let { currentEvent } = this.state;
    if (!currentEvent) return null;
    return fetch(Global.localUrl + 'api/tournament/readplayernext.php?event=' + currentEvent.code + '&code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchParms() {
    let { categs, currentEvent } = this.state;
    return fetch(Global.localUrl + 'api/tournament/readparms.php?event=' + currentEvent.code)
      .then((response) => response.json())
      .then((responseJson) => {
        let parms = [];
        if (!responseJson.error) {
          const selcategs = responseJson.filter(p => Number(p.enabled) === 1);
          //On récupère les flyers
          selcategs.filter(p => Number(p.categ) < 0).forEach(async p => {
            let cidx = categs.findIndex(c => Number(c.code) === Number(p.categ));
            let categ = categs[cidx];
            if (categ && (!categ.phases || categ.phases.length === 0)) {
              categs[cidx] = await this.fetchFlyerCateg(categ);
            }
          });
          let currentCateg = selcategs.length === 1 ? categs.find(c => Number(c.code) === Number(selcategs[0].categ)) : null;
          parms = responseJson;
          this.setState({
            error: '',
            categs,
            parms,
            currentCateg
          }, () => {
            if (currentCateg) {
              this.refreshTables();
            }
          });
          return parms;
        } else {
          this.setState({
            error: responseJson.error,
            parms
          });
          return parms;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchPlayerShootout(code) {
    return fetch(Global.localUrl + 'api/tournament/readplayershootout.php?code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchRanking(ranking, live) {
    let { allDates, currentOrg } = this.state;
    let prm = "";
    ranking.events.forEach((e) => {
      const evt = allDates.find(d => d.code === Number(e.event));
      if (live === 0 || (evt && evt.state === "C")) {
        prm += "c" + e.categ + "e" + e.event + "_";
      }
    })
    if (prm === "") return [];
    let mode = "";
    //mode = testMode ? "test" : "";
    return fetch(Global.localUrl + 'api/tournament/computeranking' + mode + '.php?org=' + currentOrg.code + '&rnk=' + ranking.code + '&prm=' + prm)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchRankings(event) {
    return fetch(Global.localUrl + 'api/admin/readeventrankings.php?event=' + event)
      .then((response) => response.json())
      .then(async (responseJson) => {
        if (!responseJson.error) {
          responseJson[0].ranking = Global.ifTiedInPoints(responseJson[0], await this.fetchRanking(responseJson[0], 0));
          if (responseJson[0].live === 1) {
            responseJson[0].rankingLive = Global.ifTiedInPoints(responseJson[0], await this.fetchRanking(responseJson[0], 1));
          }
          this.setState({
            error: '',
            rankings: responseJson
          })
        } else {
          this.setState({
            error: responseJson.error
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchSaisons() {
    let { currentOrg } = this.state;
    return fetch(Global.localUrl + 'api/admin/readsaisons.php?org=' + currentOrg.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson
        } else {
          return []
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchShootout() {
    let { currentEvent } = this.state;
    if (!currentEvent) return;
    return fetch(Global.localUrl + 'api/tournament/readshootout.php?event=' + currentEvent.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this.setState({
            error: '',
            shootout: responseJson
          });
        } else {
          this.setState({
            shootout: []
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchSingleEntries() {
    let { currentCateg, currentEvent } = this.state;
    return fetch(Global.localUrl + 'api/tournament/readsingles.php?event=' + currentEvent.code + '&categ=' + currentCateg.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this._isMounted && this.setState({
            error: ''
          });
          return responseJson;
        } else {
          this._isMounted && this.setState({
            error: responseJson.error
          });
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  fetchSponsors() {
    const { currentEvent } = this.state;
    fetch(Global.localUrl + 'api/admin/readeventsponsors.php?event=' + currentEvent.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this.setState({
            error: '',
            sponsors: responseJson,
            allCategSponsors: responseJson.filter(s => Number(s.categ) === 0)
          })
        } else {
          this.setState({
            error: responseJson.error,
            sponsors: [],
            allCategSponsors: []
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchTeamEntries() {
    let { currentCateg, currentEvent } = this.state;
    return fetch(Global.localUrl + 'api/tournament/readteams.php?event=' + currentEvent.code + '&categ=' + currentCateg.code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          this._isMounted && this.setState({
            error: ''
          });
          return responseJson;
        } else {
          this._isMounted && this.setState({
            error: responseJson.error
          });
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async fetchTeamNext(code) {
    let { currentEvent } = this.state;
    if (!currentEvent) return null;
    return fetch(Global.localUrl + 'api/tournament/readteamnext.php?event=' + currentEvent.code + '&code=' + code)
      .then((response) => response.json())
      .then((responseJson) => {
        if (!responseJson.error) {
          return responseJson;
        } else {
          return null;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  formatFrames(match, frms) {
    if (!frms || frms.length === 0) return [];
    return frms.map((f, fidx) => {
      let p11 = null;
      if (f.t1j1 > 0) p11 = match.tm1.find(p => p.i === f.t1j1);
      let p12 = null;
      if (f.t1j2 > 0) p12 = match.tm1.find(p => p.i === f.t1j2);
      let p21 = null;
      if (f.t2j1 > 0) p21 = match.tm2.find(p => p.i === f.t2j1);
      let p22 = null;
      if (f.t2j2 > 0) p22 = match.tm2.find(p => p.i === f.t2j2);
      return {
        frm: f.frm,
        t1j1: f.t1j1,
        t1n1: p11 ? p11.n : "",
        t1p1: p11 ? p11.p : "",
        t1c1: p11 ? p11.c : "",
        t1j2: f.t1j2,
        t1n2: p12 ? p12.n : "",
        t1p2: p12 ? p12.p : "",
        t1c2: p12 ? p12.c : "",
        t2j1: f.t2j1,
        t2n1: p21 ? p21.n : "",
        t2p1: p21 ? p21.p : "",
        t2c1: p21 ? p21.c : "",
        t2j2: f.t2j2,
        t2n2: p22 ? p22.n : "",
        t2p2: p22 ? p22.p : "",
        t2c2: p22 ? p22.c : "",
        st: f.st,
        cs: f.cs,
        sc1: f.sc1,
        sc2: f.sc2,
        cf1: f.cf1,
        cf2: f.cf2,
        t: f.t
      }
    });
  }

  getCategLabel(categ) {
    const { parms } = this.state;
    let label = "";
    const parm = parms.find(p => Number(p.categ) === Number(categ.code));
    if (parm) {
      label = Global.replaceParm(categ.name, parm.parm);
    }
    return label;
  }

  getLocalDate(time, format = "LL") {
    const { currentTimezone } = this.state;
    const uk = moment.tz(time, "Europe/Paris");
    const tz = currentTimezone.split(" ")[0];
    return moment.tz(uk, tz).format(format);
  }

  getLocalTime(time) {
    const { currentTimezone } = this.state;
    const uk = moment.tz(time, "Europe/Paris");
    const tz = currentTimezone.split(" ")[0];
    return moment.tz(uk, tz).format('HH:mm');
  }

  getMatchInfo(match, teamMatch, isDouble) {
    let info = {};
    info.t1j1 = match.t1j1;
    info.t1j2 = match.t1j2;
    info.t2j1 = match.t2j1;
    info.t2j2 = match.t2j2;
    info.t1n1 = match.t1n1;
    info.t1n2 = match.t1n2;
    info.t2n1 = match.t2n1;
    info.t2n2 = match.t2n2;
    info.t1p1 = match.t1p1;
    info.t1p2 = match.t1p2;
    info.t2p1 = match.t2p1;
    info.t2p2 = match.t2p2;
    info.t1c1 = match.t1c1;
    info.t1c2 = match.t1c2;
    info.t2c1 = match.t2c1;
    info.t2c2 = match.t2c2;
    if (isDouble && teamMatch) {
      if (match.tm1.length === 2) {
        info.t1j1 = match.tm1[0].i;
        info.t1j2 = match.tm1[1].i;
        info.t1n1 = match.tm1[0].n;
        info.t1n2 = match.tm1[1].n;
        info.t1p1 = match.tm1[0].p;
        info.t1p2 = match.tm1[1].p;
        info.t1c1 = match.tm1[0].c;
        info.t1c2 = match.tm1[1].c;
      }
      if (match.tm2.length === 2) {
        info.t2j1 = match.tm2[0].i;
        info.t2j2 = match.tm2[1].i;
        info.t2n1 = match.tm2[0].n;
        info.t2n2 = match.tm2[1].n;
        info.t2p1 = match.tm2[0].p;
        info.t2p2 = match.tm2[1].p;
        info.t2c1 = match.tm2[0].c;
        info.t2c2 = match.tm2[1].c;
      }
    }
    return info;
  }

  getTestMode() {
    return window.location.href.includes("localhost") || window.location.href.includes("/test/");
  }

  goFirst() {
    let { currentSaison, allLives, saisons } = this.state;
    const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
    if (idx > 0) {
      currentSaison = saisons[0];
      this.setState({
        currentSaison,
        currentEvent: null,
        currentCateg: null
      }, () => {
        this.fetchCategs();
        this.fetchAllEvents(allLives);
        this.fetchAllRankings();
      })
    }
  }

  goLast() {
    let { currentSaison, allLives, saisons } = this.state;
    const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
    if (idx < saisons.length - 1) {
      currentSaison = saisons[saisons.length - 1];
      this.setState({
        currentSaison,
        currentEvent: null,
        currentCateg: null
      }, () => {
        this.fetchCategs();
        this.fetchAllEvents(allLives);
        this.fetchAllRankings();
      })
    }
  }

  goNext() {
    let { currentSaison, allLives, saisons } = this.state;
    const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
    if (idx < saisons.length - 1) {
      currentSaison = saisons[idx + 1];
      this.setState({
        currentSaison,
        currentEvent: null,
        currentCateg: null
      }, () => {
        this.fetchCategs();
        this.fetchAllEvents(allLives);
        this.fetchAllRankings();
      })
    }
  }

  goPrev() {
    let { currentSaison, allLives, saisons } = this.state;
    const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
    if (idx > 0) {
      currentSaison = saisons[idx - 1];
      this.setState({
        currentSaison,
        currentEvent: null,
        currentCateg: null
      }, () => {
        this.fetchCategs();
        this.fetchAllEvents(allLives);
        this.fetchAllRankings();
      })
    }
  }

  hideCard() {
    this.setState({
      showCard: false
    })
  }

  showCard() {
    this.setState({
      showCard: true
    })
  }

  showGroupPlayers() {
    this.setState({
      showGroupPlayers: true,
      showGroupTable: false
    })
  }

  showGroupTable() {
    this.setState({
      showGroupPlayers: false,
      showGroupTable: true
    })
  }

  hideDetail(teamMatch) {
    if (!teamMatch) return;
    this.setState({
      detail: null
    });
  }

  showDetail(teamMatch, categ, phase, grp, session, rang, set) {
    if (!teamMatch) return;
    this.setState({
      detail: {
        c: categ,
        p: phase,
        g: grp,
        s: session,
        r: rang,
        set: set || 0
      }
    }, () => {
      this.refreshTables();
    });
  }

  async setOrg(org) {
    const { i18n } = this.props;
    await this.fetchModel(org);
    i18n.changeLanguage(org.lang);
    //moment.locale(t("locale"));
    let saison = null;
    this.fetchLiveEvents().then((lives) => {
      this.fetchSaisons().then((saisons) => {
        if (saisons && saisons.length > 0) {
          const today = moment();
          saison = saisons.find(s => today.isSameOrAfter(s.startdate, 'day') && today.isSameOrBefore(s.enddate, 'day'));
        }
        this.setState({
          saisons: saisons,
          currentSaison: saison,
          initialSaison: saison,
          running: false,
          currentTab: 1,
          currentEvent: null,
          currentCateg: null,
          lives
        }, async () => {
          await this.fetchCategs(saison ? saison.saison : null)
            .then(() => {
              this.fetchAllEvents(lives, true);
              this.fetchAllRankings();
              let allDates = this.sortEvents(this.state.allDates, lives);
              this.setState({ allDates });
              this.checkAllEvents(allDates, false);
            })
        })
      });
    })
  }

  nameFound(match, teamMatch) {
    let { currentCateg, searchName } = this.state;
    if (searchName.trim() !== "") {
      if (!match.t1n1.toUpperCase().includes(searchName.trim().toUpperCase()) &&
        !match.t1p1.toUpperCase().includes(searchName.trim().toUpperCase()) &&
        !match.t2n1.toUpperCase().includes(searchName.trim().toUpperCase()) &&
        !match.t2p1.toUpperCase().includes(searchName.trim().toUpperCase()) && !teamMatch) {
        return false;
      }
      if (currentCateg.type === "D") {
        if (!match.t1n2.toUpperCase().includes(searchName.trim().toUpperCase()) &&
          !match.t1p2.toUpperCase().includes(searchName.trim().toUpperCase()) &&
          !match.t2n2.toUpperCase().includes(searchName.trim().toUpperCase()) &&
          !match.t2p2.toUpperCase().includes(searchName.trim().toUpperCase())) {
          return false;
        }
      }
      if (teamMatch) {
        if (match.tm1.findIndex(t1 => t1.n.toUpperCase().includes(searchName.trim().toUpperCase())) < 0 &&
          match.tm1.findIndex(t1 => t1.p.toUpperCase().includes(searchName.trim().toUpperCase())) < 0 &&
          match.tm2.findIndex(t1 => t1.n.toUpperCase().includes(searchName.trim().toUpperCase())) < 0 &&
          match.tm2.findIndex(t1 => t1.p.toUpperCase().includes(searchName.trim().toUpperCase())) < 0) {
          return false;
        }
      }
    }
    return true;
  }

  onChangeLanguage(lang) {
    const { i18n, t } = this.props;
    let { allDates, currentEvent, currentGroup, currentPhase } = this.state;
    i18n.changeLanguage(lang.toLowerCase());
    moment.locale(t("locale"));
    this.checkAllEvents(allDates, false);
    if (currentEvent && Number(currentEvent.code) !== 0) {
      this.setCurrentEvent(currentEvent.code, allDates, currentPhase, currentGroup);
    }
    this.setState({
      currentMonth: moment()
    })
  }

  onChangeTimezone(timezone) {
    this.setState({
      currentTimezone: timezone
    });
  }

  async refreshTables() {
    let { currentCateg, currentEvent, currentGroup, currentTab, onlyOneEvent, parms, shootout } = this.state;
    if (!currentEvent || (!currentCateg && currentTab > 0)) return;
    //if (!currentEvent || !currentCateg) return;
    let req = "";
    let hasGrps = false;
    if (currentTab === 0 && Number(currentCateg) === 0) {
      req = Global.localUrl + 'api/live/readalllives.php?event=' + currentEvent.code;
    } else {
      hasGrps = currentCateg.phases.findIndex(p => Number(p.nbGrps) > 1) >= 0;
      const team = currentCateg.type === "T" ? "team" : "";
      req = Global.localUrl + 'api/live/readall' + team + 'scores.php?event=' + currentEvent.code + '&categ=' + currentCateg.code + '&tbc=' + currentCateg.tbc;
    }
    let tables = [];
    return fetch(req)
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.message) {
          this.setState({
            isLoading: false,
            tables,
            countries: []
          }, async () => {
            if (Number(currentCateg) !== 0) {
              if (currentCateg.type === "T") {
                currentCateg.entries = await this.fetchTeamEntries();
              } else {
                currentCateg.entries = await this.fetchSingleEntries();
              }
              this.setState({
                currentCateg
              })
            }
          })
        } else {
          this.checkAnimate = true;
          const unique11 = [...new Set(responseJson.map(item => item.t1c1))];
          const unique21 = [...new Set(responseJson.map(item => item.t2c1))];
          const unique = [...new Set(unique11.concat(unique21).map(item => item))];
          tables = responseJson;
          this.setState({
            isLoading: false,
            tables,
            countries: unique
          }, async () => {
            if (hasGrps && !onlyOneEvent) {
              await this.fetchShootout();
            }
            //TODO this.checkPhases();
            if (Number(currentCateg) !== 0) {
              this.setState({
                ctgs: Global.computeRanking(currentCateg, parms, shootout, tables)
              })
              if (currentTab === 0) {
                const firstLive = tables && tables.find(t => t.ms && !t.me);
                if (firstLive) {
                  const phase = currentCateg.phases[Number(firstLive.p)];
                  let grp = 0;
                  if (Number(phase.nbGrps) > 1 && !currentGroup) {
                    grp = Number(firstLive.g);
                    this.setState({
                      currentPhase: phase,
                      currentGroup: grp
                    })
                  }
                }
              }
            }
          })
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  resetSearch() {
    this.setState({
      searchName: ""
    })
  }

  scrollToPhase(phase) {
    if (this.tagPhase && this.tagPhase[phase]) {
      setTimeout(() => {
        //scrollIntoView(this.tagPhase[phase], { behavior: "auto", block: "start" });
        this.tagPhase[phase].scrollIntoView({
          behavior: "auto",
          block: "start",
        });
      }, 100);
    }
  }

  setCalendarEvent(event) {
    let { allDates } = this.state;
    if (event.state === "D" || event.state === "T") return;
    const phase = event.date.phase ? event.categ.phases[Number(event.date.phase)] : null;
    const grp = event.date.grp ? Number(event.date.grp) : null;
    this.setCurrentEvent(event.event, allDates, phase, grp);
  }

  async setCurrentCateg(code, phase, grp) {
    let { categs, currentCateg, currentGroup, currentPhase, currentTab } = this.state;
    if (currentCateg && Number(currentCateg) !== 0 && Number(currentCateg.code) === Number(code) &&
      currentPhase && Number(currentPhase.code) === Number(phase) &&
      currentGroup && currentGroup === grp) return;
    if (Number(code) === 0 && currentTab !== 0) {
      this._isMounted && this.setState({
        currentCateg: null,
        currentPhase: null,
        currentGroup: null,
        tables: null,
        grpDetail: []
      })
      return;
    }
    if (Number(code) === 0 && currentTab === 0) {
      this._isMounted && this.setState({
        currentCateg: code,
        currentPhase: null,
        currentGroup: null,
        tables: null,
        grpDetail: []
      }, () => {
        this.refreshTables();
      })
      return;
    }
    let categ = categs.find(c => Number(c.code) === Number(code));
    if (categ) {
      await this.fetchCateg(categ)
        .then((c) => {
          if (c) {
            categ = c;
            categ.phases.forEach(p => {
              p.show = Number(p.autohide) === 1 ? null : true;
            })
            grp = grp || 0;
            //phase = phase ? categ.phases[phase] : categ.phases[0];
            this._isMounted && this.setState({
              categs,
              currentCateg: categ,
              currentPhase: null,
              currentGroup: null,
              grpDetail: [],
              currentCountries: []
            }, () => {
              this.refreshTables();
            });
          }
        })
    }
  }

  setCurrentEvent(code, allDates, phase, grp) {
    let { currentTab, onlyOneEvent } = this.state;
    if (Number(code) === 0) {
      this._isMounted && this.setState({
        currentEvent: null,
        currentCateg: null,
        currentPhase: null,
        currentGroup: null,
        parms: null,
        ctgs: null,
        shootout: [],
        rankings: null,
        tables: null
      })
      return;
    }
    let event = allDates.find(e => e.code === code);
    this._isMounted && this.setState({
      currentEvent: event,
      currentCateg: currentTab === 0 ? 0 : null,
      currentPhase: phase || null,
      currentGroup: grp || null,
      parms: null,
      ctgs: null,
      shootout: [],
      rankings: null,
      tables: null,
      currentTimezone: event.tz + " (" + moment.tz(event.tz).format('Z z') + ")"
    }, async () => {
      this.fetchDates();
      if (!onlyOneEvent) this.fetchShootout();
      //TODO this.fetchRankings(e.value);
      this.fetchSponsors();
      const [parms, lives] = await Promise.all([this.fetchParms(), this.fetchLiveEvents()]);
      this.fetchAllEvents(lives, false);
      let allDates = this.sortEvents(this.state.allDates, lives);
      this.setState({ allDates });
      this.checkAllEvents(allDates, false);
      this.checkCategs(parms, lives);
      this.wsSend("ident=LS&event=" + event.code/* + "&user=" + user.email*/);
    })
  }

  setCurrentGroup(index) {
    let { currentGroup } = this.state;
    if (currentGroup === index) return;
    this.setState({
      currentGroup: index
    })
  }

  setCurrentMonth(sens) {
    let { allLives, currentMonth, currentSaison, saisons } = this.state;
    if (sens === "+") {
      currentMonth = currentMonth.add(1, "month");
    } else {
      currentMonth = currentMonth.subtract(1, "month");
    }
    let saisonChanged = false;
    if (currentMonth.isBefore(moment(currentSaison.startdate))) {
      const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
      if (idx > 0) {
        currentSaison = saisons[idx - 1];
        currentMonth = moment(currentSaison.enddate).startOf("month");
        saisonChanged = true;
      } else {
        currentMonth = moment(currentSaison.startdate).startOf("month");
      }
    }
    if (currentMonth.isAfter(moment(currentSaison.enddate))) {
      const idx = saisons.findIndex(s => s.saison === currentSaison.saison);
      if (idx < saisons.length - 1) {
        currentSaison = saisons[idx + 1];
        currentMonth = moment(currentSaison.startdate).startOf("month");
        saisonChanged = true;
      } else {
        currentMonth = moment(currentSaison.enddate).startOf("month");
      }
    }
    if (saisonChanged) {
      this.setState({
        currentSaison,
        currentEvent: null,
        currentCateg: null
      }, () => {
        this.fetchCategs();
        this.fetchAllEvents(allLives);
        this.fetchAllRankings();
      })
    }
    this.setState({
      currentMonth
    })
  }

  setCurrentPhase(phase) {
    let { currentCateg, currentGroup, currentPhase } = this.state;
    if (!currentCateg) return;
    if (currentPhase && Number(currentPhase.code) === phase) return;
    let group = null;
    if (Number(currentCateg.phases[phase].nbGrps) > 1) {
      group = 0;
      if (Number(currentCateg.phases[phase].nbGrps) === Number(currentPhase.nbGrps)) {
        group = currentGroup;
      }
    }
    this.setState({
      currentPhase: currentCateg.phases[phase],
      currentGroup: group
    })
  }

  async setCurrentPlayer(code, teamMatch, players, e) {
    let player = null;
    let next = null;
    if (Number(code) === 0) return;
    if (teamMatch) {
      player = await this.fetchTeam(code);
      player.players = players;
      next = await this.fetchTeamNext(code);
    } else {
      player = await this.fetchPlayer(code);
      next = await this.fetchPlayerNext(code);
    }
    const allStats = await this.fetchStats(code);
    const allShootout = await this.fetchPlayerShootout(code);
    this.setState({
      showModal: {
        open: true,
        code,
        teamMatch,
        player,
        allStats,
        allShootout,
        next,
        stats: this.sortStats(code, allStats, allShootout),
        item: 'stats',
        statitem: 'main',
        season: 0,
        e
      }
    })
  }

  setCurrentRanking(code) {
    let { allLives, allRankings, categs, currentRanking, saisons } = this.state;
    if (currentRanking && currentRanking.length > 0 && currentRanking[0].code === code) return;
    currentRanking = [allRankings.find(r => r.code === code)];
    currentRanking.isLive = false;
    if (currentRanking[0].live === 1) {
      currentRanking[0].events.forEach(e => {
        if (allLives.findIndex(l => l.event === e.event && e.state === "P") >= 0) {
          currentRanking.isLive = true;
        }
      });
    }
    (async () => {
      if (!currentRanking || currentRanking.length === 0) {
        this.setState({ currentRanking });
        return;
      }
      let ctgs = categs || [];
      const rankingCategs = await Promise.all(currentRanking.map(async (r) => {
        let localCtgs = ctgs;
        if (Number(r.rolling) === 1) {
          const saisonsToFetch = saisons
            .filter(saison => Number(saison.saison) < Number(r.saison) && Number(saison.saison) >= Number(r.saison) - (Number(r.years) - 1))
            .map(saison => saison.saison);
          const moreCategLists = await Promise.all(saisonsToFetch.map(saison => this.fetchCategs(saison, false)));
          moreCategLists.forEach((moreCategs) => {
            localCtgs = [...new Set([...localCtgs, ...moreCategs])];
          });
        } else {
          const moreCategs = await this.fetchCategs(r.saison, false);
          localCtgs = [...new Set([...localCtgs, ...moreCategs])];
        }

        const ranking = await this.fetchRanking(r, 0);
        r.ranking = Global.ifTiedInPoints(r, ranking);
        if (r.live === 1) {
          const rankingLive = await this.fetchRanking(r, 1);
          r.rankingLive = Global.ifTiedInPoints(r, rankingLive);
        }

        return localCtgs;
      }));

      rankingCategs.forEach((localCtgs) => {
        ctgs = [...new Set([...ctgs, ...localCtgs])];
      });

      this.setState({
        currentRanking,
        categs: ctgs
      });
    })();
  }

  setCurrentTab(index) {
    let { allDates, currentCateg, currentEvent, currentSaison, currentTab, initialSaison, lives, nexts, onlyOneEvent } = this.state;
    if (currentTab === index) return;
    let saison = currentSaison;
    if (index !== 2) {
      saison = initialSaison;
    }
    if (!onlyOneEvent) {
      currentEvent = null;
      currentCateg = null;
    }
    this._isMounted && this.setState({
      currentTab: index,
      currentEvent,
      currentCateg,
      currentPhase: null,
      currentSaison: saison,
      currentRanking: []
    }, async () => {
      await this.fetchCategs()
        .then(() => {
          if (!onlyOneEvent) {
            if (index === 0 && lives && lives.length === 1) {
              this.setCurrentEvent(lives[0].code, allDates);
            }
            if (index === 1 && nexts && nexts.length === 1) {
              this.setCurrentEvent(nexts[0].code, allDates);
            }
            /*if (index === 2 && archives && archives.length === 1) { //Pas de sélection auto sur archives
              this.setCurrentEvent(archives[0].code, allDates);
            }*/
          }
        });
    })
  }

  setHthPlayer(code) {
    let { showModal } = this.state;
    let hthPlayer = null;
    if (!showModal.stats) return;
    if (showModal.stats.headtohead.length > 0) {
      const headtohead = showModal.stats.headtohead.filter(h => h.code === code);
      hthPlayer = { code: code };
      hthPlayer.nom = headtohead[0].matches[0].t1j1 === hthPlayer.code ? headtohead[0].matches[0].t1n1 : headtohead[0].matches[0].t2n1;
      hthPlayer.prenom = headtohead[0].matches[0].t1j1 === hthPlayer.code ? headtohead[0].matches[0].t1p1 : headtohead[0].matches[0].t2p1;
    }
    showModal.stats.hthPlayer = hthPlayer;
    this.setState({
      showModal
    })
  }

  setModalClose() {
    this.setState({
      showModal: {
        open: false
      }
    })
  }

  setModalItem(item) {
    let { showModal } = this.state;
    showModal.item = item;
    this.setState({
      showModal
    })
  }

  setModalStatItem(item) {
    let { showModal } = this.state;
    showModal.statitem = item;
    this.setState({
      showModal
    })
  }

  setSearch(e) {
    this.setState({
      searchName: e.target.value
    })
  }

  setStatSeason(season) {
    let { showModal } = this.state;
    if (showModal.season === season) return;
    showModal.season = season;
    showModal.stats = this.sortStats(showModal.code, showModal.allStats, showModal.allShootout, season);
    this.setState({
      showModal
    })
  }

  sortEvents(events, lives) {
    if (!lives) return events;
    events.map((e) => {
      return e.isLive = lives.findIndex(l => l.event === e.code) >= 0;
    })
    events.sort(function (a, b) {
      if (a.isLive) return -1;
      return 1;
    })
    return events;
  }

  sortStats(code, matchs, grpShoots, season = 0) {
    if (!matchs) return null;
    let shootout = [];
    let headtohead = [];
    matchs.forEach((s) => {
      if (season === 0 || Number(season) === moment(s.mc).year()) {
        let adv = 0;
        let name = "";
        let sh = null;
        if (s.t1j1 === code) {
          adv = s.t2j1;
          name = s.t2n1;
          sh = s.sh1;
        } else {
          adv = s.t1j1;
          name = s.t1n1;
          sh = s.sh2;
        }
        if (sh) {
          shootout.push({ sh: sh, match: s });
        }
        const hidx = headtohead.findIndex(h => h.code === adv);
        if (hidx < 0) {
          headtohead.push({ code: adv, name: name, matches: [s] });
        } else {
          headtohead[hidx].matches.push(s);
        }
      }
    });
    grpShoots.forEach((s) => {
      if (season === 0 || Number(season) === moment(s.mc).year()) {
        shootout.push({ sh: s.sh, match: s });
      }
    });
    shootout.sort(function (a, b) {
      if (a.sh > b.sh) return 1;
      if (a.sh < b.sh) return -1;
      return 0;
    });
    headtohead.sort(function (a, b) {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });
    let hthPlayer = null;
    if (headtohead.length > 0) {
      hthPlayer = { code: headtohead[0].code };
      hthPlayer.nom = headtohead[0].matches[0].t1j1 === hthPlayer.code ? headtohead[0].matches[0].t1n1 : headtohead[0].matches[0].t2n1;
      hthPlayer.prenom = headtohead[0].matches[0].t1j1 === hthPlayer.code ? headtohead[0].matches[0].t1p1 : headtohead[0].matches[0].t2p1;
    }
    let stats = {
      shootout,
      headtohead,
      hthPlayer
    };
    return stats;
  }

  swapCountry(country) {
    let { currentCountries } = this.state;
    const cidx = currentCountries.indexOf(country);
    if (cidx >= 0) {
      currentCountries.splice(cidx, 1);
    } else {
      currentCountries.push(country);
    }
    this.setState({ currentCountries });
  }

  swapHidePhase(phase) {
    let { categs } = this.state;
    if (phase.show === true) {
      phase.show = false;
    } else {
      if (phase.show === false) {
        phase.show = true;
      }
    }
    this.setState({ categs });
  }

  swapVideo(match) {
    let { showVideo } = this.state;
    if (showVideo) {
      showVideo = null;
    } else {
      showVideo = match;
    }
    this.setState({
      showVideo
    })
  }

  wsClose() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  wsOpen() {
    const conn = new WebSocket('wss://allscoreslive.com/ws');
    let _this = this;
    let { wsQueue } = _this.state;
    conn.onopen = function () {
      console.log("Connection established at " + moment().format("YYYY-MM-DD HH:mm:ss"));
      while (wsQueue.length > 0) {
        _this.wsSend(wsQueue.shift());
      }
      _this._isMounted && _this.setState({
        wsQueue: []
      });
    };
    conn.onmessage = function (e) {
      _this.wsReceive(e.data);
    };
    conn.onerror = function (e) {
      console.log(e);
    }
    conn.onclose = function (e) {
      console.log("Connection closed at " + moment().format("YYYY-MM-DD HH:mm:ss"));
      _this.ws = null;
    };
    this.ws = conn;
    return conn;
  }

  wsReceive(data) {
    let { currentCateg, currentEvent, allLives, parms, shootout, tables } = this.state;
    const msg = JSON.parse(data);
    if (this.ws) {
      if (msg.act === "pong") {
        return;
      }
      if (!currentEvent) {  //Pas encore d'event
        return;
      }
      console.log("Received data: " + data);
      if (msg.obj === "table") {
        if (msg.act === "alloc") {  //Allocation d'une table pour un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            let table = msg.t1;
            if (!table) { table = msg.t2; }
            if (!table) { table = msg.t3; }
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              if (msg.t1) { tables[idx].t1 = table; }
              if (msg.t2) { tables[idx].t2 = table; }
              if (msg.t3) { tables[idx].t3 = table; }
              tables[idx].tn = msg.tn;
              this._isMounted && this.setState({
                tables,
              });
            }
          }
          return;
        }
        if (msg.act === "reset") {  //Reset d'une table pour un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            let table = msg.t1;
            if (!table) { table = msg.t2; }
            if (!table) { table = msg.t3; }
            if (Number(msg.resetDraw) === 1) {
              const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
              if (idx >= 0) {
                if (msg.t1) { tables[idx].t1 = 0; }
                if (msg.t2) { tables[idx].t2 = 0; }
                if (msg.t3) { tables[idx].t3 = 0; }
                tables[idx].tn = "";
                this._isMounted && this.setState({
                  tables
                });
              }
            }
          }
          return;
        }
        if (msg.act === "name") {  //Changement de nom d'une table
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const tidx = tables.findIndex(t => Number(t.code) === Number(msg.table));
            if (tidx >= 0) {
              tables[tidx].tn = msg.name;
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "live") {  //Associer un live à une table
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const tidx = tables.findIndex(t => Number(t.code) === Number(msg.table));
            if (tidx >= 0) {
              //tables[tidx].live = msg.live;
              tables[tidx].v = msg.video;
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        return;
      }
      if (msg.obj === "event") {
        if (msg.act === "flys") {  //Mise à jour du nombre de flyers
          if (Number(msg.e) === Number(currentEvent.code)) {
            currentEvent.flys = Number(msg.flys);
            this._isMounted && this.setState({
              currentEvent
            });
          }
          return;
        }
        if (msg.act === "addDate") {  //Ajout d'une date
          if (Number(msg.e) === Number(currentEvent.code)) {
            let date = {
              startdate: msg.start,
              enddate: msg.end,
              hide: 0
            };
            currentEvent.dates.push(date);
            this._isMounted && this.setState({
              currentEvent
            });
          }
          return;
        }
        return;
      }
      if (msg.obj === "draw") {
        if (msg.act === "move") { //Déplacement d'un match dans le tirage
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              tables[idx].s = Number(msg.ns);
              tables[idx].r = Number(msg.nr);
              tables[idx].mp = msg.mc;
              tables[idx].mc = msg.mc;
              tables[idx].sets.forEach((set) => {
                set.sc = msg.mc;
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "moveSet") { //Déplacement d'une session dans le tirage
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            //TODO: voir "move" au dessus
          }
          return;
        }
        if (msg.act === "setTbc") { //Set TBC sur un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              tables[idx].mc = null;
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "setTbcSet") { //Set TBC sur une session
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              tables[idx].sets.forEach((set) => {
                if (Number(set.set) === Number(msg.set) && Number(set.ss) === Number(msg.ss)) {
                  set.sc = null;
                }
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "addMatch") { //Ajout d'un match dans le tirage
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            let match = {
              c: Number(data.c),
              p: Number(data.p),
              g: Number(data.g),
              s: Number(data.s),
              r: Number(data.r),
              id: data.id,
              t1j1: data.t1j1,
              t1n1: data.t1n1,
              t1p1: data.t1p1,
              t1c1: data.t1c1,
              t1j2: data.t1j2,
              t1n2: data.t1n2,
              t1p2: data.t1p2,
              t1c2: data.t1c2,
              t2j1: data.t2j1,
              t2n1: data.t2n1,
              t2p1: data.t2p1,
              t2c1: data.t2c1,
              t2j2: data.t2j2,
              t2n2: data.t2n2,
              t2p2: data.t2p2,
              t2c2: data.t2c2,
              s1: 0,
              s2: 0,
              st1: 0,
              st2: 0,
              sh1: null,
              sh2: null,
              t1: data.t1,
              t2: data.t2,
              t3: data.t3,
              mp: data.mp,
              mc: data.mc,
              ms: null,
              me: null,
              v: "",
              sets: [{
                set: 0,
                ss: 0,
                sc1: 0,
                sc2: 0,
                cf1: 0,
                cf2: 0,
                sh1: null,
                sh2: null,
                sc: data.mc,
                st: null,
                se: null,
                frms: []
              }],
              "tm1": [],
              "tm2": [],
              "to1": null,
              "to2": null,
              "expand": false
            };
            tables.push(match);
            this._isMounted && this.setState({
              tables
            });
          }
          return;
        }
        if (msg.act === "groupOrder") { //Changement d'ordre dans un groupe
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].t1j1 = data.t1j1;
              tables[idx].t1n1 = data.t1n1;
              tables[idx].t1p1 = data.t1p1;
              tables[idx].t1c1 = data.t1c1;
              tables[idx].t1j2 = data.t1j2;
              tables[idx].t1n2 = data.t1n2;
              tables[idx].t1p2 = data.t1p2;
              tables[idx].t1c2 = data.t1c2;
              tables[idx].t2j1 = data.t2j1;
              tables[idx].t2n1 = data.t2n1;
              tables[idx].t2p1 = data.t2p1;
              tables[idx].t2c1 = data.t2c1;
              tables[idx].t2j2 = data.t2j2;
              tables[idx].t2n2 = data.t2n2;
              tables[idx].t2p2 = data.t2p2;
              tables[idx].t2c2 = data.t2c2;
              tables[idx].id1 = data.id1;
              tables[idx].id2 = data.id2;
              tables[idx].s1 = data.s1;
              tables[idx].s2 = data.s2;
              tables[idx].t1 = data.t1;
              tables[idx].t2 = data.t2;
              tables[idx].t3 = data.t3;
              tables[idx].v = data.v;
              tables[idx].tm1 = data.tm1 === "null" ? null : data.tm1;
              tables[idx].tm2 = data.tm2 === "null" ? null : data.tm2;
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        return;
      }
      if (msg.obj === "live") {
        if (msg.act === "upScore") {  //Update score
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].st1 = data.st1;
              tables[idx].st2 = data.st2;
              tables[idx].sh1 = data.sh1 === "null" ? null : data.sh1;
              tables[idx].sh2 = data.sh2 === "null" ? null : data.sh2;
              tables[idx].ms = data.ms === "null" ? null : data.ms;
              tables[idx].me = data.me === "null" ? null : data.me;
              data.sets.forEach((set) => {
                const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(set.set) && Number(s.ss) === Number(set.ss));
                if (iset >= 0) {
                  tables[idx].sets[iset].sc1 = set.sc1;
                  tables[idx].sets[iset].sc2 = set.sc2;
                  tables[idx].sets[iset].cf1 = set.cf1;
                  tables[idx].sets[iset].cf2 = set.cf2;
                  tables[idx].sets[iset].sh1 = set.sh1 === "null" ? null : set.sh1;
                  tables[idx].sets[iset].sh2 = set.sh2 === "null" ? null : set.sh2;
                  tables[idx].sets[iset].sc = set.sc;
                  tables[idx].sets[iset].st = set.st === "null" ? null : set.st;
                  tables[idx].sets[iset].se = set.se === "null" ? null : set.se;
                } else {
                  tables[idx].sets.push({
                    set: set.set,
                    ss: set.ss,
                    sc1: set.sc1,
                    sc2: set.sc2,
                    cf1: set.cf1,
                    cf2: set.cf2,
                    sh1: set.sh1 === "null" ? null : set.sh1,
                    sh2: set.sh2 === "null" ? null : set.sh2,
                    sc: set.sc,
                    st: set.st === "null" ? null : set.st,
                    se: set.se === "null" ? null : set.se
                  });
                }
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "upPlayers") {  //Update players d'un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].t1j1 = data.t1j1;
              tables[idx].t1n1 = data.t1n1;
              tables[idx].t1p1 = data.t1p1;
              tables[idx].t1c1 = data.t1c1;
              tables[idx].t1j2 = data.t1j2;
              tables[idx].t1n2 = data.t1n2;
              tables[idx].t1p2 = data.t1p2;
              tables[idx].t1c2 = data.t1c2;
              tables[idx].s1 = data.s1;
              tables[idx].t2j1 = data.t2j1;
              tables[idx].t2n1 = data.t2n1;
              tables[idx].t2p1 = data.t2p1;
              tables[idx].t2c1 = data.t2c1;
              tables[idx].t2j2 = data.t2j2;
              tables[idx].t2n2 = data.t2n2;
              tables[idx].t2p2 = data.t2p2;
              tables[idx].t2c2 = data.t2c2;
              tables[idx].s2 = data.s2;
              tables[idx].st1 = data.st1;
              tables[idx].st2 = data.st2;
              tables[idx].ms = data.ms === "null" ? null : data.ms;
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "startMatch") {  //Lancement d'un match
          if (Number(msg.e) === Number(currentEvent.code)) {
            const data = JSON.parse(msg.m);
            if (tables) {
              const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
              if (idx >= 0) {
                tables[idx].t1 = data.t1;
                tables[idx].t2 = data.t2;
                tables[idx].t3 = data.t3;
                tables[idx].ms = data.ms === "null" ? null : data.ms;
                tables[idx].v = data.v;
                data.sets.forEach((set) => {
                  const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(set.set) && Number(s.ss) === Number(set.ss));
                  if (iset >= 0) {
                    tables[idx].sets[iset].st = set.st === "null" ? null : set.st;
                  } else {
                    tables[idx].sets.push({
                      set: set.set,
                      ss: set.ss,
                      sc1: set.sc1,
                      sc2: set.sc2,
                      cf1: set.cf1,
                      cf2: set.cf2,
                      sh1: set.sh1 === "null" ? null : set.sh1,
                      sh2: set.sh2 === "null" ? null : set.sh2,
                      sc: set.sc,
                      st: set.st === "null" ? null : set.st,
                      se: set.se === "null" ? null : set.se
                    });
                  }
                });
                this._isMounted && this.setState({
                  tables
                });
              }
            }
            if (allLives && allLives.findIndex(l => l.event === currentEvent.code && l.categ === data.c) < 0) {
              allLives.push({
                event: currentEvent.code,
                categ: data.c
              });
              this._isMounted && this.setState({
                allLives
              }, () => {
                this.checkCategs(parms, allLives);
              });
            }
          }
          return;
        }
        if (msg.act === "restartMatch") {  //Redémarrer un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].st1 = data.st1;
              tables[idx].st2 = data.st2;
              tables[idx].t1 = data.t1;
              tables[idx].t2 = data.t2;
              tables[idx].t3 = data.t3;
              tables[idx].sh1 = null;
              tables[idx].sh2 = null;
              tables[idx].ms = data.ms === "null" ? null : data.ms;
              tables[idx].me = null;
              tables[idx].v = data.v;
              data.sets.forEach((set) => {
                const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(set.set) && Number(s.ss) === Number(set.ss));
                if (iset >= 0) {
                  tables[idx].sets[iset].sc1 = set.sc1;
                  tables[idx].sets[iset].sc2 = set.sc2;
                  tables[idx].sets[iset].cf1 = set.cf1;
                  tables[idx].sets[iset].cf2 = set.cf2;
                  tables[idx].sets[iset].sh1 = set.sh1 === "null" ? null : set.sh1;
                  tables[idx].sets[iset].sh2 = set.sh2 === "null" ? null : set.sh2;
                  tables[idx].sets[iset].sc = set.sc;
                  tables[idx].sets[iset].st = set.st === "null" ? null : set.st;
                  tables[idx].sets[iset].se = set.se === "null" ? null : set.se;
                } else {
                  tables[idx].sets.push({
                    set: set.set,
                    ss: set.ss,
                    sc1: set.sc1,
                    sc2: set.sc2,
                    cf1: set.cf1,
                    cf2: set.cf2,
                    sh1: set.sh1 === "null" ? null : set.sh1,
                    sh2: set.sh2 === "null" ? null : set.sh2,
                    sc: set.sc,
                    st: set.st === "null" ? null : set.st,
                    se: set.se === "null" ? null : set.se
                  });
                }
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "endMatch") {  //End match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].st1 = data.st1;
              tables[idx].st2 = data.st2;
              tables[idx].sh1 = data.sh1 === "null" ? null : data.sh1;
              tables[idx].sh2 = data.sh2 === "null" ? null : data.sh2;
              tables[idx].ms = data.ms === "null" ? null : data.ms;
              tables[idx].me = data.me === "null" ? null : data.me;
              data.sets.forEach((set) => {
                const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(set.set) && Number(s.ss) === Number(set.ss));
                if (iset >= 0) {
                  tables[idx].sets[iset].sc1 = set.sc1;
                  tables[idx].sets[iset].sc2 = set.sc2;
                  tables[idx].sets[iset].cf1 = set.cf1;
                  tables[idx].sets[iset].cf2 = set.cf2;
                  tables[idx].sets[iset].sh1 = set.sh1 === "null" ? null : set.sh1;
                  tables[idx].sets[iset].sh2 = set.sh2 === "null" ? null : set.sh2;
                  tables[idx].sets[iset].sc = set.sc;
                  tables[idx].sets[iset].st = set.st === "null" ? null : set.st;
                  tables[idx].sets[iset].se = set.se === "null" ? null : set.se;
                } else {
                  tables[idx].sets.push({
                    set: set.set,
                    ss: set.ss,
                    sc1: set.sc1,
                    sc2: set.sc2,
                    cf1: set.cf1,
                    cf2: set.cf2,
                    sh1: set.sh1 === "null" ? null : set.sh1,
                    sh2: set.sh2 === "null" ? null : set.sh2,
                    sc: set.sc,
                    st: set.st === "null" ? null : set.st,
                    se: set.se === "null" ? null : set.se
                  });
                }
              });
              this._isMounted && this.setState({
                tables
              }, () => {
                if (currentCateg && currentCateg.code === data.c) {
                  this.setState({
                    ctgs: Global.computeRanking(currentCateg, parms, shootout, tables)
                  })
                }
              });
            }
          }
          return;
        }
        if (msg.act === "cancelMatch") {  //Annuler un match
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.m);
            const idx = tables.findIndex(t => Number(t.c) === Number(data.c) && Number(t.p) === Number(data.p) && Number(t.g) === Number(data.g) && Number(t.s) === Number(data.s) && Number(t.r) === Number(data.r));
            if (idx >= 0) {
              tables[idx].st1 = 0;
              tables[idx].st2 = 0;
              tables[idx].ms = null;
              tables[idx].me = null;
              tables[idx].v = "";
              tables[idx].expand = false;
              tables[idx].t1 = 0;
              tables[idx].t2 = 0;
              tables[idx].t3 = 0;
              data.sets.forEach((set) => {
                const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(set.set) && Number(s.ss) === Number(set.ss));
                if (iset >= 0) {
                  tables[idx].sets[iset].sc1 = set.sc1;
                  tables[idx].sets[iset].sc2 = set.sc2;
                  tables[idx].sets[iset].cf1 = set.cf1;
                  tables[idx].sets[iset].cf2 = set.cf2;
                  tables[idx].sets[iset].sh1 = set.sh1 === "null" ? null : set.sh1;
                  tables[idx].sets[iset].sh2 = set.sh2 === "null" ? null : set.sh2;
                  tables[idx].sets[iset].sc = set.sc;
                  tables[idx].sets[iset].st = null;
                  tables[idx].sets[iset].se = null;
                }
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "clearOrder") {  //Clear players order
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              if (Number(msg.team) === Number(tables[idx].t1j1)) {
                tables[idx].to1 = null;
              } else {
                tables[idx].to2 = null;
              }
              tables[idx].sets[0].frms = [];
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "setOrder") {  //Set players order
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              if (Number(msg.team) === Number(tables[idx].t1j1)) {
                tables[idx].to1 = {
                  p1: msg.p1,
                  p2: msg.p2,
                  p3: msg.p3,
                  p4: msg.p4,
                  p5: msg.p5,
                  p6: msg.p6,
                  p7: msg.p7,
                  p8: msg.p8,
                  p9: msg.p9,
                  p10: msg.p10,
                  p11: msg.p11,
                  p12: msg.p12,
                  p13: msg.p13,
                  p14: msg.p14,
                  p15: msg.p15
                };
              } else {
                tables[idx].to2 = {
                  p1: msg.p1,
                  p2: msg.p2,
                  p3: msg.p3,
                  p4: msg.p4,
                  p5: msg.p5,
                  p6: msg.p6,
                  p7: msg.p7,
                  p8: msg.p8,
                  p9: msg.p9,
                  p10: msg.p10,
                  p11: msg.p11,
                  p12: msg.p12,
                  p13: msg.p13,
                  p14: msg.p14,
                  p15: msg.p15
                };
              }
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "upFrame") {  //Update frame
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.f);
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              const fidx = tables[idx].sets[Number(msg.set)].frms.findIndex(f => Number(f.frm) === Number(data.frm));
              if (fidx >= 0) {
                tables[idx].sets[Number(msg.set)].frms[fidx] = {
                  frm: data.frm,
                  t1j1: data.t1j1,
                  t1n1: data.t1n1,
                  t1p1: data.t1p1,
                  t1c1: data.t1c1,
                  t1j2: data.t1j2,
                  t1n2: data.t1n2,
                  t1p2: data.t1p2,
                  t1c2: data.t1c2,
                  t2j1: data.t2j1,
                  t2n1: data.t2n1,
                  t2p1: data.t2p1,
                  t2c1: data.t2c1,
                  t2j2: data.t2j2,
                  t2n2: data.t2n2,
                  t2p2: data.t2p2,
                  t2c2: data.t2c2,
                  st: data.st,
                  cs: data.cs,
                  sc1: data.sc1,
                  sc2: data.sc2,
                  cf1: data.cf1,
                  cf2: data.cf2,
                  t: data.t
                };
              }
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "upShoot") {  //Update Group Shootout
          if (Number(msg.e) === Number(currentEvent.code) && shootout) {
            let shootIdx = shootout.findIndex(s => Number(s.c) === Number(msg.c) && Number(s.p) === Number(msg.p) && Number(s.g) === Number(msg.g) && Number(s.t1j1) === Number(msg.t1j1));
            if (shootIdx >= 0) {
              shootout[shootIdx].sh = msg.sh;
            } else {
              const shoot = { c: Number(msg.c), p: Number(msg.p), g: Number(msg.g), t1j1: Number(msg.t1j1), t1j2: Number(msg.t1j2), sh: msg.sh };
              shootout.push(shoot);
            }
            if (Number(currentCateg) !== 0 && Number(currentCateg.code) === Number(msg.c)) {
              this.setState({
                ctgs: Global.computeRanking(currentCateg, parms, shootout, tables)
              })
            }
            this._isMounted && this.setState({
              shootout
            });
          }
          return;
        }
        if (msg.act === "upPlayer") {  //Update a player
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            tables.forEach(m => {
              if (Number(m.t1j1) === Number(msg.c)) {
                m.t1n1 = msg.n;
                m.t1p1 = msg.p;
                m.t1c1 = msg.y;
              }
              if (Number(m.t1j2) === Number(msg.c)) {
                m.t1n2 = msg.n;
                m.t1p2 = msg.p;
                m.t1c2 = msg.y;
              }
              if (Number(m.t2j1) === Number(msg.c)) {
                m.t2n1 = msg.n;
                m.t2p1 = msg.p;
                m.t2c1 = msg.y;
              }
              if (Number(m.t2j2) === Number(msg.c)) {
                m.t2n2 = msg.n;
                m.t2p2 = msg.p;
                m.t2c2 = msg.y;
              }
            });
            this._isMounted && this.setState({
              tables
            });
          }
          return;
        }
        if (msg.act === "setCard") {  //Define the matchcard
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const data = JSON.parse(msg.f);
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              const iset = tables[idx].sets.findIndex(s => Number(s.set) === Number(msg.set));
              if (iset >= 0) {
                tables[idx].sets[iset].frms = this.formatFrames(tables[idx], data);
              }
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "substitute") {  //Substitute a player
          if (Number(msg.e) === Number(currentEvent.code) && tables) {
            const idx = tables.findIndex(t => Number(t.c) === Number(msg.c) && Number(t.p) === Number(msg.p) && Number(t.g) === Number(msg.g) && Number(t.s) === Number(msg.s) && Number(t.r) === Number(msg.r));
            if (idx >= 0) {
              let playerIn = null;
              if (Number(msg.team) === 1) {
                playerIn = tables[idx].tm1.find(p => Number(p.i) === Number(msg.in));
              } else {
                playerIn = tables[idx].tm2.find(p => Number(p.i) === Number(msg.in));
              }
              tables[idx].sets[Number(msg.set)].frms.forEach((frm) => {
                if (Number(frm.frm) >= Number(msg.f)) {
                  if (Number(msg.team) === 1) {
                    if (Number(frm.t1j1) === Number(msg.out)) {
                      frm.t1j1 = playerIn.i;
                      frm.t1n1 = playerIn.n;
                      frm.t1p1 = playerIn.p;
                      frm.t1c1 = playerIn.c;
                    }
                    if (Number(frm.t1j2) === Number(msg.out)) {
                      frm.t1j2 = playerIn.i;
                      frm.t1n2 = playerIn.n;
                      frm.t1p2 = playerIn.p;
                      frm.t1c2 = playerIn.c;
                    }
                  } else {
                    if (Number(frm.t2j1) === Number(msg.out)) {
                      frm.t2j1 = playerIn.i;
                      frm.t2n1 = playerIn.n;
                      frm.t2p1 = playerIn.p;
                      frm.t2c1 = playerIn.c;
                    }
                    if (Number(frm.t2j2) === Number(msg.out)) {
                      frm.t2j2 = playerIn.i;
                      frm.t2n2 = playerIn.n;
                      frm.t2p2 = playerIn.p;
                      frm.t2c2 = playerIn.c;
                    }
                  }
                }
              });
              this._isMounted && this.setState({
                tables
              });
            }
          }
          return;
        }
        if (msg.act === "hidePhase") {  //Hide/unhide a phase
          if (Number(msg.e) === Number(currentEvent.code) && parms) {
            let parm = parms.find(p => Number(p.categ) === Number(msg.c));
            if (parm) {
              parm.hide = msg.h;
              this._isMounted && this.setState({
                parms
              });
            }
          }
          return;
        }
        return;
      }
    }
  }

  wsSend(data) {
    let { currentEvent, wsQueue } = this.state;
    if (!this.ws) {
      this.ws = this.wsOpen();
      if (currentEvent && Number(currentEvent.code) > 0) {
        this.wsSend("ident=LS&event=" + currentEvent.code/* + "&user=" + user.email*/);
      }
    }
    if (this.ws) {
      if (this.ws.readyState !== 1) {
        wsQueue.push(data);
        this._isMounted && this.setState({
          wsQueue
        });
        return;
      }
      let encryption = new Encryption();
      let encrypted = encryption.encrypt(data, "nonce_value");
      if (data.act !== "ping") console.log("Sending data: " + data);
      this.ws.send(encrypted);
    }
  }

  renderAllCategSponsors() {
    const { t } = this.props;
    let { allCategSponsors } = this.state;
    if (allCategSponsors.length === 0) return null;
    const nbSponsors = allCategSponsors.filter(s => Number(s.partner) === 0).length;
    const nbPartners = allCategSponsors.filter(s => Number(s.partner) === 1).length;
    return (
      <div className="hall-sponsors-cont">
        {nbSponsors > 0 && <h3 className="hall-sponsors-title">{t('sponsors')}</h3>}
        <div className="hall-sponsors-list">
          {allCategSponsors.filter(s => Number(s.partner) === 0).map((s) => {
            return (
              <div key={"ALLSP" + s.id} className="hall-sponsor-cont" /*style={{ maxWidth: widthS + "%", width: widthS + "%" }}*/>
                <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-sponsor-logo" alt="" />
              </div>
            )
          })}
        </div>
        {nbPartners > 0 && <h3 className="hall-sponsors-title">{t('partners')}</h3>}
        <div className="hall-sponsors-list">
          {allCategSponsors.filter(s => Number(s.partner) === 1).map((s) => {
            return (
              <div key={"ALLSPP" + s.id} className="hall-sponsor-cont" /*style={{ maxWidth: widthP + "%", width: widthP + "%" }}*/>
                {Number(s.size) > 0 ?
                  <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-partner-logo" style={{ width: s.size + '%' }} alt="" />
                  :
                  <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-partner-logo" alt="" />}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderCategHeader(categ) {
    let { currentCateg, categs, dates, parms, sponsors } = this.state;
    if (!categ) categ = currentCateg;
    if (Number(categ) === 0) return null;
    if (!categ || !categs || !dates || !parms || !sponsors) return null;
    const categSponsors = sponsors.filter(s => s.categ === categ.code);
    return (
      <div>
        <div>
          <h1 className="hall-categ-title bold" style={{ marginTop: '3rem' }}>
            {this.getCategLabel(categ)}
            {dates && dates.isLive &&
              <span className="hall-categ-live row-center" style={{ display: 'inherit' }}>
                LIVE
              </span>}
          </h1>
        </div>
        {categ.banner !== "" &&
          <div style={{ width: '100%' }}>
            <img src={Global.localUrl + 'admin/images/' + categ.banner} className="hall-categ-banner" alt="" />
          </div>}
        {sponsors && this.renderCategSponsors(categSponsors)}
      </div>
    )
  }

  renderCategSelect(options) {
    const { t } = this.props;
    let { currentCateg, currentEvent } = this.state;
    if (!currentEvent) return null;
    return (
      <React.Fragment>
        {options && options.length > 2 && <Segment inverted>
          <Dropdown
            placeholder={t('selectcateg')}
            selection fluid labeled
            options={options}
            style={{ background: 'inherit', color: 'inherit', textAlign: 'center' }}
            value={currentCateg ? currentCateg.code : 0}
            onChange={(e, data) => { this.setCurrentCateg(data.value) }}
          />
        </Segment>}
      </React.Fragment>
    )
  }

  renderCategSponsors(sponsors) {
    const { t } = this.props;
    if (sponsors.length === 0) return null;
    const hasSponsor = sponsors.filter(s => Number(s.partner) === 0).length > 0;
    const hasPartner = sponsors.filter(s => Number(s.partner) === 1).length > 0;
    return (
      <div className="hall-sponsors-cont">
        {hasSponsor && <h3 className="hall-sponsors-title">{t('sponsors')}</h3>}
        <div className="hall-sponsors-list">
          {sponsors.filter(s => Number(s.partner) === 0).map((s) => {
            return (
              <div key={"SP" + s.id} className="hall-sponsor-cont">
                {s.link.trim() === ""
                  ?
                  <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-sponsor-logo" alt="" />
                  :
                  <a href={s.link}>
                    <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-sponsor-logo" alt="" />
                  </a>
                }
              </div>
            )
          })}
        </div>
        {hasPartner && <h3 className="hall-sponsors-title">{t('partners')}</h3>}
        <div className="hall-sponsors-list">
          {sponsors.filter(s => Number(s.partner) === 1).map((s) => {
            return (
              <div key={"SPP" + s.id} className="hall-sponsor-cont">
                {s.link.trim() === ""
                  ?
                  <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-partner-logo" alt="" />
                  :
                  <a href={s.link}>
                    <img src={Global.localUrl + 'admin/sponsors/' + s.logo} className="hall-partner-logo" alt="" />
                  </a>
                }
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderEventHeader() {
    let { categOptions, currentEvent, dates, sponsors } = this.state;
    if (!currentEvent || !dates || !sponsors) return null;
    return (
      <div>
        <div>
          <h1 className="hall-categ-title bold">
            {Global.getHtmlString(dates.name)}
            {currentEvent.isLive &&
              <span className="hall-categ-live row-center" style={{ display: 'inherit' }}>
                LIVE
              </span>}
          </h1>
          {/*<h3 className="hall-text-center">{startdate} - {enddate}</h3>*/}
          <h4 className="hall-text-center">{Global.getHtmlString(dates.venue)}</h4>
        </div>
        {currentEvent.banner !== "" &&
          <div style={{ width: '100%' }}>
            <img src={Global.localUrl + 'admin/images/' + currentEvent.banner} className="hall-event-banner" alt="" />
            {this.renderCategSelect(categOptions)}
          </div>}
        {sponsors && this.renderAllCategSponsors()}
      </div>
    )
  }

  renderEventSelect(options) {
    const { t } = this.props;
    let { allDates, currentEvent } = this.state;
    const label = t('selectevent');
    return (
      <React.Fragment>
        {/*options && options.length > 1 && */<Segment inverted>
          <Dropdown
            placeholder={label}
            selection fluid
            options={options}
            style={{ background: 'inherit', color: 'inherit', textAlign: 'center' }}
            value={currentEvent ? currentEvent.code : 0}
            onChange={(e, data) => { this.setCurrentEvent(data.value, allDates) }}
          />
        </Segment>}
      </React.Fragment>
    )
  }

  renderArchives() {
    const { t } = this.props;
    let { archives, archiveOptions, categOptions, currentCateg, currentEvent } = this.state;
    if (!archives || archives.length === 0) {
      return (
        <div className="mainContainer">
          {this.renderSaisons()}
          {this.renderAppPromo()}
          <Segment inverted>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', height: '50vh', width: '100%' }}>
              <h1>{t('noarchives')}</h1>
            </div>
          </Segment>
        </div>
      )
    }
    return (
      <div className="mainContainer">
        {this.renderSaisons()}
        {this.renderEventSelect(archiveOptions)}
        {this.renderAppPromo()}
        {this.renderCategSelect(categOptions)}
        {currentEvent && this.renderEventHeader()}
        {currentCateg && this.renderCategHeader()}
        {currentCateg && this.renderSearch()}
        {currentCateg && this.renderPhases()}
        {currentEvent && this.renderBracket()}
        {currentCateg && this.renderPhases()}
      </div>
    )
  }

  renderBracket() {
    const { t } = this.props;
    let { categs, currentCateg, currentEvent, currentGroup, currentPhase, currentTab, showGroupPlayers, showGroupTable, tables } = this.state;
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    let tmpCateg, tmpPhase, tmpGroup, tmpSession, tmpDate;
    if ((!currentCateg && Number(currentCateg) !== 0) || !tables) return null;
    let showQualified = false;
    let showWinner = false;
    let firstLetter = "";
    return (
      <Segment inverted>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '96%' }}>
            {this.renderGroups()}
            <table className="hall-main-table">
              <tbody>
                <tr>
                  <td className="hall-table-col1">&nbsp;</td>
                  <td className="hall-table-col2">&nbsp;</td>
                  <td className="hall-table-col3">&nbsp;</td>
                </tr>
                {tables && tables.length === 0 &&
                  <tr>
                    <td colSpan={3} className="hall-table-cell">
                      {currentTab === 0 && Number(currentCateg) === 0 ?
                        <h3 className="hall-categ-title">{t('notinprogress')}</h3>
                        :
                        <h3 className="hall-categ-title">{t('notyetdraw')}</h3>
                      }
                    </td>
                  </tr>
                }
                {currentTab === 1 && tables && tables.length === 0 && currentCateg.entries && currentCateg.entries.length > 0 &&
                  <React.Fragment>
                    <tr>
                      <td colSpan={3} className="hall-table-cell">
                        <h3 className="hall-categ-title" style={{ marginTop: '2rem' }}>{t('entrieslist', { nb: currentCateg.entries.length })}</h3>
                      </td>
                    </tr>
                    {currentCateg.entries.map((entry, index) => {
                      let showLetter = false;
                      if (firstLetter !== entry.n.substr(0, 1)) {
                        firstLetter = entry.n.substr(0, 1);
                        showLetter = true;
                      }
                      return (
                        <React.Fragment>
                          {showLetter && <tr key={"entry-key-letter" + index}>
                            <td className="hall-table-cell">&nbsp;</td>
                            <td className="hall-table-cell" style={{ paddingTop: showLetter ? '1rem' : 0 }}>
                              {showLetter && <Label circular size={'small'}>{firstLetter}</Label>}
                            </td>
                            <td className="hall-table-cell">&nbsp;</td>
                          </tr>}
                          <tr key={"entry-key-" + index}>
                            <td className="hall-table-cell">&nbsp;</td>
                            <td className="hall-table-cell" style={{ paddingTop: showLetter ? '1rem' : 0 }}>
                              {currentCateg.type === "S" && <h3 className="hall-categ-title">{entry.n + " " + entry.p}</h3>}
                              {currentCateg.type === "D" && <h3 className="hall-categ-title">{entry.n + " " + entry.p}</h3>}
                              {currentCateg.type === "T" && <h3 className="hall-categ-title">
                                {entry.n + " ("}
                                <p style={{ display: 'inline', fontWeight: 'normal', fontSize: '1rem' }}>
                                  {entry.players.map((pl, idx) => {
                                    return (pl.p + " " + pl.n + (idx < entry.players.length - 1 ? ", " : ""))
                                  })}
                                </p>
                                {")"}
                              </h3>}
                            </td>
                            <td className="hall-table-cell">&nbsp;</td>
                          </tr>
                        </React.Fragment>
                      )
                    })}
                  </React.Fragment>}
                {tables && tables.filter(t => !currentPhase || (currentPhase && t.p === currentPhase.code && (currentGroup === null || Number(t.g) === currentGroup))).map((table, index) => {
                  const cat = categs.find(c => c.code === table.c);
                  if (!cat) return null;
                  const ph = cat.phases[Number(table.p)];
                  showQualified = ph.mode.substr(1, 1) === "Q";
                  let showQualifiedHeader = false;
                  //showQualifiedHeader = showQualified && Number(table.r) === 0;
                  let showCateg = false;
                  let showPhase = false;
                  let showGroup = false;
                  let showDate = false;
                  let newSession = false;
                  let showChange = tables.filter(t => t.c === table.c && t.p === table.p && t.g === table.g && !t.ms).length > 0;
                  if (!showCateg && tmpCateg !== table.c && currentTab === 0 && Number(currentCateg) === 0) {
                    tmpCateg = table.c;
                    showCateg = true;
                    tmpPhase = "";
                  }
                  if (!showPhase && tmpPhase !== ph.lib) {
                    tmpPhase = ph.lib;
                    tmpGroup = table.g;
                    tmpSession = table.s;
                    showPhase = !showQualified;
                    showGroup = Number(ph.nbGrps) > 1 || ((ph.mode === "RR" || ph.mode === "C1" || ph.mode === "C2" || ph.mode === "C3") && (Number(ph.nbQlfs) > 1 || (currentCateg && currentCateg.phases.length === 1)));
                    showDate = !showQualified;
                    showWinner = table.me && Number(table.p) === (cat.phases.length - 1) && ph.tirage !== "D" && !showQualified;
                    if (ph.show === null && Number(ph.autohide) === 1) {
                      const ended = tables.findIndex(t => t.c === cat.code && t.p === ph.code && !t.me) < 0;
                      if (ended) {
                        ph.show = false;
                        this.setState({ categs });
                      }
                    }
                  }
                  if (!showGroup && tmpGroup !== table.g) {
                    tmpGroup = table.g;
                    tmpSession = table.s;
                    showGroup = Number(ph.nbGrps) > 1 || ((ph.mode === "RR" || ph.mode === "C1" || ph.mode === "C2" || ph.mode === "C3") && (Number(ph.nbQlfs) > 1 || (currentCateg && currentCateg.phases.length === 1)));
                  }
                  if (table.mc && tmpDate !== new Date(table.mc.replace(" ", "T")).toLocaleDateString('en-GB', options)) {
                    tmpDate = new Date(table.mc.replace(" ", "T")).toLocaleDateString('en-GB', options);
                    showDate = !showQualified;
                  }
                  if (tmpSession !== table.s) {
                    if (!showDate) newSession = true;
                    tmpSession = table.s;
                  }
                  const date = currentEvent.dates.find(d => moment(table.mc).isBetween(moment(d.startdate), moment(d.enddate), 'day', '[]'));
                  if (date && Number(date.hide) === 1) return null;
                  const weeks = ["Week 1", "Week 16", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7", "Week 10", "Week 9", "Week 8", "Week 11", "Week 12", "Week 13", "Week 14", "Week 15", "Week 2"];
                  return (
                    <React.Fragment key={"table-key-" + index}>
                      {showCateg &&
                        <tr key={"hc" + table.c}>
                          <td className="hall-table-cell">&nbsp;</td>
                          <td className="hall-table-cell">
                            <h1 className="hall-categ-title bold" style={{ marginTop: '3rem' }}>
                              {this.getCategLabel(cat)}
                            </h1>
                          </td>
                          <td className="hall-table-cell">&nbsp;</td>
                        </tr>}
                      {showPhase && this.renderPhaseHeader(ph)}
                      {showGroup && ph.show !== false &&
                        <tr key={"hg" + table.c + table.p + table.g}>
                          <td className="hall-table-cell">&nbsp;</td>
                          <td className="hall-table-cell">
                            {Number(ph.nbGrps) === 1 && (ph.mode === "RR" || ph.mode === "C1" || ph.mode === "C2" || ph.mode === "C3") && currentTab > 0 &&
                              <h3 className="hall-categ-title" style={{ marginTop: '2rem' }}>
                                {cat.type !== "T" && "Group Table"}
                                {cat.type === "T" && showGroupTable && <div className="hall-link-active">{t('groupTable')}</div>}
                                {cat.type === "T" && !showGroupTable && <div className="hall-link" onClick={() => this.showGroupTable()}>{t('groupTable')}</div>}
                                {cat.type === "T" && showGroupPlayers && <div className="hall-link-active">{t('leadingPlayers')}</div>}
                                {cat.type === "T" && !showGroupPlayers && <div className="hall-link" onClick={() => this.showGroupPlayers()}>{t('leadingPlayers')}</div>}
                              </h3>}
                            {Number(ph.nbGrps) > 1 && (Number(currentEvent.code) !== 196 || Number(table.p) > 0) && <h3 className="hall-categ-title" style={{ marginTop: '2rem' }}>{t('group', { grp: Global.getGroupLabel(ph, table.g) })}</h3>}
                            {Number(ph.nbGrps) > 1 && Number(currentEvent.code) === 196 && Number(table.p) === 0 && <h3 className="hall-categ-title" style={{ marginTop: '2rem' }}>{weeks[Number(table.g)]}</h3>}
                          </td>
                          <td className="hall-table-cell">&nbsp;</td>
                        </tr>}
                      {showGroup && ph.show !== false && /*(currentTab > 0 || currentCateg !== 0) &&*/ showGroupTable && this.renderGroupRanking(table.p, table.g)}
                      {showGroup && ph.show !== false && /*(currentTab > 0 || currentCateg !== 0) &&*/ showGroupPlayers && this.renderGroupPlayers(table.p, table.g)}
                      {showDate && (table.mc || tmpDate) && ph.show !== false &&
                        <tr key={"hd" + table.c + table.p + table.g + tmpDate}>
                          <td className="hall-table-cell">&nbsp;</td>
                          <td className="hall-table-cell">
                            <h5 className="hall-categ-title" style={{ marginTop: '1rem' }}>{this.getLocalDate(table.mc)}</h5>
                          </td>
                          <td className="hall-table-cell">&nbsp;</td>
                        </tr>}
                      {((showDate && (table.mc || tmpDate) && !showGroup) || showGroup) && showChange && ph.show !== false &&
                        <tr key={"hdc" + table.c + table.p + table.g + tmpDate}>
                          <td className="hall-table-cell">&nbsp;</td>
                          <td className="hall-table-cell">
                            <h5 className="hall-categ-title" style={{ marginTop: 0, fontSize: 'smaller' }}>{t('timeChange')}</h5>
                          </td>
                          <td className="hall-table-cell">&nbsp;</td>
                        </tr>}
                      {showQualifiedHeader &&
                        <tr key={"h3q" + table.c + table.p}>
                          <td className="hall-table-cell">&nbsp;</td>
                          <td className="hall-table-cell">
                            <h3 className="hall-categ-phase">{ph.lib}</h3>
                          </td>
                          <td className="hall-table-cell">&nbsp;</td>
                        </tr>}
                      {!showQualified && ph.show !== false && this.renderMatch(cat, ph, table, newSession)}
                      {showQualified && this.renderQualified(table)}
                    </React.Fragment>
                  )
                })}
                {showWinner && this.renderWinner(tables[tables.length - 1])}
              </tbody>
            </table>
          </div>
        </div>
      </Segment>
    );
  }

  renderCalendar() {
    const { t } = this.props;
    let { allDates, currentMonth } = this.state;
    let events = [];
    allDates.filter(e => e.state === "P").forEach((e) => {
      e.dates.filter(d => moment(d.startdate).isSame(currentMonth, 'month') && moment(d.enddate).isSameOrAfter(moment(), 'day')).forEach((d) => {
        let title = Global.getHtmlString(e.name);
        if (events.findIndex(ev => ev.event === e.code && moment(ev.start).isSame(d.startdate, 'day') && moment(ev.end).isSame(d.enddate, 'day')) < 0) {
          events.push({
            title: title,
            start: d.startdate,
            end: d.enddate,
            event: e.code,
            date: d,
            categ: d.categ,
            state: e.state
          })
        }
      })
    })
    events.sort(function (a, b) {
      if (a.start > b.start) return 1;
      if (a.start < b.start) return -1;
      return 0;
    })
    return (
      <div style={{ margin: '1rem' }}>
        <h1 className="hall-categ-title bold">
          <Icon name="angle left" style={{ marginRight: '1rem' }} inverted onClick={(e) => this.setCurrentMonth("-")} />
          {currentMonth.format('MMMM YYYY')}
          <Icon name="angle right" style={{ marginLeft: '1rem' }} inverted onClick={(e) => this.setCurrentMonth("+")} />
        </h1>
        {events.length === 0 && <h3>{t('noupcomingmonth')}</h3>}
        {events.length > 0 && <Table celled unstackable inverted selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('agendaStart')}</Table.HeaderCell>
              <Table.HeaderCell>{t('agendaEnd')}</Table.HeaderCell>
              <Table.HeaderCell>{t('agendaEvent')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {events.map((event, e) => {
              const end = moment(event.end).isSame(moment(event.start), 'day') ? "-" : moment(event.end).format("LL");
              return (
                <Table.Row key={"event-" + e} style={{ cursor: event.state !== "D" ? 'pointer' : 'default' }}
                  onClick={() => this.setCalendarEvent(event)}>
                  <Table.Cell>{moment(event.start).format("LL")}</Table.Cell>
                  <Table.Cell>{end}</Table.Cell>
                  <Table.Cell>{event.title}</Table.Cell>
                </Table.Row>
              )
            })}
          </Table.Body>
        </Table>}
      </div>
    )
  }

  renderDetail(showDetail, categ, match, set) {
    if (!showDetail) return null;
    if (match.tm1.length === 0 || match.tm2.length === 0) return null;
    let currentSet = 0;
    if (set) currentSet = Number(set.set);
    if (match.sets[currentSet].frms && match.sets[currentSet].frms.length > 0) {
      return match.sets[currentSet].frms.map((frame, f) => {
        const ended = Number(frame.sc1) > 0 || Number(frame.sc2) > 0;
        const started = Number(frame.st) === 1;
        const isDouble = Number(frame.t1j2) > 0;
        if (started && ended) {
          let win = 0;
          if (Number(frame.sc1) > Number(frame.sc2)) win = 1;
          if (Number(frame.sc2) > Number(frame.sc1)) win = 2;
          return (
            <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "F" + frame.frm}>
              <td className="hall-table-cell"></td>
              <td className="hall-table-cell">
                <div className="hall-frame" style={{ marginBottom: f === match.sets[currentSet].frms.length - 1 ? '.5rem' : 0 }}>
                  <div className={isDouble ? "hall-double-left-ended" : "hall-single-left-ended"} style={{ backgroundColor: categ.live.bended, color: categ.live.fended }}>
                    {this.renderFlag(isDouble, frame.t1c1, frame.t1c2)}
                    <div className="hall-single-fill">
                      <div className={isDouble ? "hall-double-name-left" : "hall-single-name-left"}>
                        <p style={{ fontWeight: win === 1 ? 'bold' : 'normal' }}>
                          <span className="hall-single-name-left-margin">{frame.t1p1}</span>
                          {frame.t1n1 + Global.get6RS(frame.sh1)}
                        </p>
                        {isDouble &&
                          <p style={{ fontWeight: win === 1 ? 'bold' : 'normal' }}>
                            <span className="hall-single-name-left-margin">{frame.t1p2}</span>
                            {frame.t1n2}
                          </p>
                        }
                      </div>
                      {this.renderScore1Frame(match, frame)}
                    </div>
                  </div>
                  <div className={isDouble ? "hall-double-right-ended" : "hall-single-right-ended"} style={{ backgroundColor: categ.live.bended, color: categ.live.fended }}>
                    <div className={isDouble ? "hall-double-right-name" : "hall-single-right-name"}>
                      {this.renderScore2Frame(match, frame)}
                      <div className={isDouble ? "hall-double-name-right" : "hall-single-name-right"}>
                        <p style={{ fontWeight: win === 2 ? 'bold' : 'normal' }}>
                          {Global.get6RS(frame.sh2)}
                          <span className="hall-single-name-right-margin">{frame.t2p1}</span>
                          {frame.t2n1}
                        </p>
                        {isDouble &&
                          <p style={{ fontWeight: win === 2 ? 'bold' : 'normal' }}>
                            <span className="hall-single-name-right-margin">{frame.t2p2}</span>
                            {frame.t2n2}
                          </p>}
                      </div>
                    </div>
                    {this.renderFlag(isDouble, frame.t2c1, frame.t2c2)}
                  </div>
                </div>
              </td>
              <td className="hall-table-cell"></td>
            </tr>
          );
        }
        if (started && !ended) {
          return (
            <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "F" + frame.frm}>
              <td className="hall-table-cell"></td>
              <td className="hall-table-cell">
                <div className="hall-frame" style={{ marginBottom: f === match.sets[currentSet].frms.length - 1 ? '.5rem' : 0 }}>
                  <div className={isDouble ? "hall-double-left-live" : "hall-single-left-live"} style={{ backgroundColor: categ.live.blive, color: categ.live.flive }}>
                    {this.renderFlag(isDouble, frame.t1c1, frame.t1c2)}
                    <div className="hall-single-fill">
                      <div className={isDouble ? "hall-double-name-left" : "hall-single-name-left"}>
                        <p style={{ fontWeight: 'normal' }}>
                          <span className="hall-single-name-left-margin">{frame.t1p1}</span>
                          {frame.t1n1 + Global.get6RS(frame.sh1)}
                        </p>
                        {isDouble &&
                          <p style={{ fontWeight: 'normal' }}>
                            <span className="hall-single-name-left-margin">{frame.t1p2}</span>
                            {frame.t1n2}
                          </p>
                        }
                      </div>
                      {this.renderScore1Frame(match, frame)}
                    </div>
                  </div>
                  <div className={isDouble ? "hall-double-right-live" : "hall-single-right-live"} style={{ backgroundColor: categ.live.blive, color: categ.live.flive }}>
                    <div className={isDouble ? "hall-double-right-name" : "hall-single-right-name"}>
                      {this.renderScore2Frame(match, frame)}
                      <div className={isDouble ? "hall-double-name-right" : "hall-single-name-right"}>
                        <p style={{ fontWeight: 'normal' }}>
                          {Global.get6RS(frame.sh2)}
                          <span className="hall-single-name-right-margin">{frame.t2p1}</span>
                          {frame.t2n1}
                        </p>
                        {isDouble &&
                          <p style={{ fontWeight: 'normal' }}>
                            <span className="hall-single-name-right-margin">{frame.t2p2}</span>
                            {frame.t2n2}
                          </p>}
                      </div>
                    </div>
                    {this.renderFlag(isDouble, frame.t2c1, frame.t2c2)}
                  </div>
                </div>
              </td>
              <td className="hall-table-cell"></td>
            </tr>
          )
        }
        if (!started && !match.me) {
          return (
            <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "F" + frame.frm}>
              <td className="hall-table-cell"></td>
              <td className="hall-table-cell">
                <div className="hall-frame" style={{ marginBottom: f === match.sets[currentSet].frms.length - 1 ? '.5rem' : 0 }}>
                  <div className={isDouble ? "hall-double-left-next" : "hall-single-left-next"} style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext }}>
                    {this.renderFlag(isDouble, frame.t1c1, frame.t1c2)}
                    <div className={isDouble ? "hall-double-fill" : "hall-single-fill"}>
                      <div className={isDouble ? "hall-double-name-left" : "hall-single-name-left"}>
                        <p><span className="hall-single-name-left-margin">{frame.t1p1}</span>{frame.t1n1}</p>
                        {isDouble &&
                          <p><span className="hall-single-name-left-margin">{frame.t1p2}</span>{frame.t1n2}</p>
                        }
                      </div>
                      <div className={isDouble ? "hall-double-schedule" : "hall-single-schedule"} style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext }}>
                      </div>
                    </div>
                  </div>
                  <div className={isDouble ? "hall-double-right-next" : "hall-single-right-next"} style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext }}>
                    <div className={isDouble ? "hall-double-right-name" : "hall-single-right-name"}>
                      <div className={isDouble ? "hall-double-name-right" : "hall-single-name-right"}>
                        <p><span className="hall-single-name-right-margin">{frame.t2p1}</span>{frame.t2n1}
                        </p>
                        {isDouble &&
                          <p><span className="hall-single-name-right-margin">{frame.t2p2}</span>{frame.t2n2}
                          </p>}
                      </div>
                    </div>
                    {this.renderFlag(isDouble, frame.t2c1, frame.t2c2)}
                  </div>
                </div>
              </td>
              <td className="hall-table-cell"></td>
            </tr>
          )
        }
        return null;
      })
    } else {
      return null;
    }
  }

  renderDoubleWinner(match, teamMatch) {
    const { t } = this.props;
    let { currentCateg, currentCountries, parms } = this.state;
    if (this.nameFound(match, teamMatch) === false) return null;
    if (currentCountries.length > 0) {
      if (currentCountries.findIndex(c => c === match.t1c1) < 0 &&
        currentCountries.findIndex(c => c === match.t2c1) < 0) {
        return null;
      }
    }
    let win = 0;
    if (Number(match.st1) > Number(match.st2) || match.sh1 < match.sh2) win = 1;
    if (Number(match.st2) > Number(match.st1) || match.sh2 < match.sh1) win = 2;
    if (win === 0) return null;
    const parm = parms.find(p => p.categ === match.c);
    const hasPhoto = parm && parm.winner.trim() !== "";
    return (
      <React.Fragment>
        <tr key={"h1Winner"}>
          <td colSpan={3} className="hall-table-cell">
            <h1 className="hall-categ-title" style={{ marginTop: '3rem' }}>
              {this.getCategLabel(currentCateg) + t('doubleWinner')}
            </h1>
          </td>
        </tr>
        {win === 1 &&
          <tr>
            <td className="hall-table-cell">
            </td>
            <td className="hall-table-cell">
              <div className="hall-single">
                <div className="hall-double-qualified" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(true, match.t1c1, match.t1c2, match.tm1)}
                  <div className="hall-single-q-fill">
                    <div className="hall-double-name-left" style={{ alignItems: 'center' }}>
                      {Number(match.s1) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                        {match.s1}
                      </Label>}
                      <p><span className="hall-single-name-left-margin">{match.t1p1}</span>{match.t1n1}</p>
                      {match.t1n2 !== "" && <p><span className="hall-single-name-left-margin">{match.t1p2}</span>{match.t1n2}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>}
        {win === 2 &&
          <tr>
            <td className="hall-table-cell">
            </td>
            <td className="hall-table-cell">
              <div className="hall-single">
                <div className="hall-double-qualified" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(true, match.t2c1, match.t2c2, match.tm2)}
                  <div className="hall-single-q-fill">
                    {Number(match.s2) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                      {match.s2}
                    </Label>}
                    <div className="hall-double-name-left">
                      <p>
                        <span className="hall-single-name-left-margin">{match.t2p1}</span>{match.t2n1}
                      </p>
                      <p>
                        <span className="hall-single-name-left-margin">{match.t2p2}</span>{match.t2n2}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>}
        {hasPhoto &&
          <tr key={"h1photo"}>
            <td colSpan={3} className="hall-table-cell">
              <img src={Global.localUrl + 'admin/photos/' + parm.winner} style={{ width: '90%', margin: '2rem' }} alt="..." />
            </td>
          </tr>}
      </React.Fragment>
    )
  }

  renderFlag(isDouble, c1, c2, tm) {
    if (!isDouble) {
      return (
        <div className="hall-single-flag-cont">
          {c1.trim() !== "" && <img src={Global.flagUrl + c1 + "-small.png"} className="hall-single-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />}
        </div>
      )
    } else {
      if (tm && tm.length > 0) {
        c1 = tm[0].c;
        c2 = tm[1].c;
      }
      if (c1 === c2) {
        return (
          <div className="hall-double-flag-cont">
            {c1.trim() !== "" && <img src={Global.flagUrl + c1 + "-small.png"} className="hall-double-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />}
          </div>
        )
      } else {
        return (
          <div style={{ display: 'flex' }}>
            <div className="hall-double-flag-cont" style={{ width: 28, overflow: 'hidden' }}>
              {c1.trim() !== "" && <img src={Global.flagUrl + c1 + "-small.png"} className="hall-double-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />}
            </div>
            <div className="hall-double-flag-cont" style={{ width: 28, overflow: 'hidden', transform: 'scaleX(-1)' }}>
              {c2.trim() !== "" && <img src={Global.flagUrl + c2 + "-small.png"} className="hall-double-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />}
            </div>
          </div>
        )
      }
    }
  }

  renderGroupHeader(phase, grp) {
    const { t } = this.props;
    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        {t('group', { grp: Global.getGroupLabel(phase, grp) })}
      </div>
    )
  }

  renderGroups() {
    const { t } = this.props;
    let { currentGroup, currentPhase, tables } = this.state;
    if (!currentPhase || Number(currentPhase.nbGrps) <= 1) return null;
    return (
      <div>
        {new Array(Number(currentPhase.nbGrps)).fill(0).map((e, index) => {
          const isLive = tables && tables.filter(t => t.p === currentPhase.code && Number(t.g) === index && t.ms && !t.me).length > 0;
          return (
            <Button key={"grp" + index}
              style={{ margin: '0.5rem', background: currentGroup === index ? '#777' : '#333', color: currentGroup === index ? 'black' : 'white' }}
              onClick={() => this.setCurrentGroup(index)}>
              {t('group', { grp: Global.getGroupLabel(currentPhase, index) })}
              {isLive && <span className="hall-categ-live-dot">●</span>}
            </Button>
          )
        })}
      </div>
    )
  }

  renderGroupPlayers(phase, group) {
    const { t } = this.props;
    let { ctgs, currentCateg, searchName } = this.state;
    if (!ctgs) return null;
    const ctg = ctgs.find(c => Number(c.code) === Number(currentCateg.code));
    if (!ctg) return null;
    const ph = ctg.phases.find(p => p.code === Number(phase));
    const grp = ph.grps.find(g => Number(g.code) === Number(group));
    if (searchName.trim() !== "") {
      let nameFound = false;
      grp.players.forEach(rank => {
        if (rank.n.toUpperCase().includes(searchName.trim().toUpperCase()) ||
          rank.p.toUpperCase().includes(searchName.trim().toUpperCase())) {
          nameFound = true;
        }
      })
      if (!nameFound) return null;
    }
    if (grp.players.length === 0) return (
      <tr>
        <td colSpan={3} className="hall-table-col2" style={{ overflow: 'hidden' }}>
          <h4 className="hall-categ-title">{t('notyetranking')}</h4>
        </td>
      </tr>
    )
    return (
      <tr>
        <td colSpan={3} className="hall-table-col2" style={{ overflow: 'scroll' }}>
          <Table celled unstackable inverted style={{ marginBottom: '2rem' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>{t('rnkPos')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>{t('rnkName')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>{t('rnkTeam')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>{t('rnkPlayed')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>{t('rnkWon')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>%</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {grp.players.map((rank, r) => {
                return (
                  <Table.Row key={grp.code + "rank" + r} style={{ fontWeight: 'normal' }}>
                    <Table.Cell textAlign='center'>{(r + 1)}</Table.Cell>
                    <Table.Cell textAlign="left">
                      <div className="hall-single-flag-cont" style={{ marginRight: '.5rem', float: 'left' }}>
                        {rank.c.trim() !== "" && <img src={Global.flagUrl + rank.c + "-small.png"} className="hall-single-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />}
                      </div>
                      <span onClick={(e) => this.setCurrentPlayer(rank.i, false)} style={{ display: 'flex', alignItems: 'center', height: 32, cursor: 'pointer' }}>
                        {(rank.p + " " + rank.n)}
                      </span>
                    </Table.Cell>
                    <Table.Cell textAlign="left">
                      {(rank.t)}
                    </Table.Cell>
                    <Table.Cell textAlign='center'>{rank.played}</Table.Cell>
                    <Table.Cell textAlign='center'>{rank.won}</Table.Cell>
                    <Table.Cell textAlign='center'>{((rank.won / rank.played) * 100).toFixed(2) + "%"}</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
        </td>
      </tr>
    )
  }

  renderGroupRanking(phase, group) {
    const { t } = this.props;
    let { ctgs, currentCateg, currentEvent, grpDetail, searchName } = this.state;
    if (!ctgs) return null;
    const ctg = ctgs.find(c => Number(c.code) === Number(currentCateg.code));
    if (!ctg) return null;
    const ph = ctg.phases.find(p => p.code === Number(phase));
    if (ph.mode === "SE" || ph.mode === "2K") return null;
    const grp = ph.grps.find(g => Number(g.code) === Number(group));
    const nbQlfs = Number(ph.nbQlfs);
    const notDefined = grp.ranking.find(r => r.t1j1 === 0);
    if (notDefined) return null;
    if (searchName.trim() !== "") {
      let nameFound = false;
      grp.ranking.forEach(rank => {
        if (rank.t1n1.toUpperCase().includes(searchName.trim().toUpperCase()) ||
          rank.t1p1.toUpperCase().includes(searchName.trim().toUpperCase()) ||
          rank.t1n2.toUpperCase().includes(searchName.trim().toUpperCase()) ||
          rank.t1p2.toUpperCase().includes(searchName.trim().toUpperCase())) {
          nameFound = true;
        }
      })
      if (!nameFound) return null;
    }
    let hasPlayed = false;
    let hasShootout = false;
    let detailSpan = 8;
    if (Number(ph.mnull) === 1) detailSpan++;
    if (Number(ph.boSets) > 1) {
      detailSpan += 3;
      if (Number(ph.snull) === 1 && Number(ph.stied) !== 1) detailSpan++;
    }
    if (Number(ph.grptied) === 2) detailSpan++;
    grp.ranking.forEach(rank => {
      if (Number(rank.played) > 0) hasPlayed = true;
      if (rank.shootout && (currentEvent.state !== "C" || rank.sh)) hasShootout = true;
    })
    return (
      <tr>
        <td colSpan={3} className="hall-table-col2">
          <Table unstackable celled inverted style={{ marginBottom: '2rem' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell rowSpan={2} textAlign='center'>{t('rnkPos')}</Table.HeaderCell>
                <Table.HeaderCell rowSpan={2} textAlign='center'>{t('rnkName')}</Table.HeaderCell>
                <Table.HeaderCell colSpan={Number(ph.mnull) === 1 ? 4 : 3} textAlign='center'>{t('rnkMatchs')}</Table.HeaderCell>
                {Number(ph.boSets) > 1 && <Table.HeaderCell colSpan={Number(ph.snull) === 1 && Number(ph.stied) !== 1 ? 4 : 3} textAlign='center'>{t('rnkSets')}</Table.HeaderCell>}
                {Number(ph.grptied) === 2 && <Table.HeaderCell colSpan={3} textAlign='center'>{t('rnkFrms')}</Table.HeaderCell>}
                <Table.HeaderCell rowSpan={2} textAlign='center'>{t('rnkPts')}</Table.HeaderCell>
                {hasShootout && <Table.HeaderCell rowSpan={2} textAlign='center'>
                  <img src={Global.imgUrl + "6rs.png"} style={{ height: 24, width: 'auto' }} alt="..." />
                </Table.HeaderCell>}
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell textAlign='center' style={{ borderLeft: 1, borderLeftStyle: 'solid', borderLeftColor: 'rgba(34,36,38,.1)' }}>{t('rnkPlayed')}</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>{t('rnkWon')}</Table.HeaderCell>
                {Number(ph.mnull) === 1 && <Table.HeaderCell textAlign='center'>{t('rnkDraw')}</Table.HeaderCell>}
                <Table.HeaderCell textAlign='center'>{t('rnkLost')}</Table.HeaderCell>
                {Number(ph.boSets) > 1 &&
                  <React.Fragment>
                    <Table.HeaderCell textAlign='center'>{t('rnkPlayed')}</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>{t('rnkWon')}</Table.HeaderCell>
                    {Number(ph.snull) === 1 && Number(ph.stied) !== 1 && <Table.HeaderCell textAlign='center'>{t('rnkDraw')}</Table.HeaderCell>}
                    <Table.HeaderCell textAlign='center'>{t('rnkLost')}</Table.HeaderCell>
                  </React.Fragment>
                }
                {Number(ph.grptied) === 2 && <Table.HeaderCell textAlign='center'>{t('rnkFor')}</Table.HeaderCell>}
                {Number(ph.grptied) === 2 && <Table.HeaderCell textAlign='center'>{t('rnkAgainst')}</Table.HeaderCell>}
                {Number(ph.grptied) === 2 && <Table.HeaderCell textAlign='center'>{t('rnkDiff')}</Table.HeaderCell>}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {grp.ranking.map((rank, r) => {
                const isDouble = currentCateg.type === "D" || (currentCateg.type === "T" && currentCateg.nbTPlayers === 2 && currentCateg.nbTSubs === 0);
                const span = Number(rank.t1j2) > 0 || isDouble ? 2 : 1;
                grpDetail[rank] = grpDetail[rank] || false;
                if (rank.t1j1 < 0) return null;
                return (
                  <React.Fragment key={grp.code + "rank" + r}>
                    <Table.Row key={grp.code + "rank" + r} style={{ fontWeight: r < nbQlfs && hasPlayed ? 900 : 'normal' }}>
                      <Table.Cell rowSpan={span} textAlign='center'>{hasPlayed ? (r + 1) : "-"}</Table.Cell>
                      <Table.Cell style={{ display: "flex", alignItems: "center" }} textAlign="left"
                        onClick={() => {
                          grpDetail[r] = !grpDetail[r];
                          this.setState({ grpDetail });
                        }}>
                        {currentCateg.type === "T" && rank.t1c1.trim() !== "" &&
                          <img src={Global.flagUrl + rank.t1c1 + "-small.png"} className="hall-single-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />
                        }
                        {(isDouble ? rank.tm[0].p + " " + rank.tm[0].n : rank.t1p1 + " " + rank.t1n1)}
                      </Table.Cell>
                      <Table.Cell rowSpan={span} textAlign='center'>{rank.played}</Table.Cell>
                      <Table.Cell rowSpan={span} textAlign='center'>{rank.won}</Table.Cell>
                      {Number(ph.mnull) === 1 && <Table.Cell rowSpan={span} textAlign='center'>{rank.tie}</Table.Cell>}
                      <Table.Cell rowSpan={span} textAlign='center'>{rank.lost}</Table.Cell>
                      {Number(ph.boSets) > 1 &&
                        <React.Fragment>
                          <Table.Cell rowSpan={span} textAlign='center'>{rank.setplayed}</Table.Cell>
                          <Table.Cell rowSpan={span} textAlign='center'>{rank.setwon}</Table.Cell>
                          {Number(ph.snull) === 1 && Number(ph.stied) !== 1 && <Table.Cell rowSpan={span} textAlign='center'>{rank.settie}</Table.Cell>}
                          <Table.Cell rowSpan={span} textAlign='center'>{rank.setlost}</Table.Cell>
                        </React.Fragment>
                      }
                      {Number(ph.grptied) === 2 && <Table.Cell rowSpan={span} textAlign='center'>{rank.frmwon}</Table.Cell>}
                      {Number(ph.grptied) === 2 && <Table.Cell rowSpan={span} textAlign='center'>{rank.frmlost}</Table.Cell>}
                      {Number(ph.grptied) === 2 && <Table.Cell rowSpan={span} textAlign='center'>{rank.frmwon - rank.frmlost}</Table.Cell>}
                      <Table.Cell rowSpan={span} textAlign='center' style={{ color: r < nbQlfs && hasPlayed ? currentCateg.live.fsw : currentCateg.live.fsl }}>
                        {rank.points}
                        {rank.shootout && !rank.sh && currentEvent.state !== "C" && <img src={Global.imgUrl + "6rs.png"} style={{ height: 16, width: 'auto', marginLeft: 8 }} alt="..." />}
                      </Table.Cell>
                      {hasShootout && <Table.Cell rowSpan={span} textAlign='center'>
                        {rank.shootout && !rank.sh && currentEvent.state !== "C" && <img src={Global.imgUrl + "6rs.png"} style={{ height: 16, width: 'auto' }} alt="..." />}
                        {rank.shootout && rank.sh &&
                          <Label size={'big'} style={{ color: currentCateg.live.flive, backgroundColor: currentCateg.live.blive, fontWeight: 'normal' }}>
                            {Global.get6RSRanking(rank.sh)}
                          </Label>}
                        {!rank.shootout && "-"}
                      </Table.Cell>}
                    </Table.Row>
                    {Number(rank.t1j2) > 0 &&
                      <Table.Row key={grp.code + "rankD" + r} style={{ fontWeight: r < nbQlfs && hasPlayed ? 900 : 'normal' }}>
                        <Table.Cell style={{ borderLeft: 1, borderLeftStyle: 'solid', borderLeftColor: 'rgba(34,36,38,.1)' }} textAlign="left">{rank.t1p2 + " " + rank.t1n2}</Table.Cell>
                      </Table.Row>
                    }
                    {isDouble &&
                      <Table.Row key={grp.code + "rankD" + r} style={{ fontWeight: r < nbQlfs && hasPlayed ? 900 : 'normal' }}>
                        <Table.Cell style={{ borderLeft: 1, borderLeftStyle: 'solid', borderLeftColor: 'rgba(34,36,38,.1)' }} textAlign="left">{rank.tm[1].p + " " + rank.tm[1].n}</Table.Cell>
                      </Table.Row>
                    }
                    {grpDetail[r] && rank.res.length > 0 &&
                      <Table.Row>
                        <Table.Cell colSpan={detailSpan} align="center">
                          <table style={{ width: '80%', borderWidth: 2, borderStyle: 'solid', borderColor: currentCateg.live.bended, borderCollapse: 'collapse', margin: 'auto' }}>
                            <tbody>
                              {grpDetail[r] && rank.res.map((res, rs) => {
                                return (
                                  <tr key={"RES" + rs} style={{ width: '100%', display: 'flex' }}>
                                    <td style={{ width: '50%', borderColor: currentCateg.live.bended, borderWidth: 2, borderStyle: 'solid', display: "table-cell", textAlign: "left" }}>
                                      {currentCateg.type === "T" && res.c.trim() !== "" &&
                                        <img src={Global.flagUrl + res.c + "-small.png"} className="hall-single-flag" style={{ verticalAlign: 'middle' }} alt="..." onError={e => { e.target.style.display = 'none' }} />
                                      }
                                      {res.p + " " + res.n}
                                    </td>
                                    <td style={{ width: '20%', textAlign: 'center', borderColor: currentCateg.live.bended, borderWidth: 2, borderStyle: 'solid' }}>
                                      {Number(res.sc1) > Number(res.sc2) && t('rnkWon')}
                                      {Number(res.sc1) < Number(res.sc2) && t('rnkLost')}
                                      {Number(res.sc1) === Number(res.sc2) && t('rnkDraw')}
                                    </td>
                                    <td style={{ width: '30%', textAlign: 'center', borderColor: currentCateg.live.bended, borderWidth: 2, borderStyle: 'solid' }}>
                                      {res.sc1 + " - " + res.sc2}
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Table.Cell>
                      </Table.Row>
                    }
                    {grpDetail[r] && currentCateg.type === "T" && !isDouble && grp.players.length > 0 &&
                      <Table.Row>
                        <Table.Cell colSpan={detailSpan} textAlign="center">
                          <table style={{ width: '80%', borderWidth: 2, borderStyle: 'solid', borderColor: currentCateg.live.bended, borderCollapse: 'collapse', margin: 'auto' }}>
                            <thead>
                              <tr>
                                <th>{t('rnkPos')}</th>
                                <th>{t('rnkName')}</th>
                                <th>{t('rnkPlayed')}</th>
                                <th>{t('rnkWon')}</th>
                                <th>%</th>
                              </tr>
                            </thead>
                            <tbody>
                              {grp.players.map((player, p) => {
                                if (player.c !== rank.t1c1) return null;
                                return (
                                  <tr key={player.c + "rank" + p} style={{ fontWeight: 'normal' }}>
                                    <td align="center">{(p + 1)}</td>
                                    <td align="left">
                                      <div className="hall-single-flag-cont" style={{ marginRight: '.5rem', float: 'left' }}>
                                        <img src={Global.flagUrl + player.c + "-small.png"} className="hall-single-flag" alt="..." onError={e => { e.target.style.display = 'none' }} />
                                      </div>
                                      <span style={{ display: 'flex', alignItems: 'center', height: 32 }}>{(player.p + " " + player.n)}</span>
                                    </td>
                                    <td>{player.played}</td>
                                    <td>{player.won}</td>
                                    <td>{((player.won / player.played) * 100).toFixed(2) + "%"}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </Table.Cell>
                      </Table.Row>
                    }
                  </React.Fragment>
                )
              })}
            </Table.Body>
          </Table>
        </td>
      </tr>
    )
  }

  renderLive() {
    const { t } = this.props;
    let { categOptionsLive, currentCateg, currentEvent, liveOptions, lives, onlyOneEvent } = this.state;
    if (!lives || lives.length === 0 || !liveOptions || liveOptions.length === 0) {
      return (
        <div className="mainContainer">
          {onlyOneEvent && currentEvent && this.renderEventHeader()}
          {this.renderAppPromo()}
          <Segment inverted>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', height: '50vh', width: '100%' }}>
              <h1>{t('nolive')}</h1>
            </div>
          </Segment>
        </div>
      )
    }
    return (
      <div className="mainContainer">
        {!onlyOneEvent && this.renderEventSelect(liveOptions)}
        {this.renderAppPromo()}
        {this.renderCategSelect(categOptionsLive)}
        {currentEvent && this.renderEventHeader()}
        {(currentCateg || Number(currentCateg) === 0) && this.renderCategHeader()}
        {currentEvent && this.renderSearch()}
        {(currentCateg || Number(currentCateg) === 0) && this.renderPhases()}
        {currentEvent && this.renderBracket()}
        {(currentCateg || Number(currentCateg) === 0) && this.renderPhases()}
      </div>
    )
  }

  renderLiveNext() {
    const { t } = this.props;
    let { categs, categOptionsLive, currentCateg, currentEvent, liveOptions, lives, onlyOneEvent, tables } = this.state;
    if (!lives || lives.length === 0) {
      return (
        <div className="mainContainer">
          {onlyOneEvent && currentEvent && this.renderEventHeader()}
          <Segment inverted>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', height: '50vh', width: '100%' }}>
              <h1>{t('nolive')}</h1>
            </div>
          </Segment>
        </div>
      )
    }
    let prevCateg = null;
    let prevPhase = null;
    let prevGroup = null;
    return (
      <div className="mainContainer">
        {!onlyOneEvent && this.renderEventSelect(liveOptions)}
        {this.renderCategSelect(categOptionsLive)}
        {currentEvent && this.renderEventHeader()}
        {currentEvent && this.renderSearch()}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '96%' }}>
            <table className="hall-main-table">
              <tbody>
                <tr>
                  <td className="hall-table-col1">&nbsp;</td>
                  <td className="hall-table-col2">&nbsp;</td>
                  <td className="hall-table-col3">&nbsp;</td>
                </tr>
                {currentEvent && tables && tables.filter(t => t.c === currentCateg.code || Number(currentCateg.code) === 0).map((table) => {
                  const categ = categs.find(c => c.code === table.c);
                  if (!categ) return null;
                  const newCateg = prevCateg !== categ;
                  if (newCateg) {
                    prevPhase = null;
                    prevGroup = null;
                  }
                  prevCateg = categ;
                  const phase = categ.phases[Number(table.p)];
                  const newPhase = prevPhase !== phase;
                  if (newPhase) {
                    prevGroup = null;
                  }
                  prevPhase = phase;
                  const group = Number(table.g);
                  const newGroup = (prevGroup !== group) && (Number(phase.nbGrps) > 1);
                  prevGroup = group;
                  return (
                    <React.Fragment key={table.c + "P" + table.p + "G" + table.g + "S" + table.s + "R" + table.r}>
                      {newCateg && <tr>
                        <td colSpan={3} className="hall-table-col1">
                          {this.renderCategHeader(categ)}
                        </td>
                      </tr>}
                      {newPhase && <tr>
                        <td colSpan={3} className="hall-table-col2">
                          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                            {this.renderPhaseHeader(phase)}
                          </div>
                        </td>
                      </tr>}
                      {newGroup && <tr>
                        <td colSpan={3} className="hall-table-col2">
                          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                            {this.renderGroupHeader(phase, group)}
                          </div>
                        </td>
                      </tr>}
                      {this.renderMatch(categ, phase, table, false)}
                    </React.Fragment>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  renderMatch(categ, phase, match, newSession) {
    let { detail, showVideo } = this.state;
    const started = match.ms !== null;
    const teamMatch = categ.type === "T";
    const setMatch = Number(phase.boSets) > 1;
    const sessionMatch = Number(phase.nbSs) > 1;
    const forfeit = Number(match.st1) < 0 || Number(match.st2) < 0;
    const showDetail = detail && !setMatch && match.c === detail.c && match.p === detail.p && match.g === detail.g && match.s === detail.s && match.r === detail.r;
    const key = "C" + match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r;
    return (
      <React.Fragment key={key}>
        {this.renderMatchDetail(categ, phase, match, showDetail, teamMatch, newSession)}
        {setMatch && !sessionMatch && started && !forfeit && match.sets.map((set) => {
          const showSetDetail = detail && setMatch && match.c === detail.c && match.p === detail.p && match.g === detail.g && match.s === detail.s && match.r === detail.r && set.set === detail.set;
          return (
            <React.Fragment key={"CS" + match.c + set.set + "P" + match.p + match.g + match.s + match.r}>
              {set.st && set.se && this.renderSetEnded(match, set, showSetDetail, teamMatch)}
              {set.st && !set.se && this.renderSetLive(match, set, showSetDetail, teamMatch)}
              {!set.st && this.renderSetNext(match, set, teamMatch)}
              {this.renderDetail(showSetDetail, categ, match, set)}
            </React.Fragment>
          )
        }
        )}
        {sessionMatch && !forfeit && match.sets.map((set) => {
          const showSetDetail = detail && sessionMatch && match.c === detail.c && match.p === detail.p && match.g === detail.g && match.s === detail.s && match.r === detail.r && set.set === detail.set;
          return (
            <React.Fragment key={"CS" + match.c + set.set + "S" + set.ss + "P" + match.p + match.g + match.s + match.r}>
              {set.st && set.se && this.renderSessionEnded(categ, phase, match, set, showSetDetail, teamMatch)}
              {set.st && !set.se && this.renderSessionLive(categ, phase, match, set, showSetDetail, teamMatch)}
              {!set.st && this.renderSessionNext(categ, phase, match, set, teamMatch)}
              {this.renderDetail(showSetDetail, categ, match, set)}
            </React.Fragment>
          )
        }
        )}
        {showVideo && showVideo.e === match.e && showVideo.c === match.c && showVideo.p === match.p && showVideo.g === match.g && showVideo.s === match.s && showVideo.r === match.r && match.v !== "" && this.renderVideo(match)}
        {this.renderDetail(showDetail, categ, match)}
      </React.Fragment>
    );
  }

  renderMatchDetail(categ, phase, match, showDetail, teamMatch, newSession) {
    const { t } = this.props;
    let { categs, currentCountries } = this.state;
    if (this.nameFound(match, teamMatch) === false) return null;
    if (currentCountries.length > 0) {
      if (currentCountries.findIndex(c => c === match.t1c1) < 0 &&
        currentCountries.findIndex(c => c === match.t2c1) < 0) {
        return null;
      }
    }
    const nbSs = Number(phase.nbSs);
    let ended = match.me !== null && match.ms !== null;
    let live = match.ms !== null && match.me === null;
    let next = match.ms === null && match.me === null;
    if (nbSs > 1) {
      ended = ended || (match.sets.findIndex(s => s.se === null) < 0);
      live = (match.sets.findIndex(s => s.st !== null && s.se === null) >= 0);
      next = !ended && !live;
    }
    let win = 0;
    let tableNames = "";
    let back = categ.live.bended;
    let fore = categ.live.fended;
    let suffix = "ended";
    let backScore = "rgb(10, 10, 73)";
    if (ended) {
      if (Number(match.st1) > Number(match.st2) || match.sh1 < match.sh2) win = 1;
      if (Number(match.st2) > Number(match.st1) || match.sh2 < match.sh1) win = 2;
    } else {
      back = live ? categ.live.blive : categ.live.bnext;
      fore = live ? categ.live.flive : categ.live.fnext;
      suffix = live ? "live" : "next";
      if (nbSs > 1) {
        suffix = live ? "live" : next && !match.ms ? "next" : "ended";
        if (next && match.ms) backScore = Global.getNearColor(back, 32);
      }
    }
    if (!ended || !match.me) {
      if (!match.tn || match.tn.trim() === "" || match.tn.trim() === "0") {
        match.tn = "";
      }
      tableNames = match.tn.trim();
      if (Number(phase.nbTables) > 1 && match.tn.trim() !== "" && match.tn.trim() !== "0") {
        tableNames = "Tables " + match.t1;
        if (Number(match.t2) > 0) tableNames += " & " + match.t2;
        if (Number(match.t3) > 0) tableNames += " & " + match.t3;
      }
    }
    const isDouble = categ.type === "D" || (teamMatch && (categ.nbTPlayers === 2 && categ.nbTSubs === 0));
    const info = this.getMatchInfo(match, teamMatch, isDouble);
    const gp1 = match.t1n1.substring(match.t1n1.length - 1);
    const gp2 = match.t2n1.substring(match.t2n1.length - 1);
    const portal1 = Number(match.t1j1) === 0 && (gp1 === "G" || gp1 === "P");
    const portal2 = Number(match.t2j1) === 0 && (gp2 === "G" || gp2 === "P");
    return (
      <tr>
        <td colSpan={3} style={{ paddingTop: newSession ? '2rem' : 1 }}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="hall-table-id-cont">
                <p className="hall-table-id">{Global.formatID(phase, match)}</p>
              </div>
              <div className="hall-categ-live-table-cont">
                {!match.me && match.tn.trim() !== "" && match.tn.trim() !== "0" &&
                  <Label horizontal size={'small'} className='hall-categ-live-table' style={{ color: fore, backgroundColor: live ? 'green' : back }}>
                    {tableNames}
                    {match.v !== "" && <Icon name="video" style={{ marginLeft: 8, cursor: 'pointer' }} inverted onClick={(e) => this.swapVideo(match)} />
                    }
                  </Label>}
              </div>
            </div>
            <div className='hall-match-cont'>
              <div className="hall-single" style={{ alignItems: next && !match.ms ? 'flex-start' : 'unset' }}>
                <div className={isDouble ? "hall-double-left-" + suffix : "hall-single-left-" + suffix} style={{ backgroundColor: back, color: fore }}>
                  {this.renderFlag(isDouble, match.t1c1, match.t1c2, match.tm1)}
                  <div className="hall-single-fill">
                    {match.sh1 && <Label size={'small'} style={{ marginRight: '1rem', color: fore, backgroundColor: Global.getNearColor(back, 32), fontWeight: 'normal' }}>
                      {Global.get6RSRanking(match.sh1)}
                    </Label>}
                    <div className={isDouble ? "hall-double-name-left pointer" : "hall-single-name-left pointer"}>
                      {Number(match.s1) > 0 && <Label circular size={'small'} style={{ color: fore, backgroundColor: Global.getNearColor(back, 32), marginRight: '.5rem' }}>
                        {match.s1}
                      </Label>}
                      {portal1 ? <Popup on='click' flowing hideOnScroll
                        style={{ opacity: 0.85 }}
                        position='top center'
                        trigger={<p>
                          <span className="hall-single-name-left-margin">{info.t1p1}</span>
                          {Global.getPlayerName(t, categs, categ, match, info.t1j1, info.t1n1)}
                        </p>}>
                        <Popup.Content>
                          {this.renderPlayerCard(match, 1)}
                        </Popup.Content>
                      </Popup>
                        :
                        <p style={{ fontWeight: win === 1 ? 'bold' : 'normal' }} onClick={(e) => this.setCurrentPlayer(info.t1j1, teamMatch, match.tm1, e)}>
                          <span className="hall-single-name-left-margin">{info.t1p1}</span>
                          {Number(info.t1j1) > 0 ?
                            info.t1n1
                            :
                            Global.getPlayerName(t, categs, categ, match, info.t1j1, info.t1n1)
                          }
                        </p>}
                      {isDouble &&
                        <p style={{ fontWeight: win === 1 ? 'bold' : 'normal' }} onClick={(e) => this.setCurrentPlayer(info.t1j2, teamMatch, match.tm1)}>
                          <span className="hall-single-name-left-margin">{info.t1p2}</span>
                          {info.t1n2}
                        </p>}
                    </div>
                    {(!next || match.ms) && <div className='hall-single-score1' style={{ borderColor: back, backgroundColor: backScore }}>
                      {this.renderScore1Col(match, showDetail, teamMatch)}
                    </div>}
                    {next && !match.ms && <div>
                      {teamMatch ?
                        <div className={isDouble ? "hall-double-schedule" : "hall-single-schedule"} onClick={showDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r)} style={{ backgroundColor: Global.getNearColor(back, 32), borderColor: back, color: fore, cursor: 'pointer' }}>
                          <p className='hall-schedule-time'>{match.mc ? this.getLocalTime(match.mc) : "TBC"}</p>
                        </div>
                        :
                        <div className="hall-single-schedule" style={{ backgroundColor: Global.getNearColor(back, 32), borderColor: back, color: fore }}>
                          <p className='hall-schedule-time'>{match.mc ? this.getLocalTime(match.mc) : "TBC"}</p>
                        </div>
                      }
                    </div>}
                  </div>
                </div>
                <div className={isDouble ? "hall-double-right-" + suffix : "hall-single-right-" + suffix} style={{ backgroundColor: back, color: fore }}>
                  <div className={isDouble ? "hall-double-right-name" : "hall-single-right-name"}>
                    {(!next || match.ms) && <div className='hall-single-score2' style={{ borderColor: back, backgroundColor: backScore }}>
                      {this.renderScore2Col(match, showDetail, teamMatch)}
                    </div>}
                    <div className={isDouble ? "hall-double-name-right pointer" : "hall-single-name-right pointer"}>
                      <div className="hall-double-name-right-cont">
                        {portal2 ? <Popup on='click' flowing hideOnScroll
                          style={{ opacity: 0.85 }}
                          position='top center'
                          trigger={<p>
                            <span className="hall-single-name-right-margin">{info.t2p1}</span>
                            {Global.getPlayerName(t, categs, categ, match, info.t2j1, info.t2n1)}
                          </p>}>
                          <Popup.Content>
                            {this.renderPlayerCard(match, 2)}
                          </Popup.Content>
                        </Popup>
                          :
                          <p style={{ fontWeight: win === 2 ? 'bold' : 'normal' }} onClick={(e) => this.setCurrentPlayer(info.t2j1, teamMatch, match.tm2)}>
                            <span className="hall-single-name-right-margin">{info.t2p1}</span>
                            {Global.getPlayerName(t, categs, categ, match, info.t2j1, info.t2n1)}
                          </p>}
                        {isDouble &&
                          <p style={{ fontWeight: win === 2 ? 'bold' : 'normal' }} onClick={(e) => this.setCurrentPlayer(info.t2j2, teamMatch, match.tm2)}>
                            <span className="hall-single-name-right-margin">{info.t2p2}</span>
                            {info.t2n2}
                          </p>}
                      </div>
                      {Number(match.s2) > 0 && <Label circular size={'small'} style={{ color: fore, backgroundColor: Global.getNearColor(back, 32), marginLeft: '.5rem', marginRight: '.5rem' }}>
                        {match.s2}
                      </Label>}
                      {match.sh2 && <Label size={'small'} style={{ marginLeft: '1rem', marginRight: '1rem', color: fore, backgroundColor: Global.getNearColor(back, 32), fontWeight: 'normal' }}>
                        {Global.get6RSRanking(match.sh2)}
                      </Label>}
                    </div>
                  </div>
                  {this.renderFlag(isDouble, match.t2c1, match.t2c2, match.tm2)}
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    )
  }

  renderPhaseHeader(phase) {
    const { t } = this.props;
    const showQualified = phase.mode.substr(1, 1) === "Q";
    return (
      <React.Fragment key={"H2" + phase.code}>
        <tr ref={(el) => { this.tagPhase[phase.code] = el; }}>
          <td className="hall-table-cell">&nbsp;</td>
          <td>
            <h2 className="hall-text-center" style={{ marginTop: '1rem', marginBottom: 0, display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center' }}>
              {phase.show === false && Number(phase.autohide) === 1 &&
                <img src={Global.imgUrl + "expand.svg"} onClick={() => this.swapHidePhase(phase)} style={{ marginRight: 8, cursor: 'pointer' }} alt="Expand" height="32px" width="32px" />
              }
              {phase.show === true && Number(phase.autohide) === 1 &&
                <img src={Global.imgUrl + "collapse.svg"} onClick={() => this.swapHidePhase(phase)} style={{ marginRight: 8, cursor: 'pointer' }} alt="Collapse" height="32px" width="32px" />
              }
              {phase.lib}
              {phase.show === false && Number(phase.autohide) === 1 &&
                <img src={Global.imgUrl + "expand.svg"} onClick={() => this.swapHidePhase(phase)} style={{ marginLeft: 8, cursor: 'pointer' }} alt="Expand" height="32px" width="32px" />
              }
              {phase.show === true && Number(phase.autohide) === 1 &&
                <img src={Global.imgUrl + "collapse.svg"} onClick={() => this.swapHidePhase(phase)} style={{ marginLeft: 8, cursor: 'pointer' }} alt="Collapse" height="32px" width="32px" />
              }
            </h2>
          </td>
          <td className="hall-table-cell">&nbsp;</td>
        </tr>
        {Number(phase.boSets) > 1 && !showQualified && phase.show !== false &&
          <tr>
            <td className="hall-table-cell">&nbsp;</td>
            <td>
              <h5 className="hall-categ-bestof">
                {Number(phase.mdSets) === 0 && t('bestOfSets', { sets: phase.boSets })}
                {Number(phase.mdSets) === 1 && t('firstToSets', { sets: phase.boSets })}
                {Number(phase.mdSets) === 2 && t('fixedSets', { sets: phase.boSets })}
              </h5>
            </td>
            <td className="hall-table-cell">&nbsp;</td>
          </tr>
        }
        {!showQualified && phase.show !== false &&
          <tr>
            <td className="hall-table-cell">&nbsp;</td>
            <td>
              <h5 className="hall-categ-bestof">
                {Number(phase.mdFrames) === 0 && t('bestOfFrms', { frms: phase.boFrames })}
                {Number(phase.mdFrames) === 1 && t('firstToFrms', { frms: phase.boFrames })}
                {Number(phase.mdFrames) === 2 && t('fixedFrms', { frms: phase.boFrames })}
                {Number(phase.mdFrames) === 3 && t('nolimit')}
              </h5>
            </td>
            <td className="hall-table-cell">&nbsp;</td>
          </tr>}
      </React.Fragment >
    )
  }

  renderPhases() {
    let { currentCateg, currentPhase, tables } = this.state;
    if (!currentCateg || !currentCateg.phases) return null;
    return (
      <Step.Group stackable='tablet' style={{ width: '96%' }}>
        {currentCateg.phases.map((p, idx) => {
          const isLive = tables && tables.filter(t => t.p === p.code && t.ms && !t.me).length > 0;
          const hide = tables && tables.filter(t => t.p === p.code).length === 0;
          return (
            <Step key={"PH" + idx}
              active={currentPhase && currentPhase.code === p.code}
              disabled={hide}
              onClick={() => { this.scrollToPhase(idx) }}>
              <Step.Content>
                <Step.Title className='row-center'>
                  {p.lib}
                  {isLive && <span className="hall-categ-live-dot">●</span>}
                </Step.Title>
              </Step.Content>
            </Step>
          )
        }
        )}
      </Step.Group>
    )
  }

  renderPlayerCard(m, num) {
    const { t } = this.props;
    let { categs, tables } = this.state;
    let id = (num === 1 ? m.t1n1 : m.t2n1);
    const gp = id.substring(id.length - 1);
    if (gp !== "G" && gp !== "P") return null;
    id = id.substring(0, id.length - 1);
    const match = tables.find(t => t.id === id);
    if (!match) return null;
    const categ = categs.find(c => c.code === match.c);
    const isDouble = categ.type === "D" || (categ.type === "T" && (match.tm1.length === 2 || match.tm2.length === 2));
    let t1j1 = match.t1j1;
    let t2j1 = match.t2j1;
    let t1n1 = match.t1n1;
    let t1n2 = match.t1n2;
    let t2n1 = match.t2n1;
    let t2n2 = match.t2n2;
    let t1p1 = match.t1p1;
    let t1p2 = match.t1p2;
    let t2p1 = match.t2p1;
    let t2p2 = match.t2p2;
    if (isDouble && match.tm1 && match.tm1.length > 0 && match.tm2 && match.tm2.length > 0) {
      t1j1 = match.tm1[0].i;
      t2j1 = match.tm2[0].i;
      t1n1 = match.tm1[0].n;
      t1n2 = match.tm1[1].n;
      t2n1 = match.tm2[0].n;
      t2n2 = match.tm2[1].n;
      t1p1 = match.tm1[0].p;
      t1p2 = match.tm1[1].p;
      t2p1 = match.tm2[0].p;
      t2p2 = match.tm2[1].p;
    }
    if (Number(match.t1j1) === 0) {
      t1n1 = Global.getPlayerName(t, categs, categ, match, t1j1, t1n1);
      t1n2 = "";
      t1p1 = "";
      t1p2 = "";
    }
    if (Number(match.t2j1) === 0) {
      t2n1 = Global.getPlayerName(t, categs, categ, match, t2j1, t2n1);
      t2n2 = "";
      t2p1 = "";
      t2p2 = "";
    }
    return (
      <Segment inverted>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: categ.live.bnext, color: categ.live.fnext, borderRadius: '1rem', padding: '.5rem' }}>
          {!match.ms && <div>
            {match.mc ?
              <p style={{ textAlign: 'center', fontSize: '.7rem' }}>
                {this.getLocalDate(match.mc)}<br />
                {this.getLocalTime(match.mc)}
              </p>
              :
              "TBC"}
          </div>}
          <div className={isDouble ? "hall-double-left-next" : "hall-single-left-next"} style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext, width: 'unset' }}>
            {this.renderFlag(isDouble, match.t1c1, match.t1c2, match.tm1)}
            <div className="hall-single-fill">
              <div className={isDouble ? "hall-double-name-left" : "hall-single-name-left"}>
                {Number(match.s1) > 0 && <Label circular size={'small'} style={{ color: categ.live.fnext, backgroundColor: Global.getNearColor(categ.live.bnext, 32), marginRight: '.5rem' }}>
                  {match.s1}
                </Label>}
                <p style={{ fontWeight: 'normal' }}>
                  <span className="hall-single-name-left-margin">{t1p1}</span>
                  {t1n1}
                </p>
                {isDouble &&
                  <p style={{ fontWeight: 'normal' }}>
                    <span className="hall-single-name-left-margin">{t1p2}</span>
                    {t1n2}
                  </p>
                }
              </div>
            </div>
          </div>
          <div className={isDouble ? "hall-double-left-next" : "hall-single-left-next"} style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext, width: 'unset' }}>
            {this.renderFlag(isDouble, match.t2c1, match.t2c2, match.tm2)}
            <div className="hall-single-fill">
              <div className={isDouble ? "hall-double-name-left" : "hall-single-name-left"}>
                {Number(match.s2) > 0 && <Label circular size={'small'} style={{ color: categ.live.fnext, backgroundColor: Global.getNearColor(categ.live.bnext, 32), marginRight: '.5rem' }}>
                  {match.s2}
                </Label>}
                <p style={{ fontWeight: 'normal' }}>
                  <span className="hall-single-name-left-margin">{t2p1}</span>
                  {t2n1}
                </p>
                {isDouble &&
                  <p style={{ fontWeight: 'normal' }}>
                    <span className="hall-single-name-left-margin">{t2p2}</span>
                    {t2n2}
                  </p>
                }
              </div>
            </div>
          </div>
        </div>
      </Segment>
    )
  }

  renderProfile() {
    const { t } = this.props;
    let { currentOrg, showModal } = this.state;
    if (!showModal.open) return null;
    const player = showModal.player;
    const orgbio = Global.getOrgBio(currentOrg, player);
    if (showModal.teamMatch) {
      return this.renderProfileTeam();
    }
    return (
      <Modal open={showModal.open} inverted closeIcon onClose={() => this.setModalClose()} /*style={{ top: window.top.scrollY }}*/>
        <Modal.Header>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h1>{player.prenom + ' ' + player.nom}</h1>
              {player.meta.nick && <h3 style={{ marginBottom: 0, fontStyle: 'italic' }}>{"'" + player.meta.nick + "'"}</h3>}
              {/*<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Rating maxRating={5} defaultRating={3.5} icon='star' size='large' />
                <p style={{ marginLeft: '1rem', marginRight: '1rem', marginTop: 0, marginBottom: 0 }}>{"(3.5)"}</p>
              </div>*/}
            </div>
            <div>
              {player.meta.photo && <Image src={Global.playerUrl + player.meta.photo} size='small' circular />}
            </div>
          </div>
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description style={{ maxWidth: '100%' }}>
            <Menu pointing inverted secondary stackable>
              <Menu.Item name={t('stats')} active={showModal.item === 'stats'} onClick={(e) => this.setModalItem('stats')} />
              {player.meta.bio && <Menu.Item name='Bio' active={showModal.item === 'bio'} onClick={(e) => this.setModalItem('bio')} />}
              {orgbio && <Menu.Item name={currentOrg.toUpperCase() + ' Info'} active={showModal.item === 'org'} onClick={(e) => this.setModalItem('org')} />}
              {showModal.next && <Menu.Item name={t('nextMatches')} active={showModal.item === 'next'} onClick={(e) => this.setModalItem('next')} />}
            </Menu>
            <Segment inverted>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {showModal.item === 'bio' && this.renderProfileBio()}
                {showModal.item === 'org' && this.renderProfileOrg()}
                {showModal.item === 'stats' && this.renderProfileStats()}
                {showModal.item === 'next' && this.renderProfileNext()}
              </div>
            </Segment>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setModalClose()} secondary>{t('close')}</Button>
        </Modal.Actions>
      </Modal>
    )
  }

  renderProfileBio() {
    let { showModal } = this.state;
    const player = showModal.player;
    const lines = player.meta.bio ? player.meta.bio.split('\n') : [];
    return (
      <Container text>
        {lines.map((l, idx) => {
          return (
            <p key={"BIO" + idx}>{l}</p>
          )
        })}
      </Container>
    )
  }

  renderProfileNext() {
    const { t } = this.props;
    let { showModal } = this.state;
    const player = showModal.player;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <Segment inverted style={{ width: '100%' }}>
          <Item.Group divided>
            {showModal.next && showModal.next.map((match, idx) => {
              let adv = match.t1p1 + " " + match.t1n1;
              if (Number(player.code) === Number(match.t1j1)) {
                adv = match.t2p1 + " " + match.t2n1;
              }
              return (
                <Item key={"NEXT" + idx}>
                  <Item.Content>
                    <Item.Header style={{ color: 'white', display: 'flex' }}>
                      {this.getLocalDate(match.mc) + " - " + this.getLocalTime(match.mc)}
                      {moment().isSame(moment(match.mc), 'day') && <Label size={'small'} style={{ marginLeft: '1rem', color: 'white', backgroundColor: 'rgba(0,0,0,.5)', fontWeight: 'normal' }}>{t('today')}</Label>}
                    </Item.Header>
                    <Item.Description style={{ color: 'white' }}>
                      {Global.replaceParm(match.cn, match.parm) + " - " + match.pn}
                    </Item.Description>
                    {match.type === "S" && <Item.Extra style={{ color: 'grey' }}>{t('versus') + adv}</Item.Extra>}
                    {match.type === "T" && <Item.Extra style={{ color: 'grey' }}>{match.t1n1 + " / " + match.t2n1}</Item.Extra>}
                  </Item.Content>
                </Item>
              )
            }
            )}
          </Item.Group>
        </Segment>
      </div>
    )
  }

  renderProfileOrg() {
    let { currentOrg, showModal } = this.state;
    const player = showModal.player;
    const orgbio = Global.getOrgBio(currentOrg, player);
    if (!orgbio) return null;
    const linesBio = orgbio.split('\n');
    const linesRec = player.meta.record ? player.meta.record.split('\n') : [];
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {linesRec.length > 0 &&
          <React.Fragment>
            <List inverted style={{ margin: '1rem' }}>
              {linesRec.map((l, idx) => {
                return (
                  <List.Item key={"REC" + idx}>
                    <Icon name='trophy' color='yellow' />
                    <List.Content>
                      <List.Header>{l}</List.Header>
                    </List.Content>
                  </List.Item>
                )
              })}
            </List>
            <Divider horizontal />
          </React.Fragment>}
        <Container text>
          {linesBio.map((l, idx) => {
            return (
              <p key={"BIO" + idx}>{l}</p>
            )
          })}
        </Container>
      </div>
    )
  }

  renderProfileStats() {
    const { t } = this.props;
    let { saisons, showModal } = this.state;
    let options = [{ key: 0, text: t('allseasons'), value: 0 }];
    saisons.filter(s => Number(s.saison) !== 0).forEach((s) => {
      options.push({ key: s.saison, text: s.saison, value: s.saison });
    })
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <Dropdown
          placeholder={t('selectseason')}
          selection
          options={options}
          style={{ background: 'inherit', color: 'inherit', textAlign: 'center' }}
          value={showModal ? showModal.season : 0}
          onChange={(e, data) => { this.setStatSeason(data.value) }}
        />
        <Menu pointing inverted secondary stackable>
          <Menu.Item name={t('main')} active={showModal.statitem === 'main'} onClick={(e) => this.setModalStatItem('main')} />
          <Menu.Item name={t('shootout')} active={showModal.statitem === 'shoot'} onClick={(e) => this.setModalStatItem('shoot')} />
          <Menu.Item name={t('headtoheads')} active={showModal.statitem === 'head'} onClick={(e) => this.setModalStatItem('head')} />
        </Menu>
        <Segment inverted style={{ width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100% !important' }}>
            {showModal.statitem === 'main' && this.renderStatsMain()}
            {showModal.statitem === 'shoot' && this.renderStatsShoot()}
            {showModal.statitem === 'head' && this.renderStatsHead()}
          </div>
        </Segment>
      </div>
    )
  }

  renderProfileTeam() {
    const { t } = this.props;
    let { showModal } = this.state;
    if (!showModal.open) return null;
    const team = showModal.player;
    return (
      <Modal open={showModal.open} inverted closeIcon onClose={() => this.setModalClose()}>
        <Modal.Header>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h1 style={{ display: 'flex' }}>
                {/*this.renderFlag(false, team.players[0].c, "", null)*/}
                {team.name}
              </h1>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description style={{ maxWidth: '100%' }}>
            <Menu pointing inverted secondary stackable>
              <Menu.Item name={t('players')} active={showModal.item === 'stats'} onClick={(e) => this.setModalItem('stats')} />
              {showModal.next && <Menu.Item name={t('nextMatches')} active={showModal.item === 'next'} onClick={(e) => this.setModalItem('next')} />}
            </Menu>
            <Segment inverted>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {showModal.item === 'stats' && this.renderProfileTeamStats()}
                {showModal.item === 'next' && this.renderProfileTeamNext()}
              </div>
            </Segment>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setModalClose()} secondary>{t('close')}</Button>
        </Modal.Actions>
      </Modal>
    )
  }

  renderProfileTeamNext() {
    const { t } = this.props;
    let { showModal } = this.state;
    const team = showModal.player;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <Segment inverted style={{ width: '100%' }}>
          <Item.Group divided>
            {showModal.next && showModal.next.map((match, idx) => {
              let adv = match.t1n1;
              if (Number(team.code) === Number(match.t1j1)) {
                adv = match.t2n1;
              }
              return (
                <Item key={"NEXT" + idx}>
                  <Item.Content>
                    <Item.Header style={{ color: 'white', display: 'flex' }}>
                      {this.getLocalDate(match.mc) + " - " + this.getLocalTime(match.mc)}
                      {moment().isSame(moment(match.mc), 'day') && <Label size={'small'} style={{ marginLeft: '1rem', color: 'white', backgroundColor: 'rgba(0,0,0,.5)', fontWeight: 'normal' }}>{t('today')}</Label>}
                    </Item.Header>
                    <Item.Description style={{ color: 'white' }}>
                      {Global.replaceParm(match.cn, match.parm) + " - " + match.pn}
                    </Item.Description>
                    {match.type === "S" && <Item.Extra style={{ color: 'grey' }}>{t('versus') + adv}</Item.Extra>}
                    {match.type === "T" && <Item.Extra style={{ color: 'grey' }}>{match.t1n1 + " / " + match.t2n1}</Item.Extra>}
                  </Item.Content>
                </Item>
              )
            }
            )}
          </Item.Group>
        </Segment>
      </div>
    )
  }

  renderProfileTeamStats() {
    let { showModal } = this.state;
    const team = showModal.player;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
        <Segment inverted style={{ width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100% !important' }}>
            {team.players.map((player, idx) => {
              return (
                <div key={"TSTAT" + idx} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                  <p style={{ margin: 0 }}>{player.p + ' ' + player.n}</p>
                  {Number(player.cp) === 1 && <Label size={'small'} circular style={{ color: 'white', backgroundColor: 'rgba(0,0,0,.5)', fontWeight: 'normal', marginLeft: 8 }}>C</Label>}
                </div>
              )
            }
            )}
          </div>
        </Segment>
      </div>
    )
  }

  renderQualified(match) {
    const { t } = this.props;
    let { categs, currentCateg, currentCountries, parms } = this.state;
    if (!parms) return null;
    if (this.nameFound(match, false) === false) return null;
    if (currentCountries.length > 0) {
      if (currentCountries.findIndex(c => c === match.t1c1) < 0 &&
        currentCountries.findIndex(c => c === match.t2c1) < 0) {
        return null;
      }
    }
    const teamMatch = currentCateg.type === "T";
    const isDouble = currentCateg.type === "D" || (teamMatch && (match.tm1.length === 2 || match.tm2.length === 2));
    const info = this.getMatchInfo(match, teamMatch, isDouble);
    return (
      <React.Fragment>
        {Number(match.t1j1) > 0 &&
          <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "L"}>
            <td colSpan={3}>
              <div className="hall-single" style={{ alignItems: 'unset', flexDirection: 'row' }}>
                <div className={isDouble ? "hall-double-qualified" : "hall-single-qualified"} style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(isDouble, info.t1c1, info.t1c2, match.tm1)}
                  <div className="hall-single-q-fill">
                    <div className={isDouble ? "hall-double-name-left pointer" : "hall-single-name-left pointer"} style={{ alignItems: 'center' }}>
                      {Number(match.s1) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                        {match.s1}
                      </Label>}
                      <p><span className="hall-single-name-left-margin">{info.t1p1}</span>{Global.getPlayerName(t, categs, currentCateg, match, info.t1j1, info.t1n1)}</p>
                      {isDouble && <p><span className="hall-single-name-left-margin">{info.t1p2}</span>{info.t1n2}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>}
        {Number(match.t2j1) > 0 &&
          <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "R"}>
            <td colSpan={3}>
              <div className="hall-single" style={{ alignItems: 'unset', flexDirection: 'row' }}>
                <div className={isDouble ? "hall-double-qualified" : "hall-single-qualified"} style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(isDouble, info.t2c1, info.t2c2, match.tm2)}
                  <div className="hall-single-q-fill">
                    {Number(match.s2) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                      {match.s2}
                    </Label>}
                    <div className={isDouble ? "hall-double-name-left pointer" : "hall-single-name-left pointer"} style={{ alignItems: 'center' }}>
                      <p><span className="hall-single-name-left-margin">{info.t2p1}</span>{Global.getPlayerName(t, categs, currentCateg, match, info.t2j1, info.t2n1)}</p>
                      {isDouble && <p><span className="hall-single-name-right-margin">{info.t2p2}</span>{info.t2n2}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>}
      </React.Fragment>
    )
  }

  renderRanking(index) {
    const { t } = this.props;
    let { allDates, currentRanking, currentSaison, categs, searchName } = this.state;
    if (!currentRanking || !currentRanking[index].ranking) return null;
    if (currentRanking[index].saison !== currentSaison.saison) return null;
    if (currentRanking[index].ranking.length === 0) {
      return (
        <div key={"R" + index} className="hall-ranking-container">
          <div className="hall-ranking-wrapper">
            <h3 className="hall-categ-title">{t('notyetranking')}</h3>
          </div>
        </div>
      )
    }
    return (
      <div key={"R" + index} className="hall-ranking-container">
        <div className="hall-ranking-wrapper">
          <Table celled unstackable inverted>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell rowSpan={2} textAlign='center'>#</Table.HeaderCell>
                <Table.HeaderCell rowSpan={2} textAlign='center'>PLAYER</Table.HeaderCell>
                <Table.HeaderCell rowSpan={2} textAlign='center'>TOTAL</Table.HeaderCell>
                {Number(currentRanking[index].initpts) > 0 &&
                  <Table.HeaderCell rowSpan={2} textAlign='center'>{t('initialpoints')}</Table.HeaderCell>
                }
                {Number(currentRanking[index].code) !== 30 && currentRanking[index].events.map((event, e) => {
                  const categ = categs.find(c => Number(c.code) === Number(event.categ));
                  if (!categ) {
                    return (
                      <Table.HeaderCell key={"head" + e} textAlign='center'>-</Table.HeaderCell>
                    )
                  }
                  let header = Global.replaceParm(categ.name, event.parm);
                  if (currentRanking[index].title === "E") {
                    const evt = allDates.find(d => d.code === Number(event.event));
                    if (evt) {
                      header = evt.name;
                    }
                  }
                  return (
                    <Table.HeaderCell key={"head" + e} textAlign='center' style={{ backgroundColor: categ.back, color: categ.fore }}>{header}</Table.HeaderCell>
                  )
                })}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {currentRanking[index].ranking.map((rank, r) => {
                let oldRank = r;
                if (searchName.trim() !== "") {
                  if (!rank.n.toUpperCase().includes(searchName.trim().toUpperCase())) return null;
                }
                if (currentRanking[index].live === 1 && currentRanking[index].rankingLive && currentRanking[index].rankingLive.length > 0) {
                  oldRank = currentRanking[index].rankingLive.findIndex(rl => Number(rl.c) === Number(rank.c));
                }
                return (
                  <React.Fragment key={"rank" + r}>
                    {((Number(currentRanking[index].split) > 0 && r === 0) || (r % Number(currentRanking[index].split) === 0)) &&
                      <Table.Row style={{ backgroundColor: '#333' }}>
                        <Table.Cell colSpan={currentRanking[index].events.length + 3} textAlign='center' style={{ fontSize: '2rem', paddingTop: '2rem', paddingBottom: '2rem' }}>{currentRanking[index].label + " " + Math.ceil((r + 1) / Number(currentRanking[index].split))}</Table.Cell>
                      </Table.Row>}
                    <Table.Row>
                      <Table.Cell textAlign='center' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {r + 1}
                        {currentRanking.isLive && r < oldRank && <Icon name="long arrow alternate up" color="green" style={{ marginBottom: 6 }} />}
                        {currentRanking.isLive && r > oldRank && <Icon name="long arrow alternate down" color="red" style={{ marginBottom: 6 }} />}
                        {currentRanking.isLive && r === oldRank && <Icon name="long arrow alternate right" color="white" style={{ marginBottom: 6 }} />}
                      </Table.Cell>
                      <Table.Cell textAlign='left' style={{ whiteSpace: 'nowrap' }}>
                        <div onClick={(e) => this.setCurrentPlayer(rank.c, false)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                          {rank.n}
                          {Number(rank.s) > 0 && Number(rank.s) !== 999 &&
                            <Label circular size={'small'} style={{ marginLeft: '1rem', color: '#ccc', backgroundColor: '#333', fontWeight: 'normal', borderColor: '#ccc', borderWidth: 1 }}>
                              {rank.s}
                            </Label>}
                        </div>
                      </Table.Cell>
                      <Table.Cell textAlign='center' style={{ fontWeight: 'bold' }}>{rank.t}</Table.Cell>
                      {Number(currentRanking[index].code) !== 30 && rank.p.map((pts, p) => {
                        return (
                          <Table.Cell key={"c" + p} textAlign='center'>{pts.p ? pts.p : "-"}</Table.Cell>
                        )
                      })}
                    </Table.Row>
                  </React.Fragment>
                )
              })}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }

  renderRankings() {
    let { currentRanking } = this.state;
    return (
      <div className="mainContainer">
        {this.renderSaisons()}
        {this.renderAppPromo()}
        {this.renderRankingSelect()}
        {currentRanking && currentRanking.length > 0 && currentRanking[0].ranking && currentRanking[0].ranking.length > 0 && this.renderSearch(false)}
        {currentRanking && currentRanking.length > 0 && currentRanking.map((r, idx) => this.renderRanking(idx))}
      </div>
    )
  }

  renderRankingSelect() {
    const { t } = this.props;
    let { allRankings, currentRanking } = this.state;
    const init = { key: 0, text: t('selectranking'), value: 0 };
    let rankings = [init];
    allRankings.forEach((r) => {
      let name = Global.getHtmlString(r.name);
      rankings.push({
        key: r.code,
        text: Global.getHtmlString(name),
        value: r.code
      })
    })
    return (
      <Segment inverted>
        <Dropdown
          placeholder={t('selectranking')}
          selection fluid
          options={rankings}
          style={{ background: 'inherit', color: 'inherit', textAlign: 'center' }}
          value={currentRanking && currentRanking.length > 0 ? currentRanking[0].code : 0}
          onChange={(e, data) => { this.setCurrentRanking(data.value) }}
        />
      </Segment>
    )
  }

  renderStatsMain() {
    const { t } = this.props;
    let { showModal } = this.state;
    if (!showModal.stats) return (
      <Container style={{ width: '100%' }}>
        <p style={{ textAlign: 'center' }}>{t('noresult')}</p>
      </Container>
    );
    const heads = showModal.stats.headtohead;
    let nbWon = 0;
    let nbLost = 0;
    let nbDraw = 0;
    let nbFramesWon = 0;
    let nbFramesLost = 0;
    heads.forEach(head => {
      head.matches.forEach(m => {
        if (Number(m.t1j1) === Number(showModal.player.code)) {
          if (Number(m.st1) > Number(m.st2)) nbWon++;
          if (Number(m.st2) > Number(m.st1)) nbLost++;
          if (Number(m.st1) === Number(m.st2)) {
            if (m.sh1 < m.sh2) {
              nbWon++;
            }
            if (m.sh2 < m.sh1) {
              nbLost++;
            }
            if (!m.sh1 && !m.sh2) {
              nbDraw++;
            }
          }
          m.sets.forEach(s => {
            nbFramesWon += Number(s.sc1);
            nbFramesLost += Number(s.sc2);
          })
        } else {
          if (Number(m.st2) > Number(m.st1)) nbWon++;
          if (Number(m.st1) > Number(m.st2)) nbLost++;
          if (Number(m.st1) === Number(m.st2)) {
            if (m.sh2 < m.sh1) {
              nbWon++;
            }
            if (m.sh1 < m.sh2) {
              nbLost++;
            }
            if (!m.sh1 && !m.sh2) {
              nbDraw++;
            }
          }
          m.sets.forEach(s => {
            nbFramesWon += Number(s.sc2);
            nbFramesLost += Number(s.sc1);
          })
        }
      })
    })
    let data1 = [];
    if (nbWon > 0) data1.push({ title: 'Won', value: nbWon, color: '#00CC00' });
    if (nbLost > 0) data1.push({ title: 'Lost', value: nbLost, color: '#990000' });
    if (nbDraw > 0) data1.push({ title: 'Draw', value: nbDraw, color: '#777' });
    let data2 = [];
    if (nbFramesWon > 0) data2.push({ title: 'Won', value: nbFramesWon, color: '#00CC00' });
    if (nbFramesLost > 0) data2.push({ title: 'Lost', value: nbFramesLost, color: '#990000' });
    return (
      <Container style={{ width: '100%' }}>
        <Grid columns={2} inverted={true} stackable>
          <Grid.Row columns={2}>
            <Grid.Column textAlign='center'>
              <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                <Statistic.Value>{nbWon + nbLost + nbDraw}</Statistic.Value>
                <Statistic.Label>{t('matches')}</Statistic.Label>
              </Statistic>
              <PieChart
                style={{ marginTop: '1rem', maxHeight: '10rem' }}
                startAngle={-90}
                lengthAngle={360}
                totalValue={nbWon + nbLost + nbDraw}
                animate={true}
                label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                data={data1}
              />
              <Statistic.Label style={{ marginTop: '1rem', textAlign: 'center' }}>{nbDraw > 0 ? t('WLDpercent') : t('WLpercent')}</Statistic.Label>
            </Grid.Column>
            <Grid.Column textAlign='center'>
              <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                <Statistic.Value>{nbFramesWon + nbFramesLost}</Statistic.Value>
                <Statistic.Label>{t('frames')}</Statistic.Label>
              </Statistic>
              <PieChart
                style={{ marginTop: '1rem', maxHeight: '10rem' }}
                startAngle={-90}
                lengthAngle={360}
                totalValue={nbFramesWon + nbFramesLost}
                animate={true}
                label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                data={data2}
              />
              <Statistic.Label style={{ marginTop: '1rem', textAlign: 'center' }}>{t('frmPercent')}</Statistic.Label>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }

  renderStatsShoot() {
    const { t } = this.props;
    let { showModal } = this.state;
    if (!showModal.stats) return (
      <Container style={{ width: '100%' }}>
        <p style={{ textAlign: 'center' }}>{t('noresult')}</p>
      </Container>
    );
    const shootRef = showModal.stats.shootout.filter(s => Number(s.match.t1j1) === Number(showModal.player.code) || Number(s.match.t1j2) === Number(showModal.player.code) || Number(s.match.t2j1) === Number(showModal.player.code) || Number(s.match.t2j2) === Number(showModal.player.code));
    if (shootRef.length === 0) {
      return (
        <Container style={{ width: '100%' }}>
          <h3 style={{ textAlign: 'center' }}>{t('noresult')}</h3>
        </Container>
      )
    }
    const shootOther = showModal.stats.shootout.filter(s => Number(s.match.t1j1) !== Number(showModal.player.code) && Number(s.match.t1j2) !== Number(showModal.player.code) && Number(s.match.t2j1) !== Number(showModal.player.code) && Number(s.match.t2j2) !== Number(showModal.player.code));
    const nbNoTime = shootRef.filter(s => s.sh.substring(0, 8) === "00:59:59").length;
    let somme = moment.duration(0);
    let nbTimes = 0;
    let nbWon = 0;
    let nbLost = 0;
    shootRef.forEach(s => {
      if (s.match.st1 && s.match.st2) { //Shootout fin de match
        if (Number(showModal.player.code) === Number(s.match.t1j1)) {
          if (Number(s.match.st1) > Number(s.match.st2) || s.match.sh1 < s.match.sh2) {
            nbWon++;
            s.won = true;
          }
          if (Number(s.match.st2) > Number(s.match.st1) || s.match.sh2 < s.match.sh1) {
            nbLost++;
            s.won = false;
          }
        } else {
          if (Number(s.match.st2) > Number(s.match.st1) || s.match.sh2 < s.match.sh1) {
            nbWon++;
            s.won = true;
          }
          if (Number(s.match.st1) > Number(s.match.st2) || s.match.sh1 < s.match.sh2) {
            nbLost++;
            s.won = false;
          }
        }
      } else {  //Shootout fin de groupe
        const advShoot = shootOther.filter(so => so.match.en === s.match.en && so.match.c === s.match.c && so.match.p === s.match.p && so.match.g === s.match.g);
        let nbAdvWon = 0;
        advShoot.forEach(a => {
          if (a.match.sh < s.sh) nbAdvWon++;
        })
        if (nbAdvWon > 0) {
          nbLost++;
          s.won = false;
        } else {
          nbWon++;
          s.won = true;
        }
      }
      if (s.sh.substring(0, 8) !== "00:59:59") {
        nbTimes++;
        const time = moment.duration(s.sh);
        somme.add(time);
      }
    })
    const duree = moment.duration(somme).asMilliseconds() / nbTimes;
    const duration = moment.duration(duree);
    const average = moment.utc(duration.asMilliseconds()).format("HH:mm:ss.SS", { trim: false });
    let data1 = [];
    if (nbWon > 0) data1.push({ title: 'Won', value: nbWon, color: '#00CC00' });
    if (nbLost > 0) data1.push({ title: 'Lost', value: nbLost, color: '#990000' });
    return (
      <Container style={{ width: '100%' }}>
        <Grid columns={2} inverted={true} stackable>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column textAlign='center'>
                    <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                      <Statistic.Value>{shootRef.length}</Statistic.Value>
                      <Statistic.Label>{t('shootout')}</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column textAlign='center'>
                    <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                      <Statistic.Value>{Global.get6RSRanking(shootRef[0].sh)}</Statistic.Value>
                      <Statistic.Label>{t('bestTime')}</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column textAlign='center'>
                    <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                      <Statistic.Value>{nbNoTime}</Statistic.Value>
                      <Statistic.Label>{t('notime')}</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                  <Grid.Column textAlign='center'>
                    <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                      <Statistic.Value>{Global.get6RSRanking(average)}</Statistic.Value>
                      <Statistic.Label>{t('average')}</Statistic.Label>
                    </Statistic>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1} style={{ height: '10rem', justifyContent: 'center', marginBottom: '3rem' }}>
                  <PieChart
                    startAngle={-90}
                    lengthAngle={360}
                    totalValue={nbWon + nbLost}
                    animate={true}
                    label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                    data={data1}
                  />
                  {(nbWon + nbLost) > 0 && <Statistic.Label style={{ marginTop: '1rem' }}>{t('WLpercent')}</Statistic.Label>}
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <Item.Group divided>
                {shootRef && shootRef.length > 0 && shootRef.map((s, idx) => {
                  const advShoot = shootOther.filter(so => so.match.en === s.match.en && so.match.c === s.match.c && so.match.p === s.match.p && so.match.g === s.match.g);
                  if (s.match.st1 && s.match.st2) return (
                    <Item key={"SHOOT" + idx}>
                      <Item.Content>
                        <Item.Header style={{ color: 'white' }}>
                          {s.won ? t('won') : t('lost')}
                          {Global.get6RSRanking(s.sh)}
                          {Number(s.match.t1j2) > 0 && <span style={{ color: '#ccc', marginLeft: '.5rem', fontSize: '1rem' }}>
                            {Number(showModal.player.code) === Number(s.match.t1j1) && t('with', { n: s.match.t1n2, p: s.match.t1p2 })}
                            {Number(showModal.player.code) === Number(s.match.t1j2) && t('with', { n: s.match.t1n1, p: s.match.t1p1 })}
                            {Number(showModal.player.code) === Number(s.match.t2j1) && t('with', { n: s.match.t2n2, p: s.match.t2p2 })}
                            {Number(showModal.player.code) === Number(s.match.t2j2) && t('with', { n: s.match.t2n1, p: s.match.t2p1 })}
                          </span>}
                        </Item.Header>
                        <Item.Description style={{ color: 'white' }}>
                          <p key={"Sh" + idx} style={{ fontSize: '.7rem' }}>
                            {t('versus')}
                            {(Number(showModal.player.code) === Number(s.match.t1j1) || Number(showModal.player.code) === Number(s.match.t1j2)) && s.match.t2p1 + " " + s.match.t2n1}
                            {(Number(showModal.player.code) === Number(s.match.t2j1) || Number(showModal.player.code) === Number(s.match.t2j2)) && s.match.t1p1 + " " + s.match.t1n1}
                            {(Number(showModal.player.code) === Number(s.match.t1j1) || Number(showModal.player.code) === Number(s.match.t1j2)) && Number(s.match.t1j2) > 0 && " / " + s.match.t2p2 + " " + s.match.t2n2}
                            {(Number(showModal.player.code) === Number(s.match.t2j1) || Number(showModal.player.code) === Number(s.match.t2j2)) && Number(s.match.t2j2) > 0 && " / " + s.match.t1p2 + " " + s.match.t1n2}
                            {Global.get6RS(Number(showModal.player.code) === Number(s.match.t1j1) || Number(showModal.player.code) === Number(s.match.t1j2) ? s.match.sh2 : s.match.sh1)}
                          </p>
                        </Item.Description>
                        <Item.Extra style={{ color: 'grey' }}>
                          <p style={{ display: 'flex', flexDirection: 'column' }}>
                            {Global.getHtmlString(s.match.en)}
                            <span style={{ fontSize: '.7rem' }}>{s.match.pn}</span>
                          </p>
                        </Item.Extra>
                      </Item.Content>
                    </Item>
                  );
                  return (
                    <Item key={"SHOOT" + idx}>
                      <Item.Content>
                        <Item.Header style={{ color: 'white' }}>
                          {s.won ? t('won') : t('lost')}
                          {Global.get6RSRanking(s.sh)}
                          {Number(s.match.t1j2) > 0 && <span style={{ color: '#ccc', marginLeft: '.5rem', fontSize: '1rem' }}>
                            {Number(showModal.player.code) === Number(s.match.t2j1) ? t('with', { n: s.match.t1n2, p: s.match.t1p2 }) : t('with', { n: s.match.t1n1, p: s.match.t1p1 })}
                          </span>}
                        </Item.Header>
                        <Item.Description style={{ color: 'white' }}>
                          {advShoot && advShoot.map((a, idx) => {
                            return (
                              <p key={"Sh" + idx} style={{ fontSize: '.7rem' }}>
                                {t('versus')}
                                {a.match.t1p1 + " " + a.match.t1n1}
                                {Number(a.match.t1j2) > 0 && " / " + a.match.t1p2 + " " + a.match.t1n2}
                                {Global.get6RS(a.match.sh)}
                              </p>)
                          })}
                        </Item.Description>
                        <Item.Extra style={{ color: 'grey' }}>
                          <p style={{ display: 'flex', flexDirection: 'column' }}>
                            {Global.getHtmlString(s.match.en)}
                            <span style={{ fontSize: '.7rem' }}>{s.match.pn}</span>
                          </p>
                        </Item.Extra>
                      </Item.Content>
                    </Item>
                  )
                })}
              </Item.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }

  renderStatsHead() {
    const { t } = this.props;
    let { showModal } = this.state;
    if (!showModal.stats) return (
      <Container style={{ width: '100%' }}>
        <p style={{ textAlign: 'center' }}>{t('noresult')}</p>
      </Container>
    );
    const heads = showModal.stats.headtohead;
    const hthPlayer = showModal.stats.hthPlayer;
    const head = heads.find(h => h.code === hthPlayer.code);
    let nbWon = 0;
    let nbLost = 0;
    let nbDraw = 0;
    let nbFramesWon = 0;
    let nbFramesLost = 0;
    let nbShootWon = 0;
    let nbShootLost = 0;
    if (head) {
      head.matches.forEach(m => {
        if (Number(m.t1j1) === Number(showModal.player.code)) {
          if (Number(m.st1) > Number(m.st2)) nbWon++;
          if (Number(m.st2) > Number(m.st1)) nbLost++;
          if (Number(m.st1) === Number(m.st2)) {
            if (m.sh1 < m.sh2) {
              nbWon++;
              nbShootWon++;
            }
            if (m.sh2 < m.sh1) {
              nbLost++;
              nbShootLost++;
            }
            if (!m.sh1 && !m.sh2) {
              nbDraw++;
            }
          }
          m.sets.forEach(s => {
            nbFramesWon += Number(s.sc1);
            nbFramesLost += Number(s.sc2);
          })
        } else {
          if (Number(m.st2) > Number(m.st1)) nbWon++;
          if (Number(m.st1) > Number(m.st2)) nbLost++;
          if (Number(m.st1) === Number(m.st2)) {
            if (m.sh2 < m.sh1) {
              nbWon++;
              nbShootWon++;
            }
            if (m.sh1 < m.sh2) {
              nbLost++;
              nbShootLost++;
            }
            if (!m.sh1 && !m.sh2) {
              nbDraw++;
            }
          }
          m.sets.forEach(s => {
            nbFramesWon += Number(s.sc2);
            nbFramesLost += Number(s.sc1);
          })
        }
      })
    }
    let data1 = [];
    if (nbWon > 0) data1.push({ title: 'Won', value: nbWon, color: '#00CC00' });
    if (nbLost > 0) data1.push({ title: 'Lost', value: nbLost, color: '#990000' });
    if (nbDraw > 0) data1.push({ title: 'Draw', value: nbDraw, color: '#777' });
    let data2 = [];
    if (nbFramesWon > 0) data2.push({ title: 'Won', value: nbFramesWon, color: '#00CC00' });
    if (nbFramesLost > 0) data2.push({ title: 'Lost', value: nbFramesLost, color: '#990000' });
    let data3 = [];
    if (nbShootWon > 0) data3.push({ title: 'Won', value: nbShootWon, color: '#00CC00' });
    if (nbShootLost > 0) data3.push({ title: 'Lost', value: nbShootLost, color: '#990000' });
    return (
      <Container style={{ width: '100%' }}>
        <Dropdown
          placeholder={t('selectadv')}
          text=""
          fluid selection
          style={{ background: 'inherit', color: 'inherit', textAlign: 'center' }}
          value={hthPlayer.code}
          onChange={(e, data) => { this.setHthPlayer(data.value) }}
        >
          <Dropdown.Menu>
            {heads && heads.length > 0 && heads.map((h, idx) => {
              return (
                <Dropdown.Item key={"HEAD" + idx}
                  style={{ textAlign: 'left' }}
                  onClick={() => this.setHthPlayer(h.code)}>
                  <Label circular horizontal color='grey'>{h.matches.length}</Label>
                  {h.matches[0].t1j1 === h.code ?
                    <p style={{ display: 'inline-block', marginLeft: '1rem' }}>
                      <span className="hall-single-name-left-margin">{h.matches[0].t1p1}</span>
                      {h.matches[0].t1n1}
                    </p>
                    :
                    <p style={{ display: 'inline-block', marginLeft: '1rem' }}>
                      <span className="hall-single-name-left-margin">{h.matches[0].t2p1}</span>
                      {h.matches[0].t2n1}
                    </p>
                  }
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
        {head &&
          <Grid columns={2} inverted={true}>
            <Grid.Row columns={1}>
              <Grid.Column textAlign='center'>
                <h1 style={{ textAlign: 'center' }}>
                  {t('versus')}
                  <span className="hall-single-name-left-margin">{hthPlayer.prenom}</span>
                  {hthPlayer.nom}
                </h1>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column textAlign='center'>
                <Statistic inverted size='small' style={{ margin: '1rem 0' }}>
                  <Statistic.Value>{head.matches.length}</Statistic.Value>
                  <Statistic.Label>{t('headtoheads')}</Statistic.Label>
                </Statistic>
                <PieChart
                  style={{ marginTop: '1rem', maxHeight: '10rem' }}
                  startAngle={-90}
                  lengthAngle={360}
                  totalValue={nbWon + nbLost + nbDraw}
                  animate={true}
                  label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                  data={data1}
                />
                <Statistic.Label style={{ marginTop: '1rem', textAlign: 'center' }}>{nbDraw > 0 ? t('WLDpercent') : t('WLpercent')}</Statistic.Label>
                <PieChart
                  style={{ marginTop: '1rem', maxHeight: '10rem' }}
                  startAngle={-90}
                  lengthAngle={360}
                  totalValue={nbFramesWon + nbFramesLost}
                  animate={true}
                  label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                  data={data2}
                />
                <Statistic.Label style={{ marginTop: '1rem', textAlign: 'center' }}>{t('frmPercent')}</Statistic.Label>
                {(nbShootWon + nbShootLost) > 0 && <PieChart
                  style={{ marginTop: '1rem', maxHeight: '10rem' }}
                  startAngle={-90}
                  lengthAngle={360}
                  totalValue={nbShootWon + nbShootLost}
                  animate={true}
                  label={({ dataEntry }) => Math.round(dataEntry.percentage) + '%'}
                  data={data3}
                />}
                {(nbShootWon + nbShootLost) > 0 && <Statistic.Label style={{ marginTop: '1rem', textAlign: 'center' }}>{t('shPercent')}</Statistic.Label>}
              </Grid.Column>
              <Grid.Column>
                <Item.Group divided>
                  {head.matches.length > 0 && head.matches.map((m, idx) => {
                    let header = "";
                    if (Number(showModal.player.code) === Number(m.t1j1)) {
                      if (Number(m.st1) > Number(m.st2)) header = t('won');
                      if (Number(m.st2) > Number(m.st1)) header = t('lost');
                      if (Number(m.st1) === Number(m.st2)) {
                        if (m.sh1 < m.sh2) header = t('won');
                        if (m.sh2 < m.sh1) header = t('lost');
                        if (!m.sh1 && !m.sh2) header = t('draw');
                      }
                      m.sets.forEach((set, s) => {
                        if (s > 0) header += " / ";
                        header += set.sc1 + "-" + set.sc2 + " ";
                      })
                    } else {
                      if (Number(m.st2) > Number(m.st1)) header = t('won');
                      if (Number(m.st1) > Number(m.st2)) header = t('lost');
                      if (Number(m.st1) === Number(m.st2)) {
                        if (m.sh2 < m.sh1) header = t('won');
                        if (m.sh1 < m.sh2) header = t('lost');
                        if (!m.sh1 && !m.sh2) header = t('draw');
                      }
                      m.sets.forEach((set, s) => {
                        if (s > 0) header += " / ";
                        header += set.sc2 + "-" + set.sc1 + " ";
                      })
                    }
                    return (
                      <Item key={"HTH" + idx}>
                        <Item.Content>
                          <Item.Header style={{ color: 'white' }}>
                            {header}
                          </Item.Header>
                          <Item.Description style={{ color: 'white' }}>
                            {Global.replaceParm(m.cn, m.parm)}
                          </Item.Description>
                          <Item.Extra style={{ color: 'grey' }}>{m.pn}</Item.Extra>
                        </Item.Content>
                      </Item>
                    )
                  })}
                </Item.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
      </Container>
    )
  }

  renderSaisons() {
    let { currentSaison, saisons } = this.state;
    if (!saisons || saisons.length === 0) return null;
    const currentIdx = saisons.findIndex(s => s.saison === currentSaison.saison);
    return (
      <Segment inverted>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
          <Button circular icon='angle double left' disabled={currentIdx < 1} color='black' style={{ marginLeft: '1rem', marginRight: '1rem', color: currentIdx > 0 ? '#eee' : '#777', cursor: currentIdx > 0 ? 'pointer' : 'default' }} onClick={() => this.goFirst()} />
          <Button circular icon='angle left' disabled={currentIdx < 1} color='black' style={{ marginLeft: '1rem', marginRight: '1rem', color: currentIdx > 0 ? '#eee' : '#777', cursor: currentIdx > 0 ? 'pointer' : 'default' }} onClick={() => this.goPrev()} />
          <h3 className="hall-text-center" style={{ marginLeft: '1rem', marginRight: '1rem', marginTop: 0, marginBottom: 0 }}>{currentSaison.name}</h3>
          <Button circular icon='angle right' disabled={currentIdx === saisons.length - 1} color='black' style={{ marginLeft: '1rem', marginRight: '1rem', color: currentIdx < saisons.length - 1 ? '#eee' : '#777', cursor: currentIdx < saisons.length - 1 ? 'pointer' : 'default' }} onClick={() => this.goNext()} />
          <Button circular icon='angle double right' disabled={currentIdx === saisons.length - 1} color='black' style={{ marginLeft: '1rem', marginRight: '1rem', color: currentIdx < saisons.length - 1 ? '#eee' : '#777', cursor: currentIdx < saisons.length - 1 ? 'pointer' : 'default' }} onClick={() => this.goLast()} />
        </div>
      </Segment>
    )
  }

  renderScore1Col(match, showDetail, teamMatch) {
    let { categs, currentCateg, currentTab } = this.state;
    const cat = currentTab === 0 && Number(currentCateg) === 0 ? categs.find(c => c.code === match.c) : currentCateg;
    const phase = cat.phases[Number(match.p)];
    if (!phase) {
      return null;
    }
    let ended = match.me !== '0000-00-00 00:00:00' && match.me !== null;
    let nbSets = Number(phase.boSets);
    let cls = "hall-single-score";
    if ((nbSets > 1 && match.animate1) || (nbSets === 1 && match.sets[0].animate1)) {
      cls += " hall-effect";
    }
    cls += ended ? " hall-match-ended" : " hall-match-live";
    cls += teamMatch ? " hall-teamMatch" : "";
    let style = { backgroundColor: 'transparent', color: ended ? cat.live.fsl : cat.live.flive, transform: 'skew(20deg)' };
    let st1 = Number(match.st1) < 0 ? "FF" : (nbSets > 1 ? match.st1 : Global.getScore1(match, 0));
    let st2 = Number(match.st2) < 0 ? "FF" : (nbSets > 1 ? match.st2 : Global.getScore2(match, 0));
    if (st2 === "FF") st1 = "-";
    //let cf1 = Number(table.st1) < 0 ? "" : this.getTotalFermes(table, 1);
    const win = st2 === "FF" || Number(st1) > Number(st2) ||
      (Number(st1) === Number(st2) && Number(phase.mnull) === 1 && Number(phase.tied) === 1 && match.sh1 < match.sh2);
    if (ended && win) {
      cls += " hall-match-win";
      style = { backgroundColor: 'transparent', color: cat.live.fsw, transform: 'skew(20deg)' };
    }
    return (
      <div className={cls} style={style} onClick={showDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r)}>
        {Global.formatSet(st1)}{/*<span>{cf1}</span>*/}
      </div>
    )
  }

  renderScore2Col(match, showDetail, teamMatch) {
    let { categs, currentCateg, currentTab } = this.state;
    const cat = currentTab === 0 && Number(currentCateg) === 0 ? categs.find(c => c.code === match.c) : currentCateg;
    const phase = cat.phases[Number(match.p)];
    if (!phase) {
      return null;
    }
    let ended = match.me !== '0000-00-00 00:00:00' && match.me !== null;
    let nbSets = Number(phase.boSets);
    let cls = "hall-single-score";
    if ((nbSets > 1 && match.animate2) || (nbSets === 1 && match.sets[0].animate2)) {
      cls += " hall-effect";
    }
    cls += ended ? " hall-match-ended" : " hall-match-live";
    cls += teamMatch ? " hall-teamMatch" : "";
    let style = { backgroundColor: 'transparent', color: ended ? cat.live.fsl : cat.live.flive, transform: 'skew(20deg)' };
    let st1 = Number(match.st1) < 0 ? "FF" : (nbSets > 1 ? match.st1 : Global.getScore1(match, 0));
    let st2 = Number(match.st2) < 0 ? "FF" : (nbSets > 1 ? match.st2 : Global.getScore2(match, 0));
    if (st1 === "FF") st2 = "-";
    //let cf2 = Number(table.st2) < 0 ? "" : this.getTotalFermes(table, 2);
    const win = st1 === "FF" || Number(st2) > Number(st1) ||
      (Number(st1) === Number(st2) && Number(phase.mnull) === 1 && Number(phase.tied) === 1 && match.sh2 < match.sh1);
    if (ended && win) {
      cls += " hall-match-win";
      style = { backgroundColor: 'transparent', color: cat.live.fsw, transform: 'skew(20deg)' };
    }
    return (
      <div className={cls} style={style} onClick={showDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r)}>
        {Global.formatSet(st2)}{/*<span>{cf2}</span>*/}
      </div>
    )
  }

  renderScore1Frame(match, frame) {
    let { categs, currentCateg, currentTab } = this.state;
    const cat = currentTab === 0 && Number(currentCateg) === 0 ? categs.find(c => c.code === match.c) : currentCateg;
    let ended = Number(frame.sc1) === 1 || Number(frame.sc2) === 1;
    let started = Number(frame.st) === 1;
    let cls = "hall-single-frame";
    cls += frame.animate1 ? " hall-effect" : "";
    cls += ended ? " hall-match-ended" : " hall-match-live";
    let style = { backgroundColor: ended ? cat.live.bended : cat.live.bended, color: ended ? cat.live.fsl : cat.live.flive };
    let sc1 = Number(frame.sc1) < 0 ? "FF" : frame.sc1;
    let sc2 = Number(frame.sc2) < 0 ? "FF" : frame.sc2;
    const win = sc2 === "FF" || Number(sc1) > Number(sc2);
    if (ended && win) {
      cls += " hall-match-win";
      style = { backgroundColor: cat.live.bended, color: cat.live.fsw };
    }
    return (
      <div className={cls} style={style}>
        {started ? frame.sc1 : '-'}{/*<span>{started ? frame.cf1 : ''}</span>*/}
      </div>
    )
  }

  renderScore2Frame(match, frame) {
    let { categs, currentCateg, currentTab } = this.state;
    const cat = currentTab === 0 && Number(currentCateg) === 0 ? categs.find(c => c.code === match.c) : currentCateg;
    let ended = Number(frame.sc1) === 1 || Number(frame.sc2) === 1;
    let started = Number(frame.st) === 1;
    let cls = "hall-single-frame";
    cls += frame.animate2 ? " hall-effect" : "";
    cls += ended ? " hall-match-ended" : " hall-match-live";
    let style = { backgroundColor: ended ? cat.live.bended : cat.live.bended, color: ended ? cat.live.fsl : cat.live.flive };
    let sc1 = Number(frame.sc1) < 0 ? "FF" : frame.sc1;
    let sc2 = Number(frame.sc2) < 0 ? "FF" : frame.sc2;
    const win = sc1 === "FF" || Number(sc2) > Number(sc1);
    if (ended && win) {
      cls += " hall-match-win";
      style = { backgroundColor: cat.live.bended, color: cat.live.fsw };
    }
    return (
      <div className={cls} style={style}>
        {started ? frame.sc2 : '-'}{/*<span>{started ? frame.cf2 : ''}</span>*/}
      </div>
    )
  }

  renderSearch(showCountries = true) {
    const { t } = this.props;
    let { countries, currentCateg, currentCountries, searchName } = this.state;
    return (
      <div className='col-center'>
        <div className="row-center">
          <input type="search" name="search" className="hall-search" value={searchName} placeholder={currentCateg && currentCateg.type === "T" ? t('searchT') : t('search')} onChange={(e) => this.setSearch(e)}></input>
          {searchName && <img src={Global.imgUrl + "xmark-white.svg"} alt="reset" height="16px" width="16px" onClick={() => this.resetSearch()} style={{ cursor: 'pointer', position: 'relative', right: 24, top: 7 }} />}
        </div>
        {showCountries && countries && <div className="hall-flex-row" style={{ marginTop: '1rem', justifyContent: 'space-around', alignItems: 'baseline', width: '66%' }}>
          {countries.map((country, c) => {
            if (country.trim().length > 0) {
              const selected = currentCountries.some(c => c === country);
              return (
                <div key={"C" + c} className="hall-single-flag-cont" style={{ cursor: 'pointer' }} onClick={() => this.swapCountry(country)}>
                  <img src={Global.flagUrl + country + "-small.png"} className={selected ? "hall-single-flag-selected" : "hall-single-flag"} alt="..." onError={e => { e.target.style.display = 'none' }} />
                </div>
              )
            } else {
              return null;
            }
          })}
        </div>}
      </div>
    )
  }

  renderSessionEnded(categ, phase, match, set, showSetDetail, teamMatch) {
    const { t } = this.props;
    if (this.nameFound(match, teamMatch) === false) return null;
    let ended = set.se !== '0000-00-00 00:00:00' && set.se !== null;
    let cls1 = "hall-single-score";
    cls1 += " hall-match-ended";
    cls1 += teamMatch ? " hall-teamMatch" : "";
    let style1 = { backgroundColor: categ.live.bended, color: categ.live.fsl };
    let cls2 = "hall-single-score";
    cls2 += " hall-match-ended";
    cls2 += teamMatch ? " hall-teamMatch" : "";
    let style2 = { backgroundColor: categ.live.bended, color: categ.live.fsl };
    let sc1 = Number(set.sc1) < 0 ? "FF" : set.sc1;
    let sc2 = Number(set.sc2) < 0 ? "FF" : set.sc2;
    if (sc2 === "FF") sc1 = "-";
    if (sc1 === "FF") sc2 = "-";
    const win1 = sc2 === "FF" || Number(sc1) > Number(sc2);
    const win2 = sc1 === "FF" || Number(sc1) < Number(sc2);
    if (ended && win1) {
      cls1 += " hall-match-win";
      style1 = { backgroundColor: categ.live.bended, color: categ.live.fsw };
    }
    if (ended && win2) {
      cls2 += " hall-match-win";
      style2 = { backgroundColor: categ.live.bended, color: categ.live.fsw };
    }
    const nbSs = Number(phase.nbSs);
    let ssFrms = Number(phase.ssFrms);
    let frms1 = 0; let frms2 = 0;
    const sidx = match.sets.findIndex(s => s.set === set.set && s.ss === set.ss);
    if (sidx === match.sets.length - 1 && nbSs > 1) {
      match.sets.forEach((st, s) => {
        if (s === match.sets.length - 1) return;
        if (st.se) {
          frms1 += Number(st.sc1);
          frms2 += Number(st.sc2);
        } else {
          frms1 += ssFrms;
        }
      })
      ssFrms = Number(phase.boFrames) - frms1 - frms2;
    }
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set + set.ss} >
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left-ended" style={{ backgroundColor: categ.live.bended, color: categ.live.fended }}>
              <div className="hall-single-flag-cont">
              </div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {t('session.' + set.ss)}
                </div>
                <div className={cls1} style={style1} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc1}</div>
              </div>
            </div>
            <div className="hall-single-set-right-ended" style={{ backgroundColor: categ.live.bended, color: categ.live.fended }}>
              <div className="hall-single-right-name">
                <div className={cls2} style={style2} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc2}</div>
                <div className="hall-single-set-name-right">
                  {ssFrms > 0 && t('fixedFrms', { frms: ssFrms })}
                  {phase.ssTime !== "00:00:00" && moment.duration(phase.ssTime).humanize()}
                </div>
              </div>
              <div className="hall-single-flag-cont">
              </div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSessionLive(categ, phase, match, set, showSetDetail, teamMatch) {
    const { t } = this.props;
    if (this.nameFound(match, teamMatch) === false) return null;
    let cls1 = "hall-single-score";
    cls1 += set.animate1 ? " hall-effect" : "";
    cls1 += " hall-match-live";
    cls1 += teamMatch ? " hall-teamMatch" : "";
    let style1 = { backgroundColor: categ.live.blive, color: categ.live.flive };
    let cls2 = "hall-single-score";
    cls2 += set.animate2 ? " hall-effect" : "";
    cls2 += " hall-match-live";
    cls2 += teamMatch ? " hall-teamMatch" : "";
    let style2 = { backgroundColor: categ.live.blive, color: categ.live.flive };
    let sc1 = Number(set.sc1) < 0 ? "FF" : set.sc1;
    let sc2 = Number(set.sc2) < 0 ? "FF" : set.sc2;
    if (sc2 === "FF") sc1 = "-";
    if (sc1 === "FF") sc2 = "-";
    const nbSs = Number(phase.nbSs);
    let ssFrms = Number(phase.ssFrms);
    let frms1 = 0; let frms2 = 0;
    const sidx = match.sets.findIndex(s => s.set === set.set && s.ss === set.ss);
    if (sidx === match.sets.length - 1 && nbSs > 1) {
      match.sets.forEach((st, s) => {
        if (s === match.sets.length - 1) return;
        if (st.se) {
          frms1 += Number(st.sc1);
          frms2 += Number(st.sc2);
        } else {
          frms1 += ssFrms;
        }
      })
      ssFrms = Number(phase.boFrames) - frms1 - frms2;
    }
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set + set.ss}>
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left" style={{ backgroundColor: categ.live.blive, color: categ.live.flive }}>
              <div className="hall-single-flag-cont"></div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {t('session.' + set.ss)}
                </div>
                <div className={cls1} style={style1} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc1}</div>
              </div>
            </div>
            <div className="hall-single-set-right" style={{ backgroundColor: categ.live.blive, color: categ.live.flive }}>
              <div className="hall-single-right-name">
                <div className={cls2} style={style2} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc2}</div>
                <div className="hall-single-set-name-right">
                  {ssFrms > 0 && t('fixedFrms', { frms: ssFrms })}
                  {phase.ssTime !== "00:00:00" && moment.duration(phase.ssTime).humanize()}
                </div>
              </div>
              <div className="hall-single-flag-cont"></div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSessionNext(categ, phase, match, set, teamMatch) {
    const { t } = this.props;
    if (this.nameFound(match, teamMatch) === false) return null;
    const nbSs = Number(phase.nbSs);
    let ssFrms = Number(phase.ssFrms);
    let frms1 = 0; let frms2 = 0;
    const sidx = match.sets.findIndex(s => s.set === set.set && s.ss === set.ss);
    if (sidx === match.sets.length - 1 && nbSs > 1) {
      match.sets.forEach((st, s) => {
        if (s === match.sets.length - 1) return;
        if (st.se) {
          frms1 += Number(st.sc1);
          frms2 += Number(st.sc2);
        } else {
          frms1 += ssFrms;
        }
      })
      ssFrms = Number(phase.boFrames) - frms1 - frms2;
    }
    const sameDate = moment(match.mc).isSame(moment(set.sc), 'day');
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set + set.ss}>
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left-next" style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext }}>
              <div className="hall-single-flag-cont"></div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {t('session.' + set.ss)}
                </div>
              </div>
              <div className="hall-single-schedule" style={{ backgroundColor: Global.getNearColor(categ.live.bnext, 32), color: categ.live.fnext }}>
                <p className='hall-schedule-time' style={{ margin: 0, paddingTop: sameDate ? 0 : 6, paddingRight: sameDate ? 0 : 5 }}>{set.sc ? this.getLocalTime(set.sc) : (match.mc ? this.getLocalTime(match.mc) : "TBC")}</p>
                {!sameDate && <span className='hall-schedule-time' style={{ fontSize: 8, marginTop: -6, paddingLeft: 5 }}>{this.getLocalDate(set.sc, "MMM D")}</span>}
              </div>
            </div>
            <div className="hall-single-set-right-next" style={{ backgroundColor: categ.live.bnext, color: categ.live.fnext }}>
              <div className="hall-single-right-name">
                <div className="hall-single-set-name-right-next">
                  {ssFrms > 0 && t('fixedFrms', { frms: ssFrms })}
                  {phase.ssTime !== "00:00:00" && moment.duration(phase.ssTime).humanize()}
                </div>
              </div>
              <div className="hall-single-flag-cont"></div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSetEnded(match, set, showSetDetail, teamMatch) {
    let { currentCateg } = this.state;
    if (this.nameFound(match, teamMatch) === false) return null;
    let ended = set.se !== '0000-00-00 00:00:00' && set.se !== null;
    let cls1 = "hall-single-score";
    cls1 += " hall-match-ended";
    cls1 += teamMatch ? " hall-teamMatch" : "";
    let style1 = { backgroundColor: currentCateg.live.bended, color: currentCateg.live.fsl };
    let cls2 = "hall-single-score";
    cls2 += " hall-match-ended";
    cls2 += teamMatch ? " hall-teamMatch" : "";
    let style2 = { backgroundColor: currentCateg.live.bended, color: currentCateg.live.fsl };
    let sc1 = Number(set.sc1) < 0 ? "FF" : set.sc1;
    let sc2 = Number(set.sc2) < 0 ? "FF" : set.sc2;
    if (sc2 === "FF") sc1 = "-";
    if (sc1 === "FF") sc2 = "-";
    const win1 = sc2 === "FF" || Number(sc1) > Number(sc2);
    const win2 = sc1 === "FF" || Number(sc1) < Number(sc2);
    if (ended && win1) {
      cls1 += " hall-match-win";
      style1 = { backgroundColor: currentCateg.live.bended, color: currentCateg.live.fsw };
    }
    if (ended && win2) {
      cls2 += " hall-match-win";
      style2 = { backgroundColor: currentCateg.live.bended, color: currentCateg.live.fsw };
    }
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set} >
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left-ended" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
              <div className="hall-single-flag-cont">
              </div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {"Set " + (Number(set.set) + 1)}
                </div>
                <div className={cls1} style={style1} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc1}</div>
              </div>
            </div>
            <div className="hall-single-set-right-ended" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
              <div className="hall-single-right-name">
                <div className={cls2} style={style2} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc2}</div>
                <div className="hall-single-set-name-right">
                </div>
              </div>
              <div className="hall-single-flag-cont">
              </div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSetLive(match, set, showSetDetail, teamMatch) {
    let { currentCateg } = this.state;
    if (this.nameFound(match, teamMatch) === false) return null;
    let cls1 = "hall-single-score";
    cls1 += set.animate1 ? " hall-effect" : "";
    cls1 += " hall-match-live";
    cls1 += teamMatch ? " hall-teamMatch" : "";
    let style1 = { backgroundColor: currentCateg.live.blive, color: currentCateg.live.flive };
    let cls2 = "hall-single-score";
    cls2 += set.animate2 ? " hall-effect" : "";
    cls2 += " hall-match-live";
    cls2 += teamMatch ? " hall-teamMatch" : "";
    let style2 = { backgroundColor: currentCateg.live.blive, color: currentCateg.live.flive };
    let sc1 = Number(set.sc1) < 0 ? "FF" : set.sc1;
    let sc2 = Number(set.sc2) < 0 ? "FF" : set.sc2;
    if (sc2 === "FF") sc1 = "-";
    if (sc1 === "FF") sc2 = "-";
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set}>
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left" style={{ backgroundColor: currentCateg.live.blive, color: currentCateg.live.flive }}>
              <div className="hall-single-flag-cont"></div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {"Set " + (Number(set.set) + 1)}
                </div>
                <div className={cls1} style={style1} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc1}</div>
              </div>
            </div>
            <div className="hall-single-set-right" style={{ backgroundColor: currentCateg.live.blive, color: currentCateg.live.flive }}>
              <div className="hall-single-right-name">
                <div className={cls2} style={style2} onClick={showSetDetail ? this.hideDetail.bind(this, teamMatch) : this.showDetail.bind(this, teamMatch, match.c, match.p, match.g, match.s, match.r, set.set)}>{sc2}</div>
                <div className="hall-single-set-name-right">
                </div>
              </div>
              <div className="hall-single-flag-cont"></div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSetNext(match, set, teamMatch) {
    let { currentCateg } = this.state;
    if (this.nameFound(match, teamMatch) === false) return null;
    return (
      <tr key={match.c + "P" + match.p + "G" + match.g + "S" + match.s + "R" + match.r + "S" + set.set}>
        <td className="hall-table-cell"></td>
        <td className="hall-table-cell">
          <div className="hall-single">
            <div className="hall-single-set-left-next" style={{ backgroundColor: currentCateg.live.bnext, color: currentCateg.live.fnext }}>
              <div className="hall-single-flag-cont"></div>
              <div className="hall-single-fill">
                <div className="hall-single-set-name-left">
                  {"Set " + (Number(set.set) + 1)}
                </div>
              </div>
              <div className="hall-single-schedule" style={{ backgroundColor: currentCateg.live.bnext, color: currentCateg.live.fnext }}>
                <p className='hall-schedule-time'>{set.sc ? set.sc.substring(11, 16) : (match.mc ? this.getLocalTime(match.mc) : "TBC")}</p>
              </div>
            </div>
            <div className="hall-single-set-right-next" style={{ backgroundColor: currentCateg.live.bnext, color: currentCateg.live.fnext }}>
              <div className="hall-single-right-name">
                <div className="hall-single-set-name-right">
                </div>
              </div>
              <div className="hall-single-flag-cont"></div>
            </div>
          </div>
        </td>
        <td className="hall-table-cell"></td>
      </tr>
    )
  }

  renderSingleWinner(match) {
    const { t } = this.props;
    let { currentCateg, currentCountries, parms } = this.state;
    if (this.nameFound(match, false) === false) return null;
    if (currentCountries.length > 0) {
      if (currentCountries.findIndex(c => c === match.t1c1) < 0 &&
        currentCountries.findIndex(c => c === match.t2c1) < 0) {
        return null;
      }
    }
    let win = 0;
    if (Number(match.st1) > Number(match.st2) || match.sh1 < match.sh2) win = 1;
    if (Number(match.st2) > Number(match.st1) || match.sh2 < match.sh1) win = 2;
    if (win === 0) return null;
    const parm = parms.find(p => p.categ === match.c);
    const hasPhoto = parm && parm.winner.trim() !== "";
    return (
      <React.Fragment>
        <tr key={"h1Winner"}>
          <td colSpan={3} className="hall-table-cell">
            <h1 className="hall-categ-title" style={{ marginTop: '3rem' }}>
              {this.getCategLabel(currentCateg) + t('singleWinner')}
            </h1>
          </td>
        </tr>
        {win === 1 &&
          <tr>
            <td className="hall-table-cell">
            </td>
            <td className="hall-table-cell">
              <div className="hall-single">
                <div className="hall-single-qualified" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(false, match.t1c1, match.t1c2, match.tm1)}
                  <div className="hall-single-q-fill">
                    <div className="hall-single-name-left">
                      {Number(match.s1) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                        {match.s1}
                      </Label>}
                      <p><span className="hall-single-name-left-margin">{match.t1p1}</span>{match.t1n1}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>}
        {win === 2 &&
          <tr>
            <td className="hall-table-cell">
            </td>
            <td className="hall-table-cell">
              <div className="hall-single">
                <div className="hall-single-qualified" style={{ backgroundColor: currentCateg.live.bended, color: currentCateg.live.fended }}>
                  {this.renderFlag(false, match.t2c1, match.t2c2, match.tm2)}
                  <div className="hall-single-q-fill">
                    {Number(match.s2) > 0 && <Label circular size={'small'} style={{ color: currentCateg.live.fended, backgroundColor: Global.getNearColor(currentCateg.live.bended, 32), marginRight: '.5rem' }}>
                      {match.s2}
                    </Label>}
                    <div className="hall-single-name-left">
                      <p><span className="hall-single-name-left-margin">{match.t2p1}</span>{match.t2n1}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td></td>
          </tr>}
        {hasPhoto &&
          <tr key={"h1photo"}>
            <td colSpan={3} className="hall-table-cell">
              <img src={Global.localUrl + 'admin/photos/' + parm.winner} style={{ width: '90%', margin: '2rem' }} alt="..." />
            </td>
          </tr>}
      </React.Fragment>
    )
  }

  renderUpcoming() {
    const { t } = this.props;
    let { categOptions, currentCateg, currentEvent, nextOptions, nexts, onlyOneEvent } = this.state;
    if (!nexts || nexts.length === 0) {
      return (
        <div className="mainContainer">
          <Segment inverted>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', height: '50vh', width: '100%' }}>
              <h1>{t('noupcoming')}</h1>
            </div>
          </Segment>
        </div>
      )
    }
    return (
      <div className="mainContainer">
        {!onlyOneEvent && this.renderCalendar()}
        {!onlyOneEvent && this.renderEventSelect(nextOptions)}
        {this.renderAppPromo()}
        {this.renderCategSelect(categOptions)}
        {currentEvent && this.renderEventHeader()}
        {currentCateg && this.renderCategHeader()}
        {currentCateg && this.renderSearch()}
        {currentCateg && this.renderPhases()}
        {currentEvent && this.renderBracket()}
        {currentCateg && this.renderPhases()}
      </div>
    )
  }

  renderAppPromo() {
    const { t } = this.props;
    return (
      <Segment inverted textAlign='center' style={{ marginBottom: '1rem' }}>
        <p style={{ fontWeight: 'bold', marginBottom: '0.75rem' }}>{t('installApp')}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
          <a href='https://apps.apple.com/app/id6758780334' target='_blank' rel='noopener noreferrer'>
            {/* Badge App Store officiel (auto-hébergé) : hauteur 40px (référence) */}
            <img src={process.env.PUBLIC_URL + '/appstore-badge.svg'} alt='Download on the App Store' style={{ height: '40px', display: 'block' }} />
          </a>
          <a href='https://play.google.com/store/apps/details?id=com.allscoreslive.allscoreslive' target='_blank' rel='noopener noreferrer'>
            {/* Badge Google Play officiel (auto-hébergé) : ~59px pour compenser son padding interne et aligner visuellement sur les 40px du badge Apple */}
            <img src={process.env.PUBLIC_URL + '/googleplay-badge.png'} alt='Get it on Google Play' style={{ height: '59px', display: 'block' }} />
          </a>
        </div>
      </Segment>
    )
  }

  renderVideo(match) {
    const target = match.l && match.l.length > 1 ? match.l.charAt(1) : 0;
    return (
      <tr>
        <td colSpan={3} className="hall-table-cell">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {target === "Y" && <YouTubeEmbed url={match.v} width={"50%"} />}
            {target === "I" && <InstagramEmbed url={match.v} width={"50%"} />}
            {target === "T" && <TikTokEmbed url={match.v} width={"50%"} />}
            {target === "F" && <FacebookEmbed url={match.v} width={"50%"} />}
            {target === "X" && <XEmbed url={match.v} width={"50%"} />}
          </div>
        </td>
      </tr>
    )
  }

  renderWinner(match) {
    let { currentCateg, parms } = this.state;
    if (!parms) return null;
    if (!currentCateg || currentCateg.code !== match.c) return null;
    if (currentCateg.phases[match.p].nbQlfs > 1) return null;
    const mode = currentCateg.phases[match.p].mode;
    if (mode === "RR" || mode === "C1" || mode === "C2" || mode === "C3") return null;
    const teamMatch = currentCateg.type === "T";
    const isDouble = currentCateg.type === "D" || (teamMatch && (match.tm1.length === 2 || match.tm2.length === 2));
    if (isDouble) {
      return (
        <React.Fragment key={"C" + match.c + "P" + match.p + match.g + match.s + match.r}>
          {this.renderDoubleWinner(match, teamMatch)}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment key={"C" + match.c + "P" + match.p + match.g + match.s + match.r}>
          {this.renderSingleWinner(match)}
        </React.Fragment>
      );
    }
  }

  render() {
    const { i18n, t } = this.props;
    let { currentOrg, currentTab, currentTimezone, allRankings, onlyOneEvent, running } = this.state;
    if (running) {
      return (
        <div className="mainContainer">
          <Loader>{t('loading')}</Loader>
        </div>
      );
    }
    let nbMenus = allRankings && allRankings.length > 0 ? 4 : 3;
    return (
      <div className="App">
        <Segment inverted>
          <Grid doubling columns={2} style={{ flexWrap: 'unset' }}>
            <Grid.Column>
              <ReactLangSelect
                style={{ marginLeft: 'auto' }}
                languages={["GB", "FR", "MT", "PT", "US"]}
                defaultLanguage={i18n.language.toUpperCase()}
                showSelectedLabel={true}
                searchPlaceholder={t("langSearch")}
                onSelect={this.onChangeLanguage.bind(this)} />
              {/*<ReactTimezoneSelect
                style={{ marginLeft: 'auto' }}
                timezones={["GB", "FR", "MT", "PT", "US"]}
                defaultTimezone={currentTimezone}
                showSelectedLabel={true}
                searchPlaceholder={t("langSearch")}
    onSelect={this.onChangeLanguage.bind(this)} />*/}
              <p style={{ fontSize: '.7rem' }}>{currentTimezone}</p>
            </Grid.Column>
            <Grid.Column>
              <Image src={Global.localUrl + "admin/logos/" + currentOrg.logo} size='small' centered />
            </Grid.Column>
          </Grid>
        </Segment>
        <Segment inverted>
          <Menu inverted pointing secondary widths={nbMenus}>
            <Menu.Item
              name={t("live")}
              active={currentTab === 0}
              onClick={(e) => this.setCurrentTab(0)}
            />
            <Menu.Item
              name={onlyOneEvent ? t("draws") : t("upcoming")}
              active={currentTab === 1}
              onClick={(e) => this.setCurrentTab(1)}
            />
            {!onlyOneEvent && <Menu.Item
              name={t("archives")}
              active={currentTab === 2}
              onClick={(e) => this.setCurrentTab(2)}
            />}
            {!onlyOneEvent && allRankings && allRankings.length > 0 && <Menu.Item
              name={t("rankings")}
              active={currentTab === 3}
              onClick={(e) => this.setCurrentTab(3)}
            />}
          </Menu>
        </Segment>
        {currentTab === 0 && this.renderLive()}
        {currentTab === 1 && this.renderUpcoming()}
        {currentTab === 2 && this.renderArchives()}
        {currentTab === 3 && this.renderRankings()}
        {this.renderProfile()}
      </div>
    );
  }
}

export default withTranslation('common')(App);
